export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Byte: any;
  DateTime: any;
  DateTimeZone: any;
  Decimal: any;
  LocalDate: any;
  LocalDateTime: any;
  Uuid: any;
};

export type CorvalAccount = {
  businessFunctions?: Maybe<Array<Scalars['Uuid']>>;
  createdBy?: Maybe<CorvalAccount>;
  createdById?: Maybe<Scalars['Uuid']>;
  createdUtc: Scalars['DateTime'];
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['Uuid'];
  lastName: Scalars['String'];
  organizations?: Maybe<Array<Maybe<CorvalOrganizationAccount>>>;
  projects?: Maybe<Array<Maybe<CorvalProjectAccount>>>;
  projectTemplates: Array<CorvalProjectTemplate>;
  systemRole: CorvalSystemRole;
  updatedBy?: Maybe<CorvalAccount>;
  updatedById?: Maybe<Scalars['Uuid']>;
  updatedUtc: Scalars['DateTime'];
};

export type CorvalAccountBusinessFunctionFilterInput = {
  accountId?: Maybe<CorvalUuidOperationFilterInput>;
  and?: Maybe<Array<CorvalAccountBusinessFunctionFilterInput>>;
  businessFunctionId?: Maybe<CorvalUuidOperationFilterInput>;
  or?: Maybe<Array<CorvalAccountBusinessFunctionFilterInput>>;
};

export type CorvalAccountCreateCommandInput = {
  businessFunctionIds: Array<Scalars['Uuid']>;
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['Uuid'];
  lastName: Scalars['String'];
  organizations: Array<CorvalAccountCreateCommandOrganizationItemInput>;
  systemRole: CorvalSystemRole;
};

export type CorvalAccountCreateCommandOrganizationItemInput = {
  isActive: Scalars['Boolean'];
  organizationId: Scalars['Uuid'];
  organizationRole: CorvalOrganizationRole;
};

export type CorvalAccountFilterInput = {
  and?: Maybe<Array<CorvalAccountFilterInput>>;
  businessFunctions?: Maybe<CorvalListFilterInputTypeOfAccountBusinessFunctionFilterInput>;
  createdBy?: Maybe<CorvalAccountFilterInput>;
  createdById?: Maybe<CorvalUuidOperationFilterInput>;
  createdUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  emailAddress?: Maybe<CorvalStringOperationFilterInput>;
  firstName?: Maybe<CorvalStringOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  lastName?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalAccountFilterInput>>;
  organizations?: Maybe<CorvalListFilterInputTypeOfOrganizationAccountFilterInput>;
  projects?: Maybe<CorvalListFilterInputTypeOfProjectAccountFilterInput>;
  rowVersion?: Maybe<CorvalListByteOperationFilterInput>;
  systemRole?: Maybe<CorvalSystemRoleOperationFilterInput>;
  updatedBy?: Maybe<CorvalAccountFilterInput>;
  updatedById?: Maybe<CorvalUuidOperationFilterInput>;
  updatedUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
};

export type CorvalAccountSortInput = {
  createdBy?: Maybe<CorvalAccountSortInput>;
  createdById?: Maybe<CorvalSortEnumType>;
  createdUtc?: Maybe<CorvalSortEnumType>;
  emailAddress?: Maybe<CorvalSortEnumType>;
  firstName?: Maybe<CorvalSortEnumType>;
  id?: Maybe<CorvalSortEnumType>;
  lastName?: Maybe<CorvalSortEnumType>;
  systemRole?: Maybe<CorvalSortEnumType>;
  updatedBy?: Maybe<CorvalAccountSortInput>;
  updatedById?: Maybe<CorvalSortEnumType>;
  updatedUtc?: Maybe<CorvalSortEnumType>;
};

export type CorvalAccountUpdateCommandInput = {
  businessFunctionIds: Array<Scalars['Uuid']>;
  firstName: Scalars['String'];
  id: Scalars['Uuid'];
  lastName: Scalars['String'];
  organizations: Array<CorvalAccountUpdateCommandOrganizationItemInput>;
  systemRole: CorvalSystemRole;
};

export type CorvalAccountUpdateCommandOrganizationItemInput = {
  isActive: Scalars['Boolean'];
  organizationId: Scalars['Uuid'];
  organizationRole: CorvalOrganizationRole;
};

export type CorvalActivity = {
  budgetValueConditions?: Maybe<Array<Maybe<CorvalBudgetValueCondition>>>;
  businessFunction?: Maybe<CorvalBusinessFunction>;
  businessFunctionId: Scalars['Uuid'];
  category?: Maybe<CorvalCategory>;
  categoryId: Scalars['Uuid'];
  childActivities?: Maybe<Array<Maybe<CorvalActivityActivity>>>;
  completionMilestoneId?: Maybe<Scalars['Uuid']>;
  contextOwner: CorvalContextOwner;
  contextOwnerOrganization?: Maybe<CorvalOrganization>;
  contextOwnerOrganizationId?: Maybe<Scalars['Uuid']>;
  contextOwnerProject?: Maybe<CorvalProject>;
  contextOwnerProjectId?: Maybe<Scalars['Uuid']>;
  createdBy?: Maybe<CorvalAccount>;
  createdById?: Maybe<Scalars['Uuid']>;
  createdUtc: Scalars['DateTime'];
  defaultBudgetValue: Scalars['Decimal'];
  defaultCriticality: CorvalCriticality;
  defaultOngoingCostDurationQuarters: Scalars['Int'];
  defaultOngoingCostMax: Scalars['Decimal'];
  defaultOngoingCostMin: Scalars['Decimal'];
  defaultOperationalCost: Scalars['Decimal'];
  defaultTimeSpanUnit: CorvalTimeSpanUnit;
  defaultTimeSpanValue: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  duplicationQuestions?: Maybe<Array<Maybe<CorvalIntakeQuestion>>>;
  hasParentChildLoops: CorvalActivityDetectParentChildLoopsCommandResult;
  hires?: Maybe<Array<Maybe<CorvalActivityHire>>>;
  id: Scalars['Uuid'];
  isRequired: Scalars['Boolean'];
  milestoneId?: Maybe<Scalars['Uuid']>;
  name: Scalars['String'];
  parentActivities?: Maybe<Array<Maybe<CorvalActivityActivity>>>;
  perceivedAsContinuous: Scalars['Boolean'];
  professionalFees?: Maybe<Array<Maybe<CorvalActivityProfessionalFee>>>;
  projectTimingMilestoneOffsetMonths: Scalars['Int'];
  quickLinks?: Maybe<Array<Maybe<CorvalQuickLink>>>;
  refId?: Maybe<Scalars['String']>;
  refIdCode?: Maybe<Scalars['Int']>;
  subCategory?: Maybe<CorvalSubCategory>;
  subCategoryId: Scalars['Uuid'];
  tags?: Maybe<Array<Maybe<CorvalActivityTag>>>;
  timeSpanConditions?: Maybe<Array<Maybe<CorvalTimeSpanCondition>>>;
  triggeringSubObjectives?: Maybe<Array<Maybe<CorvalSubObjective>>>;
  updatedBy?: Maybe<CorvalAccount>;
  updatedById?: Maybe<Scalars['Uuid']>;
  updatedUtc: Scalars['DateTime'];
};


export type CorvalActivityHasParentChildLoopsArgs = {
  childActivityIds: Array<Scalars['Uuid']>;
  parentActivityIds: Array<Scalars['Uuid']>;
  tracePaths: Scalars['Boolean'];
};

export type CorvalActivityActivity = {
  childActivity?: Maybe<CorvalActivity>;
  childActivityId: Scalars['Uuid'];
  parentActivity?: Maybe<CorvalActivity>;
  parentActivityId: Scalars['Uuid'];
  parentCompletionRequired: Scalars['Boolean'];
  parentSchedulingEnforced: Scalars['Boolean'];
};

export type CorvalActivityActivityFilterInput = {
  and?: Maybe<Array<CorvalActivityActivityFilterInput>>;
  childActivity?: Maybe<CorvalActivityFilterInput>;
  childActivityId?: Maybe<CorvalUuidOperationFilterInput>;
  or?: Maybe<Array<CorvalActivityActivityFilterInput>>;
  parentActivity?: Maybe<CorvalActivityFilterInput>;
  parentActivityId?: Maybe<CorvalUuidOperationFilterInput>;
  parentCompletionRequired?: Maybe<CorvalBooleanOperationFilterInput>;
  parentSchedulingEnforced?: Maybe<CorvalBooleanOperationFilterInput>;
};

export type CorvalActivityCategoriesQueryInput = {
  topLevelCategory?: Maybe<Scalars['Uuid']>;
};

export type CorvalActivityCreateBudgetValueConditionCreateItemInput = {
  answerValue: Scalars['String'];
  budgetValue: Scalars['Decimal'];
  conditionType: CorvalConditionTypeEnum;
  id: Scalars['Uuid'];
  targetIntakeQuestionId: Scalars['Uuid'];
};

export type CorvalActivityCreateCommandInput = {
  budgetValueConditions: Array<CorvalActivityCreateBudgetValueConditionCreateItemInput>;
  businessFunctionId: Scalars['Uuid'];
  childActivities: Array<CorvalActivityCreateRelationshipItemInput>;
  completionMilestoneId?: Maybe<Scalars['Uuid']>;
  defaultBudgetValue: Scalars['Decimal'];
  defaultCriticality: CorvalCriticality;
  defaultOngoingCostDurationQuarters: Scalars['Int'];
  defaultOngoingCostMax: Scalars['Decimal'];
  defaultOngoingCostMin: Scalars['Decimal'];
  defaultOperationalCost: Scalars['Decimal'];
  defaultTimeSpanUnit: CorvalTimeSpanUnit;
  defaultTimeSpanValue: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  duplicationQuestionIds: Array<Scalars['Uuid']>;
  hires: Array<CorvalActivityCreateHireCreateItemInput>;
  id: Scalars['Uuid'];
  isRequired: Scalars['Boolean'];
  milestoneId?: Maybe<Scalars['Uuid']>;
  name: Scalars['String'];
  parentActivities: Array<CorvalActivityCreateRelationshipItemInput>;
  perceivedAsContinuous: Scalars['Boolean'];
  professionalFees: Array<Scalars['Uuid']>;
  projectTimingMilestoneOffsetMonths: Scalars['Int'];
  refIdCode?: Maybe<Scalars['Int']>;
  subCategoryId: Scalars['Uuid'];
  tags: Array<Scalars['String']>;
  timeSpanConditions: Array<CorvalActivityCreateTimeSpanConditionCreateItemInput>;
  triggeringSubObjectiveIds: Array<Scalars['Uuid']>;
};

export type CorvalActivityCreateHireCreateItemInput = {
  headcount: Scalars['Int'];
  hireTypeId: Scalars['Uuid'];
  isHiringPoint: Scalars['Boolean'];
};

export type CorvalActivityCreateRelationshipItemInput = {
  activityId: Scalars['Uuid'];
  parentCompletionRequired: Scalars['Boolean'];
  parentSchedulingEnforced: Scalars['Boolean'];
};

export type CorvalActivityCreateTimeSpanConditionCreateItemInput = {
  answerValue: Scalars['String'];
  conditionType: CorvalConditionTypeEnum;
  id: Scalars['Uuid'];
  targetIntakeQuestionId: Scalars['Uuid'];
  timeSpanUnit: CorvalTimeSpanUnit;
  timeSpanValue: Scalars['Int'];
};

export type CorvalActivityDeleteCommandInput = {
  id: Scalars['Uuid'];
  remappedRelationships: Array<CorvalActivityDeleteRemappedRelationshipItemInput>;
};

export type CorvalActivityDeleteRemappedRelationshipItemInput = {
  childActivityId: Scalars['Uuid'];
  targetParentId?: Maybe<Scalars['Uuid']>;
};

export type CorvalActivityDetectParentChildLoopsCommandResult = {
  loopsDetected: Scalars['Boolean'];
  paths: Array<Array<CorvalActivityStep>>;
};

export type CorvalActivityFilterInput = {
  and?: Maybe<Array<CorvalActivityFilterInput>>;
  budgetValueConditions?: Maybe<CorvalListFilterInputTypeOfBudgetValueConditionFilterInput>;
  businessFunctionId?: Maybe<CorvalUuidOperationFilterInput>;
  childActivities?: Maybe<CorvalListFilterInputTypeOfActivityActivityFilterInput>;
  completionMilestoneId?: Maybe<CorvalUuidOperationFilterInput>;
  contextOwner?: Maybe<CorvalContextOwnerOperationFilterInput>;
  contextOwnerOrganization?: Maybe<CorvalOrganizationFilterInput>;
  contextOwnerOrganizationId?: Maybe<CorvalUuidOperationFilterInput>;
  contextOwnerProject?: Maybe<CorvalProjectFilterInput>;
  contextOwnerProjectId?: Maybe<CorvalUuidOperationFilterInput>;
  createdBy?: Maybe<CorvalAccountFilterInput>;
  createdById?: Maybe<CorvalUuidOperationFilterInput>;
  createdUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  defaultBudgetValue?: Maybe<CorvalDecimalOperationFilterInput>;
  defaultCriticality?: Maybe<CorvalCriticalityOperationFilterInput>;
  defaultOngoingCostDurationQuarters?: Maybe<CorvalIntOperationFilterInput>;
  defaultOngoingCostMax?: Maybe<CorvalDecimalOperationFilterInput>;
  defaultOngoingCostMin?: Maybe<CorvalDecimalOperationFilterInput>;
  defaultOperationalCost?: Maybe<CorvalDecimalOperationFilterInput>;
  defaultTimeSpanUnit?: Maybe<CorvalTimeSpanUnitOperationFilterInput>;
  defaultTimeSpanValue?: Maybe<CorvalIntOperationFilterInput>;
  description?: Maybe<CorvalStringOperationFilterInput>;
  displayName?: Maybe<CorvalStringOperationFilterInput>;
  duplicationQuestions?: Maybe<CorvalListFilterInputTypeOfActivityIntakeQuestionFilterInput>;
  hires?: Maybe<CorvalListFilterInputTypeOfActivityHireFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  isRequired?: Maybe<CorvalBooleanOperationFilterInput>;
  milestoneId?: Maybe<CorvalUuidOperationFilterInput>;
  name?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalActivityFilterInput>>;
  parentActivities?: Maybe<CorvalListFilterInputTypeOfActivityActivityFilterInput>;
  perceivedAsContinuous?: Maybe<CorvalBooleanOperationFilterInput>;
  professionalFees?: Maybe<CorvalListFilterInputTypeOfActivityProfessionalFeeFilterInput>;
  projectTimingMilestoneOffsetMonths?: Maybe<CorvalIntOperationFilterInput>;
  quickLinks?: Maybe<CorvalListFilterInputTypeOfQuickLinkFilterInput>;
  refIdCode?: Maybe<CorvalIntOperationFilterInput>;
  rowVersion?: Maybe<CorvalListByteOperationFilterInput>;
  subCategory?: Maybe<CorvalSubCategoryFilterInput>;
  subCategoryId?: Maybe<CorvalUuidOperationFilterInput>;
  tags?: Maybe<CorvalListFilterInputTypeOfActivityTagFilterInput>;
  timeSpanConditions?: Maybe<CorvalListFilterInputTypeOfTimeSpanConditionFilterInput>;
  triggeringSubObjectives?: Maybe<CorvalListFilterInputTypeOfActivitySubObjectiveFilterInput>;
  updatedBy?: Maybe<CorvalAccountFilterInput>;
  updatedById?: Maybe<CorvalUuidOperationFilterInput>;
  updatedUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
};

export type CorvalActivityHire = {
  activity?: Maybe<CorvalActivity>;
  activityId: Scalars['Uuid'];
  headcount: Scalars['Int'];
  hireType?: Maybe<CorvalHireType>;
  hireTypeId: Scalars['Uuid'];
  isHiringPoint: Scalars['Boolean'];
};

export type CorvalActivityHireFilterInput = {
  activity?: Maybe<CorvalActivityFilterInput>;
  activityId?: Maybe<CorvalUuidOperationFilterInput>;
  and?: Maybe<Array<CorvalActivityHireFilterInput>>;
  headcount?: Maybe<CorvalIntOperationFilterInput>;
  hireType?: Maybe<CorvalHireTypeFilterInput>;
  hireTypeId?: Maybe<CorvalUuidOperationFilterInput>;
  isHiringPoint?: Maybe<CorvalBooleanOperationFilterInput>;
  or?: Maybe<Array<CorvalActivityHireFilterInput>>;
};

export type CorvalActivityIntakeQuestion = {
  activity?: Maybe<CorvalActivity>;
  activityId: Scalars['Uuid'];
  intakeQuestion?: Maybe<CorvalIntakeQuestion>;
  intakeQuestionId: Scalars['Uuid'];
};

export type CorvalActivityIntakeQuestionFilterInput = {
  activity?: Maybe<CorvalActivityFilterInput>;
  activityId?: Maybe<CorvalUuidOperationFilterInput>;
  and?: Maybe<Array<CorvalActivityIntakeQuestionFilterInput>>;
  intakeQuestion?: Maybe<CorvalIntakeQuestionFilterInput>;
  intakeQuestionId?: Maybe<CorvalUuidOperationFilterInput>;
  or?: Maybe<Array<CorvalActivityIntakeQuestionFilterInput>>;
};

export type CorvalActivityProfessionalFee = {
  activity?: Maybe<CorvalActivity>;
  activityId: Scalars['Uuid'];
  professionalFee?: Maybe<CorvalProfessionalFee>;
  professionalFeeId: Scalars['Uuid'];
};

export type CorvalActivityProfessionalFeeFilterInput = {
  activity?: Maybe<CorvalActivityFilterInput>;
  activityId?: Maybe<CorvalUuidOperationFilterInput>;
  and?: Maybe<Array<CorvalActivityProfessionalFeeFilterInput>>;
  or?: Maybe<Array<CorvalActivityProfessionalFeeFilterInput>>;
  professionalFee?: Maybe<CorvalProfessionalFeeFilterInput>;
  professionalFeeId?: Maybe<CorvalUuidOperationFilterInput>;
};

export type CorvalActivitySortInput = {
  businessFunctionId?: Maybe<CorvalSortEnumType>;
  completionMilestoneId?: Maybe<CorvalSortEnumType>;
  contextOwner?: Maybe<CorvalSortEnumType>;
  contextOwnerOrganization?: Maybe<CorvalOrganizationSortInput>;
  contextOwnerOrganizationId?: Maybe<CorvalSortEnumType>;
  contextOwnerProject?: Maybe<CorvalProjectSortInput>;
  contextOwnerProjectId?: Maybe<CorvalSortEnumType>;
  createdBy?: Maybe<CorvalAccountSortInput>;
  createdById?: Maybe<CorvalSortEnumType>;
  createdUtc?: Maybe<CorvalSortEnumType>;
  defaultBudgetValue?: Maybe<CorvalSortEnumType>;
  defaultCriticality?: Maybe<CorvalSortEnumType>;
  defaultOngoingCostDurationQuarters?: Maybe<CorvalSortEnumType>;
  defaultOngoingCostMax?: Maybe<CorvalSortEnumType>;
  defaultOngoingCostMin?: Maybe<CorvalSortEnumType>;
  defaultOperationalCost?: Maybe<CorvalSortEnumType>;
  defaultTimeSpanUnit?: Maybe<CorvalSortEnumType>;
  defaultTimeSpanValue?: Maybe<CorvalSortEnumType>;
  description?: Maybe<CorvalSortEnumType>;
  displayName?: Maybe<CorvalSortEnumType>;
  id?: Maybe<CorvalSortEnumType>;
  isRequired?: Maybe<CorvalSortEnumType>;
  milestoneId?: Maybe<CorvalSortEnumType>;
  name?: Maybe<CorvalSortEnumType>;
  perceivedAsContinuous?: Maybe<CorvalSortEnumType>;
  projectTimingMilestoneOffsetMonths?: Maybe<CorvalSortEnumType>;
  refIdCode?: Maybe<CorvalSortEnumType>;
  subCategory?: Maybe<CorvalSubCategorySortInput>;
  subCategoryId?: Maybe<CorvalSortEnumType>;
  updatedBy?: Maybe<CorvalAccountSortInput>;
  updatedById?: Maybe<CorvalSortEnumType>;
  updatedUtc?: Maybe<CorvalSortEnumType>;
};

export type CorvalActivityStep = {
  activityId: Scalars['Uuid'];
  step: Scalars['Int'];
};

export type CorvalActivitySubObjective = {
  activity?: Maybe<CorvalActivity>;
  activityId: Scalars['Uuid'];
  subObjective?: Maybe<CorvalSubObjective>;
  subObjectiveId: Scalars['Uuid'];
};

export type CorvalActivitySubObjectiveFilterInput = {
  activity?: Maybe<CorvalActivityFilterInput>;
  activityId?: Maybe<CorvalUuidOperationFilterInput>;
  and?: Maybe<Array<CorvalActivitySubObjectiveFilterInput>>;
  or?: Maybe<Array<CorvalActivitySubObjectiveFilterInput>>;
  subObjective?: Maybe<CorvalSubObjectiveFilterInput>;
  subObjectiveId?: Maybe<CorvalUuidOperationFilterInput>;
};

export type CorvalActivityTag = {
  activity?: Maybe<CorvalAccount>;
  activityId: Scalars['Uuid'];
  tag?: Maybe<CorvalTag>;
  tagName: Scalars['String'];
};

export type CorvalActivityTagFilterInput = {
  activity?: Maybe<CorvalActivityFilterInput>;
  activityId?: Maybe<CorvalUuidOperationFilterInput>;
  and?: Maybe<Array<CorvalActivityTagFilterInput>>;
  or?: Maybe<Array<CorvalActivityTagFilterInput>>;
  tag?: Maybe<CorvalTagFilterInput>;
  tagName?: Maybe<CorvalStringOperationFilterInput>;
};

export type CorvalActivityUpdateBudgetValueConditionItemInput = {
  answerValue: Scalars['String'];
  budgetValue: Scalars['Decimal'];
  conditionType: CorvalConditionTypeEnum;
  id: Scalars['Uuid'];
  targetIntakeQuestionId: Scalars['Uuid'];
};

export type CorvalActivityUpdateCommandInput = {
  budgetValueConditions: Array<CorvalActivityUpdateBudgetValueConditionItemInput>;
  businessFunctionId: Scalars['Uuid'];
  childActivities: Array<CorvalActivityUpdateRelationshipItemInput>;
  completionMilestoneId?: Maybe<Scalars['Uuid']>;
  defaultBudgetValue: Scalars['Decimal'];
  defaultCriticality: CorvalCriticality;
  defaultOngoingCostDurationQuarters: Scalars['Int'];
  defaultOngoingCostMax: Scalars['Decimal'];
  defaultOngoingCostMin: Scalars['Decimal'];
  defaultOperationalCost: Scalars['Decimal'];
  defaultTimeSpanUnit: CorvalTimeSpanUnit;
  defaultTimeSpanValue: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  duplicationQuestionIds: Array<Scalars['Uuid']>;
  hires: Array<CorvalActivityUpdateHireUpdateItemInput>;
  id: Scalars['Uuid'];
  isRequired: Scalars['Boolean'];
  milestoneId?: Maybe<Scalars['Uuid']>;
  name: Scalars['String'];
  parentActivities: Array<CorvalActivityUpdateRelationshipItemInput>;
  perceivedAsContinuous: Scalars['Boolean'];
  professionalFees: Array<Scalars['Uuid']>;
  projectTimingMilestoneOffsetMonths: Scalars['Int'];
  refIdCode?: Maybe<Scalars['Int']>;
  subCategoryId: Scalars['Uuid'];
  tags: Array<Scalars['String']>;
  timeSpanConditions: Array<CorvalActivityUpdateTimeSpanConditionItemInput>;
  triggeringSubObjectiveIds: Array<Scalars['Uuid']>;
};

export type CorvalActivityUpdateHireUpdateItemInput = {
  headcount: Scalars['Int'];
  hireTypeId: Scalars['Uuid'];
  isHiringPoint: Scalars['Boolean'];
};

export type CorvalActivityUpdateRelationshipItemInput = {
  activityId: Scalars['Uuid'];
  parentCompletionRequired: Scalars['Boolean'];
  parentSchedulingEnforced: Scalars['Boolean'];
};

export type CorvalActivityUpdateTimeSpanConditionItemInput = {
  answerValue: Scalars['String'];
  conditionType: CorvalConditionTypeEnum;
  id: Scalars['Uuid'];
  targetIntakeQuestionId: Scalars['Uuid'];
  timeSpanUnit: CorvalTimeSpanUnit;
  timeSpanValue: Scalars['Int'];
};

export type CorvalAddActivityItemInput = {
  businessFunctionId: Scalars['Uuid'];
  constraintDate?: Maybe<Scalars['LocalDate']>;
  constraintType?: Maybe<CorvalConstraintType>;
  criticality: CorvalCriticality;
  deadlineDate?: Maybe<Scalars['LocalDate']>;
  description: Scalars['String'];
  endDate: Scalars['LocalDate'];
  id: Scalars['Uuid'];
  isAtRisk: Scalars['Boolean'];
  manuallyScheduled: Scalars['Boolean'];
  name: Scalars['String'];
  notes: Scalars['String'];
  ongoingCostNote: Scalars['String'];
  ongoingCostPerQuarter: Scalars['Int'];
  ongoingCostQuarters: Scalars['Int'];
  operationalCost: Scalars['Int'];
  operationalCostNote: Scalars['String'];
  operationalCostReplacesProfessionalFees: Scalars['Boolean'];
  percentDone: Scalars['Int'];
  requiredHireTypes: Array<CorvalRequiredHireTypeItemInput>;
  scheduledBudgetItems: Array<CorvalScheduledBudgetItemInput>;
  startDate: Scalars['LocalDate'];
  subCategoryId: Scalars['Uuid'];
  subObjectiveId: Scalars['Uuid'];
};

export type CorvalAddCategoryItemInput = {
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['Uuid'];
  name: Scalars['String'];
  ordinal: Scalars['Int'];
};

export type CorvalAddDependencyItemInput = {
  active: Scalars['Boolean'];
  from: Scalars['Uuid'];
  id: Scalars['Uuid'];
  lag: Scalars['Int'];
  lagUnit: Scalars['String'];
  to: Scalars['Uuid'];
  type: Scalars['Int'];
};

export type CorvalAddEventItemInput = {
  colorValue: Scalars['String'];
  description: Scalars['String'];
  iconName: Scalars['String'];
  id: Scalars['Uuid'];
  milestoneId?: Maybe<Scalars['Uuid']>;
  name: Scalars['String'];
  startDate: Scalars['LocalDate'];
};

export type CorvalAddSubCategoryItemInput = {
  categoryId: Scalars['Uuid'];
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['Uuid'];
  name: Scalars['String'];
  ordinal: Scalars['Int'];
};

export type CorvalAddSubObjectiveItemInput = {
  businessFunctionId: Scalars['Uuid'];
  description: Scalars['String'];
  id: Scalars['Uuid'];
  name: Scalars['String'];
  subCategoryId: Scalars['Uuid'];
};

export enum CorvalApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER',
  Validation = 'VALIDATION'
}

export type CorvalAsset = {
  id: Scalars['Uuid'];
  indication: Scalars['String'];
  name: Scalars['String'];
  organization?: Maybe<CorvalOrganization>;
  organizationId: Scalars['Uuid'];
  projects?: Maybe<Array<Maybe<CorvalProject>>>;
};

export type CorvalAssetFilterInput = {
  and?: Maybe<Array<CorvalAssetFilterInput>>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  indication?: Maybe<CorvalStringOperationFilterInput>;
  name?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalAssetFilterInput>>;
  organization?: Maybe<CorvalOrganizationFilterInput>;
  organizationId?: Maybe<CorvalUuidOperationFilterInput>;
  projects?: Maybe<CorvalListFilterInputTypeOfProjectFilterInput>;
};

export type CorvalAssetSortInput = {
  id?: Maybe<CorvalSortEnumType>;
  indication?: Maybe<CorvalSortEnumType>;
  name?: Maybe<CorvalSortEnumType>;
  organization?: Maybe<CorvalOrganizationSortInput>;
  organizationId?: Maybe<CorvalSortEnumType>;
};

export type CorvalAssumption = {
  answerValue: Scalars['String'];
  createdBy?: Maybe<CorvalAccount>;
  createdById?: Maybe<Scalars['Uuid']>;
  createdUtc: Scalars['DateTime'];
  intakeQuestion?: Maybe<CorvalIntakeQuestion>;
  intakeQuestionId: Scalars['Uuid'];
  project?: Maybe<CorvalProject>;
  projectId: Scalars['Uuid'];
  updatedBy?: Maybe<CorvalAccount>;
  updatedById?: Maybe<Scalars['Uuid']>;
  updatedUtc: Scalars['DateTime'];
};

export type CorvalAssumptionFilterInput = {
  and?: Maybe<Array<CorvalAssumptionFilterInput>>;
  answerValue?: Maybe<CorvalStringOperationFilterInput>;
  createdBy?: Maybe<CorvalAccountFilterInput>;
  createdById?: Maybe<CorvalUuidOperationFilterInput>;
  createdUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  intakeQuestion?: Maybe<CorvalIntakeQuestionFilterInput>;
  intakeQuestionId?: Maybe<CorvalUuidOperationFilterInput>;
  or?: Maybe<Array<CorvalAssumptionFilterInput>>;
  project?: Maybe<CorvalProjectFilterInput>;
  projectId?: Maybe<CorvalUuidOperationFilterInput>;
  rowVersion?: Maybe<CorvalListByteOperationFilterInput>;
  updatedBy?: Maybe<CorvalAccountFilterInput>;
  updatedById?: Maybe<CorvalUuidOperationFilterInput>;
  updatedUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
};

export type CorvalAssumptionGroup = {
  assumptionGroupIntakeQuestions?: Maybe<Array<Maybe<CorvalAssumptionGroupIntakeQuestion>>>;
  createdBy?: Maybe<CorvalAccount>;
  createdById?: Maybe<Scalars['Uuid']>;
  createdUtc: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['Uuid'];
  name: Scalars['String'];
  ordinal: Scalars['Int'];
  updatedBy?: Maybe<CorvalAccount>;
  updatedById?: Maybe<Scalars['Uuid']>;
  updatedUtc: Scalars['DateTime'];
};

export type CorvalAssumptionGroupCreateCommandInput = {
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['Uuid'];
  intakeQuestionIds: Array<Scalars['Uuid']>;
  name: Scalars['String'];
  ordinal: Scalars['Int'];
};

export type CorvalAssumptionGroupDeleteCommandInput = {
  id: Scalars['Uuid'];
};

export type CorvalAssumptionGroupFilterInput = {
  and?: Maybe<Array<CorvalAssumptionGroupFilterInput>>;
  assumptionGroupIntakeQuestions?: Maybe<CorvalListFilterInputTypeOfAssumptionGroupIntakeQuestionFilterInput>;
  createdBy?: Maybe<CorvalAccountFilterInput>;
  createdById?: Maybe<CorvalUuidOperationFilterInput>;
  createdUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  description?: Maybe<CorvalStringOperationFilterInput>;
  displayName?: Maybe<CorvalStringOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  name?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalAssumptionGroupFilterInput>>;
  ordinal?: Maybe<CorvalIntOperationFilterInput>;
  rowVersion?: Maybe<CorvalListByteOperationFilterInput>;
  updatedBy?: Maybe<CorvalAccountFilterInput>;
  updatedById?: Maybe<CorvalUuidOperationFilterInput>;
  updatedUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
};

export type CorvalAssumptionGroupIntakeQuestion = {
  assumptionGroup?: Maybe<CorvalAssumptionGroup>;
  assumptionGroupId: Scalars['Uuid'];
  intakeQuestion?: Maybe<CorvalIntakeQuestion>;
  intakeQuestionId: Scalars['Uuid'];
  ordinal: Scalars['Int'];
};

export type CorvalAssumptionGroupIntakeQuestionFilterInput = {
  and?: Maybe<Array<CorvalAssumptionGroupIntakeQuestionFilterInput>>;
  assumptionGroup?: Maybe<CorvalAssumptionGroupFilterInput>;
  assumptionGroupId?: Maybe<CorvalUuidOperationFilterInput>;
  intakeQuestion?: Maybe<CorvalIntakeQuestionFilterInput>;
  intakeQuestionId?: Maybe<CorvalUuidOperationFilterInput>;
  or?: Maybe<Array<CorvalAssumptionGroupIntakeQuestionFilterInput>>;
  ordinal?: Maybe<CorvalIntOperationFilterInput>;
};

export type CorvalAssumptionGroupSortInput = {
  createdBy?: Maybe<CorvalAccountSortInput>;
  createdById?: Maybe<CorvalSortEnumType>;
  createdUtc?: Maybe<CorvalSortEnumType>;
  description?: Maybe<CorvalSortEnumType>;
  displayName?: Maybe<CorvalSortEnumType>;
  id?: Maybe<CorvalSortEnumType>;
  name?: Maybe<CorvalSortEnumType>;
  ordinal?: Maybe<CorvalSortEnumType>;
  updatedBy?: Maybe<CorvalAccountSortInput>;
  updatedById?: Maybe<CorvalSortEnumType>;
  updatedUtc?: Maybe<CorvalSortEnumType>;
};

export type CorvalAssumptionGroupUpdateCommandInput = {
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['Uuid'];
  intakeQuestionIds: Array<Scalars['Uuid']>;
  name: Scalars['String'];
  ordinal: Scalars['Int'];
};

export type CorvalAssumptionGroupUpdateOrdinalsCommandInput = {
  ordinals: Array<CorvalAssumptionGroupUpdateOrdinalsItemInput>;
};

export type CorvalAssumptionGroupUpdateOrdinalsItemInput = {
  assumptionGroupId: Scalars['Uuid'];
  ordinal: Scalars['Int'];
};

export type CorvalAssumptionSaveCommandInput = {
  answerValue: Scalars['String'];
  intakeQuestionId: Scalars['Uuid'];
  projectId: Scalars['Uuid'];
};

export type CorvalAssumptionSortInput = {
  answerValue?: Maybe<CorvalSortEnumType>;
  createdBy?: Maybe<CorvalAccountSortInput>;
  createdById?: Maybe<CorvalSortEnumType>;
  createdUtc?: Maybe<CorvalSortEnumType>;
  intakeQuestion?: Maybe<CorvalIntakeQuestionSortInput>;
  intakeQuestionId?: Maybe<CorvalSortEnumType>;
  project?: Maybe<CorvalProjectSortInput>;
  projectId?: Maybe<CorvalSortEnumType>;
  updatedBy?: Maybe<CorvalAccountSortInput>;
  updatedById?: Maybe<CorvalSortEnumType>;
  updatedUtc?: Maybe<CorvalSortEnumType>;
};

export type CorvalAuditEntry = {
  accountId?: Maybe<Scalars['Uuid']>;
  auditData: Scalars['String'];
  auditType: Scalars['String'];
  entityId: Scalars['Uuid'];
  entityLabel: Scalars['String'];
  entityType: Scalars['String'];
  id: Scalars['Uuid'];
  timestampUtc: Scalars['DateTime'];
};

export type CorvalAuditEntryFilterInput = {
  accountId?: Maybe<CorvalUuidOperationFilterInput>;
  and?: Maybe<Array<CorvalAuditEntryFilterInput>>;
  auditData?: Maybe<CorvalStringOperationFilterInput>;
  auditType?: Maybe<CorvalStringOperationFilterInput>;
  entityId?: Maybe<CorvalUuidOperationFilterInput>;
  entityLabel?: Maybe<CorvalStringOperationFilterInput>;
  entityType?: Maybe<CorvalStringOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  or?: Maybe<Array<CorvalAuditEntryFilterInput>>;
  timestampUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
};

export type CorvalAuditEntrySortInput = {
  accountId?: Maybe<CorvalSortEnumType>;
  auditData?: Maybe<CorvalSortEnumType>;
  auditType?: Maybe<CorvalSortEnumType>;
  entityId?: Maybe<CorvalSortEnumType>;
  entityLabel?: Maybe<CorvalSortEnumType>;
  entityType?: Maybe<CorvalSortEnumType>;
  id?: Maybe<CorvalSortEnumType>;
  timestampUtc?: Maybe<CorvalSortEnumType>;
};

export type CorvalBooleanOperationFilterInput = {
  eq?: Maybe<Scalars['Boolean']>;
  neq?: Maybe<Scalars['Boolean']>;
};

export type CorvalBudgetValueCondition = {
  activity?: Maybe<CorvalActivity>;
  activityId: Scalars['Uuid'];
  answerValue: Scalars['String'];
  budgetValue: Scalars['Decimal'];
  conditionType: CorvalConditionTypeEnum;
  id: Scalars['Uuid'];
  targetIntakeQuestion?: Maybe<CorvalIntakeQuestion>;
  targetIntakeQuestionId: Scalars['Uuid'];
};

export type CorvalBudgetValueConditionFilterInput = {
  activity?: Maybe<CorvalActivityFilterInput>;
  activityId?: Maybe<CorvalUuidOperationFilterInput>;
  and?: Maybe<Array<CorvalBudgetValueConditionFilterInput>>;
  answerValue?: Maybe<CorvalStringOperationFilterInput>;
  budgetValue?: Maybe<CorvalDecimalOperationFilterInput>;
  conditionType?: Maybe<CorvalConditionTypeEnumOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  or?: Maybe<Array<CorvalBudgetValueConditionFilterInput>>;
  targetIntakeQuestion?: Maybe<CorvalIntakeQuestionFilterInput>;
  targetIntakeQuestionId?: Maybe<CorvalUuidOperationFilterInput>;
};

export type CorvalBusinessFunction = {
  colorValue: Scalars['String'];
  contextOwner: CorvalContextOwner;
  contextOwnerOrganization?: Maybe<CorvalOrganization>;
  contextOwnerOrganizationId?: Maybe<Scalars['Uuid']>;
  contextOwnerProject?: Maybe<CorvalProject>;
  contextOwnerProjectId?: Maybe<Scalars['Uuid']>;
  description: Scalars['String'];
  iconName: Scalars['String'];
  id: Scalars['Uuid'];
  isArchived: Scalars['Boolean'];
  name: Scalars['String'];
  refIdCode: Scalars['Int'];
  resourceCode: Scalars['String'];
};

export type CorvalBusinessFunctionCreateCommandInput = {
  colorValue: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  iconName: Scalars['String'];
  id: Scalars['Uuid'];
  isArchived: Scalars['Boolean'];
  name: Scalars['String'];
  refIdCode: Scalars['Int'];
  resourceCode: Scalars['String'];
};

export type CorvalBusinessFunctionFilterInput = {
  and?: Maybe<Array<CorvalBusinessFunctionFilterInput>>;
  colorValue?: Maybe<CorvalStringOperationFilterInput>;
  contextOwner?: Maybe<CorvalContextOwnerOperationFilterInput>;
  contextOwnerOrganization?: Maybe<CorvalOrganizationFilterInput>;
  contextOwnerOrganizationId?: Maybe<CorvalUuidOperationFilterInput>;
  contextOwnerProject?: Maybe<CorvalProjectFilterInput>;
  contextOwnerProjectId?: Maybe<CorvalUuidOperationFilterInput>;
  description?: Maybe<CorvalStringOperationFilterInput>;
  iconName?: Maybe<CorvalStringOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  isArchived?: Maybe<CorvalBooleanOperationFilterInput>;
  name?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalBusinessFunctionFilterInput>>;
  refIdCode?: Maybe<CorvalIntOperationFilterInput>;
  resourceCode?: Maybe<CorvalStringOperationFilterInput>;
};

export type CorvalBusinessFunctionSortInput = {
  colorValue?: Maybe<CorvalSortEnumType>;
  contextOwner?: Maybe<CorvalSortEnumType>;
  contextOwnerOrganization?: Maybe<CorvalOrganizationSortInput>;
  contextOwnerOrganizationId?: Maybe<CorvalSortEnumType>;
  contextOwnerProject?: Maybe<CorvalProjectSortInput>;
  contextOwnerProjectId?: Maybe<CorvalSortEnumType>;
  description?: Maybe<CorvalSortEnumType>;
  iconName?: Maybe<CorvalSortEnumType>;
  id?: Maybe<CorvalSortEnumType>;
  isArchived?: Maybe<CorvalSortEnumType>;
  name?: Maybe<CorvalSortEnumType>;
  refIdCode?: Maybe<CorvalSortEnumType>;
  resourceCode?: Maybe<CorvalSortEnumType>;
};

export type CorvalBusinessFunctionUpdateCommandInput = {
  colorValue: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  iconName: Scalars['String'];
  id: Scalars['Uuid'];
  isArchived: Scalars['Boolean'];
  name: Scalars['String'];
  refIdCode: Scalars['Int'];
  resourceCode: Scalars['String'];
};


export type CorvalByteOperationFilterInput = {
  eq?: Maybe<Scalars['Byte']>;
  gt?: Maybe<Scalars['Byte']>;
  gte?: Maybe<Scalars['Byte']>;
  in?: Maybe<Array<Maybe<Scalars['Byte']>>>;
  lt?: Maybe<Scalars['Byte']>;
  lte?: Maybe<Scalars['Byte']>;
  neq?: Maybe<Scalars['Byte']>;
  ngt?: Maybe<Scalars['Byte']>;
  ngte?: Maybe<Scalars['Byte']>;
  nin?: Maybe<Array<Maybe<Scalars['Byte']>>>;
  nlt?: Maybe<Scalars['Byte']>;
  nlte?: Maybe<Scalars['Byte']>;
};

export type CorvalCalendarSystemFilterInput = {
  and?: Maybe<Array<CorvalCalendarSystemFilterInput>>;
  eras?: Maybe<CorvalListFilterInputTypeOfEraFilterInput>;
  id?: Maybe<CorvalStringOperationFilterInput>;
  maxYear?: Maybe<CorvalIntOperationFilterInput>;
  minYear?: Maybe<CorvalIntOperationFilterInput>;
  name?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalCalendarSystemFilterInput>>;
};

export type CorvalCategory = {
  contextOwner: CorvalContextOwner;
  contextOwnerOrganization?: Maybe<CorvalOrganization>;
  contextOwnerOrganizationId?: Maybe<Scalars['Uuid']>;
  contextOwnerProject?: Maybe<CorvalProject>;
  contextOwnerProjectId?: Maybe<Scalars['Uuid']>;
  createdBy?: Maybe<CorvalAccount>;
  createdById?: Maybe<Scalars['Uuid']>;
  createdUtc: Scalars['DateTime'];
  description: Scalars['String'];
  displayName: Scalars['String'];
  id: Scalars['Uuid'];
  name: Scalars['String'];
  ordinal: Scalars['Int'];
  refId?: Maybe<Scalars['String']>;
  refIdCode?: Maybe<Scalars['Int']>;
  rowVersion?: Maybe<Array<Scalars['Byte']>>;
  subCategories?: Maybe<Array<Maybe<CorvalSubCategory>>>;
  updatedBy?: Maybe<CorvalAccount>;
  updatedById?: Maybe<Scalars['Uuid']>;
  updatedUtc: Scalars['DateTime'];
};


export type CorvalCategoryDescriptionArgs = {
  projectVersionId?: Maybe<Scalars['Uuid']>;
};


export type CorvalCategoryDisplayNameArgs = {
  projectVersionId?: Maybe<Scalars['Uuid']>;
};


export type CorvalCategoryNameArgs = {
  projectVersionId?: Maybe<Scalars['Uuid']>;
};


export type CorvalCategoryOrdinalArgs = {
  projectVersionId?: Maybe<Scalars['Uuid']>;
};

export type CorvalCategoryCreateCommandInput = {
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['Uuid'];
  name: Scalars['String'];
  ordinal: Scalars['Int'];
  refIdCode?: Maybe<Scalars['Int']>;
};

export type CorvalCategoryDeleteCommandInput = {
  id: Scalars['Uuid'];
  reassignAllSubCategoriesToTargetNewParentId: Scalars['Boolean'];
  subCategoryIdToTargetNewParentIdDict: Array<CorvalKeyValuePairOfGuidAndGuidInput>;
  targetNewParentId: Scalars['Uuid'];
};

export type CorvalCategoryFilterInput = {
  and?: Maybe<Array<CorvalCategoryFilterInput>>;
  contextOwner?: Maybe<CorvalContextOwnerOperationFilterInput>;
  contextOwnerOrganization?: Maybe<CorvalOrganizationFilterInput>;
  contextOwnerOrganizationId?: Maybe<CorvalUuidOperationFilterInput>;
  contextOwnerProject?: Maybe<CorvalProjectFilterInput>;
  contextOwnerProjectId?: Maybe<CorvalUuidOperationFilterInput>;
  createdBy?: Maybe<CorvalAccountFilterInput>;
  createdById?: Maybe<CorvalUuidOperationFilterInput>;
  createdUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  description?: Maybe<CorvalStringOperationFilterInput>;
  displayName?: Maybe<CorvalStringOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  name?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalCategoryFilterInput>>;
  ordinal?: Maybe<CorvalIntOperationFilterInput>;
  refIdCode?: Maybe<CorvalIntOperationFilterInput>;
  rowVersion?: Maybe<CorvalListByteOperationFilterInput>;
  subCategories?: Maybe<CorvalListFilterInputTypeOfSubCategoryFilterInput>;
  updatedBy?: Maybe<CorvalAccountFilterInput>;
  updatedById?: Maybe<CorvalUuidOperationFilterInput>;
  updatedUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
};

export type CorvalCategorySortInput = {
  contextOwner?: Maybe<CorvalSortEnumType>;
  contextOwnerOrganization?: Maybe<CorvalOrganizationSortInput>;
  contextOwnerOrganizationId?: Maybe<CorvalSortEnumType>;
  contextOwnerProject?: Maybe<CorvalProjectSortInput>;
  contextOwnerProjectId?: Maybe<CorvalSortEnumType>;
  createdBy?: Maybe<CorvalAccountSortInput>;
  createdById?: Maybe<CorvalSortEnumType>;
  createdUtc?: Maybe<CorvalSortEnumType>;
  description?: Maybe<CorvalSortEnumType>;
  displayName?: Maybe<CorvalSortEnumType>;
  id?: Maybe<CorvalSortEnumType>;
  name?: Maybe<CorvalSortEnumType>;
  ordinal?: Maybe<CorvalSortEnumType>;
  refIdCode?: Maybe<CorvalSortEnumType>;
  updatedBy?: Maybe<CorvalAccountSortInput>;
  updatedById?: Maybe<CorvalSortEnumType>;
  updatedUtc?: Maybe<CorvalSortEnumType>;
};

export type CorvalCategoryUpdateCommandInput = {
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['Uuid'];
  name: Scalars['String'];
  refIdCode?: Maybe<Scalars['Int']>;
};

export type CorvalCategoryUpdateOrdinalsCommandInput = {
  ordinals: Array<CorvalCategoryUpdateOrdinalsItemInput>;
};

export type CorvalCategoryUpdateOrdinalsItemInput = {
  id: Scalars['Uuid'];
  ordinal: Scalars['Int'];
};

export type CorvalChangesetOfAddActivityItemAndUpdateActivityItemInput = {
  added?: Maybe<Array<CorvalAddActivityItemInput>>;
  modified?: Maybe<Array<CorvalUpdateActivityItemInput>>;
  removed?: Maybe<Array<Scalars['Uuid']>>;
};

export type CorvalChangesetOfAddCategoryItemAndUpdateCategoryItemInput = {
  added?: Maybe<Array<CorvalAddCategoryItemInput>>;
  modified?: Maybe<Array<CorvalUpdateCategoryItemInput>>;
  removed?: Maybe<Array<Scalars['Uuid']>>;
};

export type CorvalChangesetOfAddDependencyItemAndUpdateDependencyItemInput = {
  added?: Maybe<Array<CorvalAddDependencyItemInput>>;
  modified?: Maybe<Array<CorvalUpdateDependencyItemInput>>;
  removed?: Maybe<Array<Scalars['Uuid']>>;
};

export type CorvalChangesetOfAddEventItemAndUpdateEventItemInput = {
  added?: Maybe<Array<CorvalAddEventItemInput>>;
  modified?: Maybe<Array<CorvalUpdateEventItemInput>>;
  removed?: Maybe<Array<Scalars['Uuid']>>;
};

export type CorvalChangesetOfAddSubCategoryItemAndUpdateSubCategoryItemInput = {
  added?: Maybe<Array<CorvalAddSubCategoryItemInput>>;
  modified?: Maybe<Array<CorvalUpdateSubCategoryItemInput>>;
  removed?: Maybe<Array<Scalars['Uuid']>>;
};

export type CorvalChangesetOfAddSubObjectiveItemAndUpdateSubObjectiveItemInput = {
  added?: Maybe<Array<CorvalAddSubObjectiveItemInput>>;
  modified?: Maybe<Array<CorvalUpdateSubObjectiveItemInput>>;
  removed?: Maybe<Array<Scalars['Uuid']>>;
};

export enum CorvalCompletionState {
  Complete = 'COMPLETE',
  Excluded = 'EXCLUDED',
  Incomplete = 'INCOMPLETE',
  Notstarted = 'NOTSTARTED'
}

export type CorvalCompletionStateOperationFilterInput = {
  eq?: Maybe<CorvalCompletionState>;
  in?: Maybe<Array<CorvalCompletionState>>;
  neq?: Maybe<CorvalCompletionState>;
  nin?: Maybe<Array<CorvalCompletionState>>;
};

export enum CorvalConditionTypeEnum {
  Equalto = 'EQUALTO',
  Notequalto = 'NOTEQUALTO'
}

export type CorvalConditionTypeEnumOperationFilterInput = {
  eq?: Maybe<CorvalConditionTypeEnum>;
  in?: Maybe<Array<CorvalConditionTypeEnum>>;
  neq?: Maybe<CorvalConditionTypeEnum>;
  nin?: Maybe<Array<CorvalConditionTypeEnum>>;
};

export enum CorvalConstraintType {
  Aslateaspossible = 'ASLATEASPOSSIBLE',
  Assoonaspossible = 'ASSOONASPOSSIBLE',
  Finishnoearlierthan = 'FINISHNOEARLIERTHAN',
  Finishnolaterthan = 'FINISHNOLATERTHAN',
  Mustfinishon = 'MUSTFINISHON',
  Muststarton = 'MUSTSTARTON',
  Startnoearlierthan = 'STARTNOEARLIERTHAN',
  Startnolaterthan = 'STARTNOLATERTHAN'
}

export enum CorvalContextOwner {
  Corval = 'CORVAL',
  Organization = 'ORGANIZATION',
  Project = 'PROJECT',
  Tenant = 'TENANT'
}

export type CorvalContextOwnerOperationFilterInput = {
  eq?: Maybe<CorvalContextOwner>;
  in?: Maybe<Array<CorvalContextOwner>>;
  neq?: Maybe<CorvalContextOwner>;
  nin?: Maybe<Array<CorvalContextOwner>>;
};

export enum CorvalCostOccurenceType {
  Customprojectactivity = 'CUSTOMPROJECTACTIVITY',
  Customuser = 'CUSTOMUSER',
  Projectactivity = 'PROJECTACTIVITY'
}

export enum CorvalCostOccurrenceFeeType {
  Custombudgetitem = 'CUSTOMBUDGETITEM',
  Ongoingcost = 'ONGOINGCOST',
  Operationalcost = 'OPERATIONALCOST',
  Professionalfee = 'PROFESSIONALFEE',
  Scheduledbudgetitem = 'SCHEDULEDBUDGETITEM'
}

export enum CorvalCriticality {
  Critical = 'CRITICAL',
  Minor = 'MINOR',
  Moderate = 'MODERATE',
  Priority = 'PRIORITY'
}

export type CorvalCriticalityOperationFilterInput = {
  eq?: Maybe<CorvalCriticality>;
  in?: Maybe<Array<CorvalCriticality>>;
  neq?: Maybe<CorvalCriticality>;
  nin?: Maybe<Array<CorvalCriticality>>;
};

export type CorvalDataValueSet = {
  contextOwner: CorvalContextOwner;
  contextOwnerOrganization?: Maybe<CorvalOrganization>;
  contextOwnerOrganizationId?: Maybe<Scalars['Uuid']>;
  contextOwnerProject?: Maybe<CorvalProject>;
  contextOwnerProjectId?: Maybe<Scalars['Uuid']>;
  createdBy?: Maybe<CorvalAccount>;
  createdById?: Maybe<Scalars['Uuid']>;
  createdUtc: Scalars['DateTime'];
  id: Scalars['Uuid'];
  items?: Maybe<Array<Maybe<CorvalDataValueSetItem>>>;
  name: Scalars['String'];
  refId?: Maybe<Scalars['String']>;
  refIdCode?: Maybe<Scalars['Int']>;
  updatedBy?: Maybe<CorvalAccount>;
  updatedById?: Maybe<Scalars['Uuid']>;
  updatedUtc: Scalars['DateTime'];
  valueType: CorvalValueTypeEnum;
};

export type CorvalDataValueSetCreateCommandInput = {
  id: Scalars['Uuid'];
  items: Array<CorvalDataValueSetCreateItemInput>;
  name: Scalars['String'];
  refIdCode?: Maybe<Scalars['Int']>;
  valueType: CorvalValueTypeEnum;
};

export type CorvalDataValueSetCreateItemInput = {
  id: Scalars['Uuid'];
  ordinal: Scalars['Int'];
  refIdCode?: Maybe<Scalars['Int']>;
  value: Scalars['String'];
};

export type CorvalDataValueSetDeleteCommandInput = {
  id: Scalars['Uuid'];
};

export type CorvalDataValueSetFilterInput = {
  and?: Maybe<Array<CorvalDataValueSetFilterInput>>;
  contextOwner?: Maybe<CorvalContextOwnerOperationFilterInput>;
  contextOwnerOrganization?: Maybe<CorvalOrganizationFilterInput>;
  contextOwnerOrganizationId?: Maybe<CorvalUuidOperationFilterInput>;
  contextOwnerProject?: Maybe<CorvalProjectFilterInput>;
  contextOwnerProjectId?: Maybe<CorvalUuidOperationFilterInput>;
  createdBy?: Maybe<CorvalAccountFilterInput>;
  createdById?: Maybe<CorvalUuidOperationFilterInput>;
  createdUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  items?: Maybe<CorvalListFilterInputTypeOfDataValueSetItemFilterInput>;
  name?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalDataValueSetFilterInput>>;
  refIdCode?: Maybe<CorvalIntOperationFilterInput>;
  rowVersion?: Maybe<CorvalListByteOperationFilterInput>;
  updatedBy?: Maybe<CorvalAccountFilterInput>;
  updatedById?: Maybe<CorvalUuidOperationFilterInput>;
  updatedUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  valueType?: Maybe<CorvalValueTypeEnumOperationFilterInput>;
};

export type CorvalDataValueSetItem = {
  contextOwner: CorvalContextOwner;
  contextOwnerOrganization?: Maybe<CorvalOrganization>;
  contextOwnerOrganizationId?: Maybe<Scalars['Uuid']>;
  contextOwnerProject?: Maybe<CorvalProject>;
  contextOwnerProjectId?: Maybe<Scalars['Uuid']>;
  dataValueSetId: Scalars['Uuid'];
  id: Scalars['Uuid'];
  ordinal: Scalars['Int'];
  refId?: Maybe<Scalars['String']>;
  refIdCode?: Maybe<Scalars['Int']>;
  value: Scalars['String'];
};

export type CorvalDataValueSetItemFilterInput = {
  and?: Maybe<Array<CorvalDataValueSetItemFilterInput>>;
  contextOwner?: Maybe<CorvalContextOwnerOperationFilterInput>;
  contextOwnerOrganization?: Maybe<CorvalOrganizationFilterInput>;
  contextOwnerOrganizationId?: Maybe<CorvalUuidOperationFilterInput>;
  contextOwnerProject?: Maybe<CorvalProjectFilterInput>;
  contextOwnerProjectId?: Maybe<CorvalUuidOperationFilterInput>;
  dataValueSetId?: Maybe<CorvalUuidOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  or?: Maybe<Array<CorvalDataValueSetItemFilterInput>>;
  ordinal?: Maybe<CorvalIntOperationFilterInput>;
  refIdCode?: Maybe<CorvalIntOperationFilterInput>;
  value?: Maybe<CorvalStringOperationFilterInput>;
};

export type CorvalDataValueSetSortInput = {
  contextOwner?: Maybe<CorvalSortEnumType>;
  contextOwnerOrganization?: Maybe<CorvalOrganizationSortInput>;
  contextOwnerOrganizationId?: Maybe<CorvalSortEnumType>;
  contextOwnerProject?: Maybe<CorvalProjectSortInput>;
  contextOwnerProjectId?: Maybe<CorvalSortEnumType>;
  createdBy?: Maybe<CorvalAccountSortInput>;
  createdById?: Maybe<CorvalSortEnumType>;
  createdUtc?: Maybe<CorvalSortEnumType>;
  id?: Maybe<CorvalSortEnumType>;
  name?: Maybe<CorvalSortEnumType>;
  refIdCode?: Maybe<CorvalSortEnumType>;
  updatedBy?: Maybe<CorvalAccountSortInput>;
  updatedById?: Maybe<CorvalSortEnumType>;
  updatedUtc?: Maybe<CorvalSortEnumType>;
  valueType?: Maybe<CorvalSortEnumType>;
};

export type CorvalDataValueSetUpdateCommandInput = {
  id: Scalars['Uuid'];
  items: Array<CorvalDataValueSetUpdateItemInput>;
  name: Scalars['String'];
  refIdCode?: Maybe<Scalars['Int']>;
  valueType: CorvalValueTypeEnum;
};

export type CorvalDataValueSetUpdateItemInput = {
  id: Scalars['Uuid'];
  ordinal: Scalars['Int'];
  refIdCode?: Maybe<Scalars['Int']>;
  value: Scalars['String'];
};


export type CorvalDateTimeOperationFilterInput = {
  eq?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  neq?: Maybe<Scalars['DateTime']>;
  ngt?: Maybe<Scalars['DateTime']>;
  ngte?: Maybe<Scalars['DateTime']>;
  nin?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  nlt?: Maybe<Scalars['DateTime']>;
  nlte?: Maybe<Scalars['DateTime']>;
};



export type CorvalDecimalOperationFilterInput = {
  eq?: Maybe<Scalars['Decimal']>;
  gt?: Maybe<Scalars['Decimal']>;
  gte?: Maybe<Scalars['Decimal']>;
  in?: Maybe<Array<Maybe<Scalars['Decimal']>>>;
  lt?: Maybe<Scalars['Decimal']>;
  lte?: Maybe<Scalars['Decimal']>;
  neq?: Maybe<Scalars['Decimal']>;
  ngt?: Maybe<Scalars['Decimal']>;
  ngte?: Maybe<Scalars['Decimal']>;
  nin?: Maybe<Array<Maybe<Scalars['Decimal']>>>;
  nlt?: Maybe<Scalars['Decimal']>;
  nlte?: Maybe<Scalars['Decimal']>;
};

export type CorvalDocument = {
  createdBy?: Maybe<CorvalAccount>;
  createdById?: Maybe<Scalars['Uuid']>;
  createdUtc: Scalars['DateTime'];
  documentType: CorvalDocumentType;
  id: Scalars['Uuid'];
  organization?: Maybe<CorvalOrganization>;
  organizationId: Scalars['Uuid'];
  rowVersion?: Maybe<Array<Scalars['Byte']>>;
  size: Scalars['Int'];
  updatedBy?: Maybe<CorvalAccount>;
  updatedById?: Maybe<Scalars['Uuid']>;
  updatedUtc: Scalars['DateTime'];
};

export enum CorvalDocumentType {
  Generic = 'GENERIC',
  Report = 'REPORT'
}

export type CorvalEraFilterInput = {
  and?: Maybe<Array<CorvalEraFilterInput>>;
  name?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalEraFilterInput>>;
};

export enum CorvalGanttCorvalType {
  Activity = 'ACTIVITY',
  Category = 'CATEGORY',
  Subcategory = 'SUBCATEGORY',
  Subobjective = 'SUBOBJECTIVE'
}

export type CorvalGanttDependency = {
  active: Scalars['Boolean'];
  from: Scalars['String'];
  id: Scalars['String'];
  lag: Scalars['Int'];
  lagUnit: Scalars['String'];
  to: Scalars['String'];
  type: Scalars['Int'];
};

export enum CorvalGanttDependencyType {
  Endtoend = 'ENDTOEND',
  Endtostart = 'ENDTOSTART',
  Starttoend = 'STARTTOEND',
  Starttostart = 'STARTTOSTART'
}

export type CorvalGanttDependencyTypeOperationFilterInput = {
  eq?: Maybe<CorvalGanttDependencyType>;
  in?: Maybe<Array<CorvalGanttDependencyType>>;
  neq?: Maybe<CorvalGanttDependencyType>;
  nin?: Maybe<Array<CorvalGanttDependencyType>>;
};

export type CorvalHireItemInput = {
  headcount: Scalars['Int'];
  hireDate?: Maybe<Scalars['LocalDate']>;
  id: Scalars['Uuid'];
  isActive: Scalars['Boolean'];
  note: Scalars['String'];
  projectVersionMilestoneId?: Maybe<Scalars['Uuid']>;
  projectVersionMilestoneOffsetMonths: Scalars['Int'];
};

export type CorvalHireType = {
  businessFunction?: Maybe<CorvalBusinessFunction>;
  businessFunctionId: Scalars['Uuid'];
  contextOwner: CorvalContextOwner;
  contextOwnerOrganization?: Maybe<CorvalOrganization>;
  contextOwnerOrganizationId?: Maybe<Scalars['Uuid']>;
  contextOwnerProject?: Maybe<CorvalProject>;
  contextOwnerProjectId?: Maybe<Scalars['Uuid']>;
  createdBy?: Maybe<CorvalAccount>;
  createdById?: Maybe<Scalars['Uuid']>;
  createdUtc: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Uuid'];
  managingHireType?: Maybe<CorvalHireType>;
  managingHireTypeId?: Maybe<Scalars['Uuid']>;
  modifier: Scalars['Decimal'];
  name?: Maybe<Scalars['String']>;
  refId?: Maybe<Scalars['String']>;
  refIdCode?: Maybe<Scalars['Int']>;
  resourceCode: Scalars['String'];
  salary: Scalars['Decimal'];
  updatedBy?: Maybe<CorvalAccount>;
  updatedById?: Maybe<Scalars['Uuid']>;
  updatedUtc: Scalars['DateTime'];
};

export type CorvalHireTypeCreateCommandInput = {
  businessFunctionId: Scalars['Uuid'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Uuid'];
  managingHireTypeId?: Maybe<Scalars['Uuid']>;
  modifier: Scalars['Decimal'];
  name: Scalars['String'];
  refIdCode?: Maybe<Scalars['Int']>;
  resourceCode: Scalars['String'];
  salary: Scalars['Decimal'];
};

export type CorvalHireTypeDeleteCommandInput = {
  hireTypeId: Scalars['Uuid'];
  replacementHireTypeId?: Maybe<Scalars['Uuid']>;
};

export type CorvalHireTypeFilterInput = {
  and?: Maybe<Array<CorvalHireTypeFilterInput>>;
  businessFunctionId?: Maybe<CorvalUuidOperationFilterInput>;
  contextOwner?: Maybe<CorvalContextOwnerOperationFilterInput>;
  contextOwnerOrganization?: Maybe<CorvalOrganizationFilterInput>;
  contextOwnerOrganizationId?: Maybe<CorvalUuidOperationFilterInput>;
  contextOwnerProject?: Maybe<CorvalProjectFilterInput>;
  contextOwnerProjectId?: Maybe<CorvalUuidOperationFilterInput>;
  createdBy?: Maybe<CorvalAccountFilterInput>;
  createdById?: Maybe<CorvalUuidOperationFilterInput>;
  createdUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  description?: Maybe<CorvalStringOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  managingHireType?: Maybe<CorvalHireTypeFilterInput>;
  managingHireTypeId?: Maybe<CorvalUuidOperationFilterInput>;
  modifier?: Maybe<CorvalDecimalOperationFilterInput>;
  name?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalHireTypeFilterInput>>;
  refIdCode?: Maybe<CorvalIntOperationFilterInput>;
  resourceCode?: Maybe<CorvalStringOperationFilterInput>;
  rowVersion?: Maybe<CorvalListByteOperationFilterInput>;
  salary?: Maybe<CorvalDecimalOperationFilterInput>;
  updatedBy?: Maybe<CorvalAccountFilterInput>;
  updatedById?: Maybe<CorvalUuidOperationFilterInput>;
  updatedUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
};

export type CorvalHireTypeSortInput = {
  businessFunctionId?: Maybe<CorvalSortEnumType>;
  contextOwner?: Maybe<CorvalSortEnumType>;
  contextOwnerOrganization?: Maybe<CorvalOrganizationSortInput>;
  contextOwnerOrganizationId?: Maybe<CorvalSortEnumType>;
  contextOwnerProject?: Maybe<CorvalProjectSortInput>;
  contextOwnerProjectId?: Maybe<CorvalSortEnumType>;
  createdBy?: Maybe<CorvalAccountSortInput>;
  createdById?: Maybe<CorvalSortEnumType>;
  createdUtc?: Maybe<CorvalSortEnumType>;
  description?: Maybe<CorvalSortEnumType>;
  id?: Maybe<CorvalSortEnumType>;
  managingHireType?: Maybe<CorvalHireTypeSortInput>;
  managingHireTypeId?: Maybe<CorvalSortEnumType>;
  modifier?: Maybe<CorvalSortEnumType>;
  name?: Maybe<CorvalSortEnumType>;
  refIdCode?: Maybe<CorvalSortEnumType>;
  resourceCode?: Maybe<CorvalSortEnumType>;
  salary?: Maybe<CorvalSortEnumType>;
  updatedBy?: Maybe<CorvalAccountSortInput>;
  updatedById?: Maybe<CorvalSortEnumType>;
  updatedUtc?: Maybe<CorvalSortEnumType>;
};

export type CorvalHireTypeUpdateCommandInput = {
  businessFunctionId: Scalars['Uuid'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Uuid'];
  managingHireTypeId?: Maybe<Scalars['Uuid']>;
  modifier: Scalars['Decimal'];
  name: Scalars['String'];
  refIdCode?: Maybe<Scalars['Int']>;
  resourceCode: Scalars['String'];
  salary: Scalars['Decimal'];
};

export type CorvalIHire = {
  headcount: Scalars['Int'];
  hireType?: Maybe<CorvalHireType>;
  hireTypeId: Scalars['Uuid'];
};

export type CorvalIntakeQuestion = {
  assumptionGroupIntakeQuestions?: Maybe<Array<Maybe<CorvalAssumptionGroupIntakeQuestion>>>;
  category?: Maybe<CorvalCategory>;
  categoryId: Scalars['Uuid'];
  conditions?: Maybe<Array<Maybe<CorvalIntakeQuestionCondition>>>;
  contextOwner: CorvalContextOwner;
  contextOwnerOrganization?: Maybe<CorvalOrganization>;
  contextOwnerOrganizationId?: Maybe<Scalars['Uuid']>;
  contextOwnerProject?: Maybe<CorvalProject>;
  contextOwnerProjectId?: Maybe<Scalars['Uuid']>;
  createdBy?: Maybe<CorvalAccount>;
  createdById?: Maybe<Scalars['Uuid']>;
  createdUtc: Scalars['DateTime'];
  dataValueSet?: Maybe<CorvalDataValueSet>;
  dataValueSetId?: Maybe<Scalars['Uuid']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Uuid'];
  inputType: CorvalQuestionInputTypeEnum;
  isSurveyQuestion: Scalars['Boolean'];
  name: Scalars['String'];
  ordinal: Scalars['Int'];
  questionContext: CorvalQuestionContextEnum;
  questionText: Scalars['String'];
  refId?: Maybe<Scalars['String']>;
  refIdCode?: Maybe<Scalars['Int']>;
  requiredInDiscovery: Scalars['Boolean'];
  subObjectives?: Maybe<Array<Maybe<CorvalSubObjective>>>;
  updatedBy?: Maybe<CorvalAccount>;
  updatedById?: Maybe<Scalars['Uuid']>;
  updatedUtc: Scalars['DateTime'];
};

export type CorvalIntakeQuestionAnswerValueInput = {
  answerValue: Scalars['String'];
  intakeQuestionId: Scalars['Uuid'];
};

export type CorvalIntakeQuestionCondition = {
  conditionType: CorvalConditionTypeEnum;
  id: Scalars['Uuid'];
  intakeQuestionId: Scalars['Uuid'];
  targetIntakeQuestion?: Maybe<CorvalIntakeQuestion>;
  targetIntakeQuestionId: Scalars['Uuid'];
  value: Scalars['String'];
};

export type CorvalIntakeQuestionConditionFilterInput = {
  and?: Maybe<Array<CorvalIntakeQuestionConditionFilterInput>>;
  conditionType?: Maybe<CorvalConditionTypeEnumOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  intakeQuestionId?: Maybe<CorvalUuidOperationFilterInput>;
  or?: Maybe<Array<CorvalIntakeQuestionConditionFilterInput>>;
  targetIntakeQuestion?: Maybe<CorvalIntakeQuestionFilterInput>;
  targetIntakeQuestionId?: Maybe<CorvalUuidOperationFilterInput>;
  value?: Maybe<CorvalStringOperationFilterInput>;
};

export type CorvalIntakeQuestionCreateCommandInput = {
  categoryId: Scalars['Uuid'];
  conditions: Array<CorvalIntakeQuestionCreateConditionInput>;
  dataValueSetId?: Maybe<Scalars['Uuid']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Uuid'];
  inputType: CorvalQuestionInputTypeEnum;
  name: Scalars['String'];
  ordinal: Scalars['Int'];
  questionContext: CorvalQuestionContextEnum;
  questionText: Scalars['String'];
  refIdCode?: Maybe<Scalars['Int']>;
  requiredInDiscovery: Scalars['Boolean'];
};

export type CorvalIntakeQuestionCreateConditionInput = {
  conditionType: CorvalConditionTypeEnum;
  id: Scalars['Uuid'];
  targetIntakeQuestionId: Scalars['Uuid'];
  value: Scalars['String'];
};

export type CorvalIntakeQuestionDeleteCommandInput = {
  id: Scalars['Uuid'];
};

export type CorvalIntakeQuestionFilterInput = {
  and?: Maybe<Array<CorvalIntakeQuestionFilterInput>>;
  assumptionGroupIntakeQuestions?: Maybe<CorvalListFilterInputTypeOfAssumptionGroupIntakeQuestionFilterInput>;
  category?: Maybe<CorvalCategoryFilterInput>;
  categoryId?: Maybe<CorvalUuidOperationFilterInput>;
  conditions?: Maybe<CorvalListFilterInputTypeOfIntakeQuestionConditionFilterInput>;
  contextOwner?: Maybe<CorvalContextOwnerOperationFilterInput>;
  contextOwnerOrganization?: Maybe<CorvalOrganizationFilterInput>;
  contextOwnerOrganizationId?: Maybe<CorvalUuidOperationFilterInput>;
  contextOwnerProject?: Maybe<CorvalProjectFilterInput>;
  contextOwnerProjectId?: Maybe<CorvalUuidOperationFilterInput>;
  createdBy?: Maybe<CorvalAccountFilterInput>;
  createdById?: Maybe<CorvalUuidOperationFilterInput>;
  createdUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  dataValueSet?: Maybe<CorvalDataValueSetFilterInput>;
  dataValueSetId?: Maybe<CorvalUuidOperationFilterInput>;
  description?: Maybe<CorvalStringOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  inputType?: Maybe<CorvalQuestionInputTypeEnumOperationFilterInput>;
  name?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalIntakeQuestionFilterInput>>;
  ordinal?: Maybe<CorvalIntOperationFilterInput>;
  questionContext?: Maybe<CorvalQuestionContextEnumOperationFilterInput>;
  questionText?: Maybe<CorvalStringOperationFilterInput>;
  refIdCode?: Maybe<CorvalIntOperationFilterInput>;
  requiredInDiscovery?: Maybe<CorvalBooleanOperationFilterInput>;
  rowVersion?: Maybe<CorvalListByteOperationFilterInput>;
  updatedBy?: Maybe<CorvalAccountFilterInput>;
  updatedById?: Maybe<CorvalUuidOperationFilterInput>;
  updatedUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
};

export type CorvalIntakeQuestionSortInput = {
  category?: Maybe<CorvalCategorySortInput>;
  categoryId?: Maybe<CorvalSortEnumType>;
  contextOwner?: Maybe<CorvalSortEnumType>;
  contextOwnerOrganization?: Maybe<CorvalOrganizationSortInput>;
  contextOwnerOrganizationId?: Maybe<CorvalSortEnumType>;
  contextOwnerProject?: Maybe<CorvalProjectSortInput>;
  contextOwnerProjectId?: Maybe<CorvalSortEnumType>;
  createdBy?: Maybe<CorvalAccountSortInput>;
  createdById?: Maybe<CorvalSortEnumType>;
  createdUtc?: Maybe<CorvalSortEnumType>;
  dataValueSet?: Maybe<CorvalDataValueSetSortInput>;
  dataValueSetId?: Maybe<CorvalSortEnumType>;
  description?: Maybe<CorvalSortEnumType>;
  id?: Maybe<CorvalSortEnumType>;
  inputType?: Maybe<CorvalSortEnumType>;
  name?: Maybe<CorvalSortEnumType>;
  ordinal?: Maybe<CorvalSortEnumType>;
  questionContext?: Maybe<CorvalSortEnumType>;
  questionText?: Maybe<CorvalSortEnumType>;
  refIdCode?: Maybe<CorvalSortEnumType>;
  requiredInDiscovery?: Maybe<CorvalSortEnumType>;
  updatedBy?: Maybe<CorvalAccountSortInput>;
  updatedById?: Maybe<CorvalSortEnumType>;
  updatedUtc?: Maybe<CorvalSortEnumType>;
};

export type CorvalIntakeQuestionUnansweredQueryInput = {
  answers: Array<CorvalIntakeQuestionAnswerValueInput>;
};

export type CorvalIntakeQuestionUnansweredQueryResponse = {
  results: Array<CorvalResult>;
};

export type CorvalIntakeQuestionUpdateCommandInput = {
  categoryId: Scalars['Uuid'];
  conditions: Array<CorvalIntakeQuestionUpdateConditionInput>;
  dataValueSetId?: Maybe<Scalars['Uuid']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Uuid'];
  inputType: CorvalQuestionInputTypeEnum;
  name: Scalars['String'];
  ordinal: Scalars['Int'];
  questionContext: CorvalQuestionContextEnum;
  questionText: Scalars['String'];
  refIdCode?: Maybe<Scalars['Int']>;
  requiredInDiscovery: Scalars['Boolean'];
};

export type CorvalIntakeQuestionUpdateConditionInput = {
  conditionType: CorvalConditionTypeEnum;
  id: Scalars['Uuid'];
  targetIntakeQuestionId: Scalars['Uuid'];
  value: Scalars['String'];
};

export type CorvalIntakeQuestionUpdateOrdinalsCommandInput = {
  questionOrdinals: Array<CorvalIntakeQuestionUpdateOrdinalsItemInput>;
};

export type CorvalIntakeQuestionUpdateOrdinalsItemInput = {
  id: Scalars['Uuid'];
  ordinal: Scalars['Int'];
};

export type CorvalIntOperationFilterInput = {
  eq?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  neq?: Maybe<Scalars['Int']>;
  ngt?: Maybe<Scalars['Int']>;
  ngte?: Maybe<Scalars['Int']>;
  nin?: Maybe<Array<Maybe<Scalars['Int']>>>;
  nlt?: Maybe<Scalars['Int']>;
  nlte?: Maybe<Scalars['Int']>;
};

export enum CorvalIsoDayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  None = 'NONE',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type CorvalIsoDayOfWeekOperationFilterInput = {
  eq?: Maybe<CorvalIsoDayOfWeek>;
  in?: Maybe<Array<CorvalIsoDayOfWeek>>;
  neq?: Maybe<CorvalIsoDayOfWeek>;
  nin?: Maybe<Array<CorvalIsoDayOfWeek>>;
};

export type CorvalKeyValuePairOfGuidAndGuidInput = {
  key: Scalars['Uuid'];
  value: Scalars['Uuid'];
};

export type CorvalListByteOperationFilterInput = {
  all?: Maybe<CorvalByteOperationFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalByteOperationFilterInput>;
  some?: Maybe<CorvalByteOperationFilterInput>;
};

export type CorvalListFilterInputTypeOfAccountBusinessFunctionFilterInput = {
  all?: Maybe<CorvalAccountBusinessFunctionFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalAccountBusinessFunctionFilterInput>;
  some?: Maybe<CorvalAccountBusinessFunctionFilterInput>;
};

export type CorvalListFilterInputTypeOfActivityActivityFilterInput = {
  all?: Maybe<CorvalActivityActivityFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalActivityActivityFilterInput>;
  some?: Maybe<CorvalActivityActivityFilterInput>;
};

export type CorvalListFilterInputTypeOfActivityHireFilterInput = {
  all?: Maybe<CorvalActivityHireFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalActivityHireFilterInput>;
  some?: Maybe<CorvalActivityHireFilterInput>;
};

export type CorvalListFilterInputTypeOfActivityIntakeQuestionFilterInput = {
  all?: Maybe<CorvalActivityIntakeQuestionFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalActivityIntakeQuestionFilterInput>;
  some?: Maybe<CorvalActivityIntakeQuestionFilterInput>;
};

export type CorvalListFilterInputTypeOfActivityProfessionalFeeFilterInput = {
  all?: Maybe<CorvalActivityProfessionalFeeFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalActivityProfessionalFeeFilterInput>;
  some?: Maybe<CorvalActivityProfessionalFeeFilterInput>;
};

export type CorvalListFilterInputTypeOfActivitySubObjectiveFilterInput = {
  all?: Maybe<CorvalActivitySubObjectiveFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalActivitySubObjectiveFilterInput>;
  some?: Maybe<CorvalActivitySubObjectiveFilterInput>;
};

export type CorvalListFilterInputTypeOfActivityTagFilterInput = {
  all?: Maybe<CorvalActivityTagFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalActivityTagFilterInput>;
  some?: Maybe<CorvalActivityTagFilterInput>;
};

export type CorvalListFilterInputTypeOfAssetFilterInput = {
  all?: Maybe<CorvalAssetFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalAssetFilterInput>;
  some?: Maybe<CorvalAssetFilterInput>;
};

export type CorvalListFilterInputTypeOfAssumptionFilterInput = {
  all?: Maybe<CorvalAssumptionFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalAssumptionFilterInput>;
  some?: Maybe<CorvalAssumptionFilterInput>;
};

export type CorvalListFilterInputTypeOfAssumptionGroupIntakeQuestionFilterInput = {
  all?: Maybe<CorvalAssumptionGroupIntakeQuestionFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalAssumptionGroupIntakeQuestionFilterInput>;
  some?: Maybe<CorvalAssumptionGroupIntakeQuestionFilterInput>;
};

export type CorvalListFilterInputTypeOfBudgetValueConditionFilterInput = {
  all?: Maybe<CorvalBudgetValueConditionFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalBudgetValueConditionFilterInput>;
  some?: Maybe<CorvalBudgetValueConditionFilterInput>;
};

export type CorvalListFilterInputTypeOfDataValueSetItemFilterInput = {
  all?: Maybe<CorvalDataValueSetItemFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalDataValueSetItemFilterInput>;
  some?: Maybe<CorvalDataValueSetItemFilterInput>;
};

export type CorvalListFilterInputTypeOfEraFilterInput = {
  all?: Maybe<CorvalEraFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalEraFilterInput>;
  some?: Maybe<CorvalEraFilterInput>;
};

export type CorvalListFilterInputTypeOfIntakeQuestionConditionFilterInput = {
  all?: Maybe<CorvalIntakeQuestionConditionFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalIntakeQuestionConditionFilterInput>;
  some?: Maybe<CorvalIntakeQuestionConditionFilterInput>;
};

export type CorvalListFilterInputTypeOfOrganizationAccountFilterInput = {
  all?: Maybe<CorvalOrganizationAccountFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalOrganizationAccountFilterInput>;
  some?: Maybe<CorvalOrganizationAccountFilterInput>;
};

export type CorvalListFilterInputTypeOfProjectAccountFilterInput = {
  all?: Maybe<CorvalProjectAccountFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalProjectAccountFilterInput>;
  some?: Maybe<CorvalProjectAccountFilterInput>;
};

export type CorvalListFilterInputTypeOfProjectAnnualObjectiveFilterInput = {
  all?: Maybe<CorvalProjectAnnualObjectiveFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalProjectAnnualObjectiveFilterInput>;
  some?: Maybe<CorvalProjectAnnualObjectiveFilterInput>;
};

export type CorvalListFilterInputTypeOfProjectFilterInput = {
  all?: Maybe<CorvalProjectFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalProjectFilterInput>;
  some?: Maybe<CorvalProjectFilterInput>;
};

export type CorvalListFilterInputTypeOfProjectVersionHireTypeFilterInput = {
  all?: Maybe<CorvalProjectVersionHireTypeFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalProjectVersionHireTypeFilterInput>;
  some?: Maybe<CorvalProjectVersionHireTypeFilterInput>;
};

export type CorvalListFilterInputTypeOfProjectVersionMilestoneFilterInput = {
  all?: Maybe<CorvalProjectVersionMilestoneFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalProjectVersionMilestoneFilterInput>;
  some?: Maybe<CorvalProjectVersionMilestoneFilterInput>;
};

export type CorvalListFilterInputTypeOfProjectWorkflowTaskFilterInput = {
  all?: Maybe<CorvalProjectWorkflowTaskFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalProjectWorkflowTaskFilterInput>;
  some?: Maybe<CorvalProjectWorkflowTaskFilterInput>;
};

export type CorvalListFilterInputTypeOfQuickLinkFilterInput = {
  all?: Maybe<CorvalQuickLinkFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalQuickLinkFilterInput>;
  some?: Maybe<CorvalQuickLinkFilterInput>;
};

export type CorvalListFilterInputTypeOfScheduledBudgetItemFilterInput = {
  all?: Maybe<CorvalScheduledBudgetItemFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalScheduledBudgetItemFilterInput>;
  some?: Maybe<CorvalScheduledBudgetItemFilterInput>;
};

export type CorvalListFilterInputTypeOfStaticProjectActivityAccountFilterInput = {
  all?: Maybe<CorvalStaticProjectActivityAccountFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalStaticProjectActivityAccountFilterInput>;
  some?: Maybe<CorvalStaticProjectActivityAccountFilterInput>;
};

export type CorvalListFilterInputTypeOfStaticProjectActivityFilterInput = {
  all?: Maybe<CorvalStaticProjectActivityFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalStaticProjectActivityFilterInput>;
  some?: Maybe<CorvalStaticProjectActivityFilterInput>;
};

export type CorvalListFilterInputTypeOfStaticProjectActivityHireTypeFilterInput = {
  all?: Maybe<CorvalStaticProjectActivityHireTypeFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalStaticProjectActivityHireTypeFilterInput>;
  some?: Maybe<CorvalStaticProjectActivityHireTypeFilterInput>;
};

export type CorvalListFilterInputTypeOfStaticProjectActivityMilestoneRelationshipFilterInput = {
  all?: Maybe<CorvalStaticProjectActivityMilestoneRelationshipFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalStaticProjectActivityMilestoneRelationshipFilterInput>;
  some?: Maybe<CorvalStaticProjectActivityMilestoneRelationshipFilterInput>;
};

export type CorvalListFilterInputTypeOfStaticProjectActivityProfessionalFeeFilterInput = {
  all?: Maybe<CorvalStaticProjectActivityProfessionalFeeFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalStaticProjectActivityProfessionalFeeFilterInput>;
  some?: Maybe<CorvalStaticProjectActivityProfessionalFeeFilterInput>;
};

export type CorvalListFilterInputTypeOfStaticProjectActivityRelationshipFilterInput = {
  all?: Maybe<CorvalStaticProjectActivityRelationshipFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalStaticProjectActivityRelationshipFilterInput>;
  some?: Maybe<CorvalStaticProjectActivityRelationshipFilterInput>;
};

export type CorvalListFilterInputTypeOfStaticProjectBudgetItemFilterInput = {
  all?: Maybe<CorvalStaticProjectBudgetItemFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalStaticProjectBudgetItemFilterInput>;
  some?: Maybe<CorvalStaticProjectBudgetItemFilterInput>;
};

export type CorvalListFilterInputTypeOfStaticProjectBudgetItemValueFilterInput = {
  all?: Maybe<CorvalStaticProjectBudgetItemValueFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalStaticProjectBudgetItemValueFilterInput>;
  some?: Maybe<CorvalStaticProjectBudgetItemValueFilterInput>;
};

export type CorvalListFilterInputTypeOfStaticProjectHireFilterInput = {
  all?: Maybe<CorvalStaticProjectHireFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalStaticProjectHireFilterInput>;
  some?: Maybe<CorvalStaticProjectHireFilterInput>;
};

export type CorvalListFilterInputTypeOfStaticProjectProfessionalFeeFilterInput = {
  all?: Maybe<CorvalStaticProjectProfessionalFeeFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalStaticProjectProfessionalFeeFilterInput>;
  some?: Maybe<CorvalStaticProjectProfessionalFeeFilterInput>;
};

export type CorvalListFilterInputTypeOfStaticProjectSubObjectiveFilterInput = {
  all?: Maybe<CorvalStaticProjectSubObjectiveFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalStaticProjectSubObjectiveFilterInput>;
  some?: Maybe<CorvalStaticProjectSubObjectiveFilterInput>;
};

export type CorvalListFilterInputTypeOfSubCategoryFilterInput = {
  all?: Maybe<CorvalSubCategoryFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalSubCategoryFilterInput>;
  some?: Maybe<CorvalSubCategoryFilterInput>;
};

export type CorvalListFilterInputTypeOfSubObjectiveConditionFilterInput = {
  all?: Maybe<CorvalSubObjectiveConditionFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalSubObjectiveConditionFilterInput>;
  some?: Maybe<CorvalSubObjectiveConditionFilterInput>;
};

export type CorvalListFilterInputTypeOfSubObjectiveFilterInput = {
  all?: Maybe<CorvalSubObjectiveFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalSubObjectiveFilterInput>;
  some?: Maybe<CorvalSubObjectiveFilterInput>;
};

export type CorvalListFilterInputTypeOfTimeSpanConditionFilterInput = {
  all?: Maybe<CorvalTimeSpanConditionFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
  none?: Maybe<CorvalTimeSpanConditionFilterInput>;
  some?: Maybe<CorvalTimeSpanConditionFilterInput>;
};


export type CorvalLocalDateFilterInput = {
  and?: Maybe<Array<CorvalLocalDateFilterInput>>;
  calendar?: Maybe<CorvalCalendarSystemFilterInput>;
  day?: Maybe<CorvalIntOperationFilterInput>;
  dayOfWeek?: Maybe<CorvalIsoDayOfWeekOperationFilterInput>;
  dayOfYear?: Maybe<CorvalIntOperationFilterInput>;
  era?: Maybe<CorvalEraFilterInput>;
  month?: Maybe<CorvalIntOperationFilterInput>;
  or?: Maybe<Array<CorvalLocalDateFilterInput>>;
  year?: Maybe<CorvalIntOperationFilterInput>;
  yearOfEra?: Maybe<CorvalIntOperationFilterInput>;
};


export type CorvalMilestone = {
  colorValue: Scalars['String'];
  contextOwner: CorvalContextOwner;
  contextOwnerOrganization?: Maybe<CorvalOrganization>;
  contextOwnerOrganizationId?: Maybe<Scalars['Uuid']>;
  contextOwnerProject?: Maybe<CorvalProject>;
  contextOwnerProjectId?: Maybe<Scalars['Uuid']>;
  description: Scalars['String'];
  iconName: Scalars['String'];
  id: Scalars['Uuid'];
  isArchived: Scalars['Boolean'];
  name: Scalars['String'];
  refIdCode: Scalars['Int'];
  resourceCode: Scalars['String'];
};

export type CorvalMilestoneCreateCommandInput = {
  colorValue: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  iconName: Scalars['String'];
  id: Scalars['Uuid'];
  isArchived: Scalars['Boolean'];
  name: Scalars['String'];
  refIdCode: Scalars['Int'];
  resourceCode: Scalars['String'];
};

export type CorvalMilestoneFilterInput = {
  and?: Maybe<Array<CorvalMilestoneFilterInput>>;
  colorValue?: Maybe<CorvalStringOperationFilterInput>;
  contextOwner?: Maybe<CorvalContextOwnerOperationFilterInput>;
  contextOwnerOrganization?: Maybe<CorvalOrganizationFilterInput>;
  contextOwnerOrganizationId?: Maybe<CorvalUuidOperationFilterInput>;
  contextOwnerProject?: Maybe<CorvalProjectFilterInput>;
  contextOwnerProjectId?: Maybe<CorvalUuidOperationFilterInput>;
  description?: Maybe<CorvalStringOperationFilterInput>;
  iconName?: Maybe<CorvalStringOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  isArchived?: Maybe<CorvalBooleanOperationFilterInput>;
  name?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalMilestoneFilterInput>>;
  refIdCode?: Maybe<CorvalIntOperationFilterInput>;
  resourceCode?: Maybe<CorvalStringOperationFilterInput>;
};

export type CorvalMilestoneSortInput = {
  colorValue?: Maybe<CorvalSortEnumType>;
  contextOwner?: Maybe<CorvalSortEnumType>;
  contextOwnerOrganization?: Maybe<CorvalOrganizationSortInput>;
  contextOwnerOrganizationId?: Maybe<CorvalSortEnumType>;
  contextOwnerProject?: Maybe<CorvalProjectSortInput>;
  contextOwnerProjectId?: Maybe<CorvalSortEnumType>;
  description?: Maybe<CorvalSortEnumType>;
  iconName?: Maybe<CorvalSortEnumType>;
  id?: Maybe<CorvalSortEnumType>;
  isArchived?: Maybe<CorvalSortEnumType>;
  name?: Maybe<CorvalSortEnumType>;
  refIdCode?: Maybe<CorvalSortEnumType>;
  resourceCode?: Maybe<CorvalSortEnumType>;
};

export type CorvalMilestoneUpdateCommandInput = {
  colorValue: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  iconName: Scalars['String'];
  id: Scalars['Uuid'];
  isArchived: Scalars['Boolean'];
  name: Scalars['String'];
  refIdCode: Scalars['Int'];
  resourceCode: Scalars['String'];
};

export type CorvalMinMaxOfDecimal = {
  max: Scalars['Decimal'];
  min: Scalars['Decimal'];
};

export type CorvalMutation = {
  addProjectVersionSubObjectives: CorvalProjectVersionAddSubObjectivesCommandResponse;
  cloneProject: CorvalProject;
  createAccount: CorvalAccount;
  createActivity: CorvalActivity;
  createAssumptionGroup: CorvalAssumptionGroup;
  createBusinessFunction: CorvalBusinessFunction;
  createCategory: CorvalCategory;
  createDataValueSet: CorvalDataValueSet;
  createHireType?: Maybe<CorvalHireType>;
  createIntakeQuestion: CorvalIntakeQuestion;
  createMilestone: CorvalMilestone;
  createObjective: CorvalObjective;
  createOrganization: CorvalOrganization;
  createProfessionalFee?: Maybe<CorvalProfessionalFee>;
  createProject: CorvalProject;
  createProjectAnnualObjective: CorvalProjectAnnualObjective;
  createProjectFromTemplate: CorvalProject;
  createProjectTemplate?: Maybe<CorvalProjectTemplate>;
  createProjectVersion: CorvalProjectVersion;
  createSubCategory: CorvalSubCategory;
  createSubObjective: CorvalSubObjective;
  deleteActivity: Scalars['Uuid'];
  deleteAssumptionGroup: Scalars['Uuid'];
  deleteCategory: Scalars['Uuid'];
  deleteDataValueSet: Scalars['Uuid'];
  deleteHireType: Scalars['Uuid'];
  deleteIntakeQuestion: Scalars['Uuid'];
  deleteObjective: Scalars['Uuid'];
  deleteProfessionalFee: Scalars['Uuid'];
  deleteProjectAnnualObjective: Scalars['Boolean'];
  deleteProjectVersion: Scalars['Boolean'];
  deleteSubCategory: Scalars['Uuid'];
  deleteSubObjective: Scalars['Uuid'];
  reassignProjectWorkflowTask: CorvalProjectWorkflowTask;
  saveAssumption: CorvalAssumption;
  saveStaticProjectBudgetItems: Array<CorvalStaticProjectBudgetItem>;
  updateAccount: CorvalAccount;
  updateActivity: CorvalActivity;
  updateAssumptionGroup: CorvalAssumptionGroup;
  updateAssumptionGroupOrdinals: Array<CorvalAssumptionGroup>;
  updateBusinessFunction: CorvalBusinessFunction;
  updateCategory: CorvalCategory;
  updateCategoryOrdinals: Array<CorvalCategory>;
  updateDataValueSet: CorvalDataValueSet;
  updateHireType?: Maybe<CorvalHireType>;
  updateIntakeQuestion: CorvalIntakeQuestion;
  updateIntakeQuestionOrdinals: Array<CorvalIntakeQuestion>;
  updateMilestone: CorvalMilestone;
  updateObjective: CorvalObjective;
  updateObjectiveOrdinals: Array<CorvalObjective>;
  updateProfessionalFee?: Maybe<CorvalProfessionalFee>;
  updateProject: CorvalProject;
  updateProjectAnnualObjective: CorvalProjectAnnualObjective;
  updateProjectTemplate?: Maybe<CorvalProjectTemplate>;
  updateProjectVersion: CorvalProjectVersion;
  updateProjectVersionData: CorvalProjectVersionUpdateDataCommandResponse;
  updateProjectVersionHireType: CorvalProjectVersionHireType;
  updateProjectWorkflowTaskActionStatus: CorvalProjectWorkflowTask;
  updateStrategicAssumptionTemplate: CorvalStrategicAssumptionTemplate;
  updateSubCategory: CorvalSubCategory;
  updateSubCategoryOrdinals: Array<CorvalSubCategory>;
  updateSubObjective: CorvalSubObjective;
  updateSubObjectiveOrdinals: Array<CorvalSubObjective>;
};


export type CorvalMutationAddProjectVersionSubObjectivesArgs = {
  input: CorvalProjectVersionAddSubObjectivesCommandInput;
};


export type CorvalMutationCloneProjectArgs = {
  input: CorvalProjectCloneCommandInput;
};


export type CorvalMutationCreateAccountArgs = {
  input: CorvalAccountCreateCommandInput;
};


export type CorvalMutationCreateActivityArgs = {
  input: CorvalActivityCreateCommandInput;
};


export type CorvalMutationCreateAssumptionGroupArgs = {
  input: CorvalAssumptionGroupCreateCommandInput;
};


export type CorvalMutationCreateBusinessFunctionArgs = {
  input: CorvalBusinessFunctionCreateCommandInput;
};


export type CorvalMutationCreateCategoryArgs = {
  input: CorvalCategoryCreateCommandInput;
};


export type CorvalMutationCreateDataValueSetArgs = {
  input: CorvalDataValueSetCreateCommandInput;
};


export type CorvalMutationCreateHireTypeArgs = {
  input: CorvalHireTypeCreateCommandInput;
};


export type CorvalMutationCreateIntakeQuestionArgs = {
  input: CorvalIntakeQuestionCreateCommandInput;
};


export type CorvalMutationCreateMilestoneArgs = {
  input: CorvalMilestoneCreateCommandInput;
};


export type CorvalMutationCreateObjectiveArgs = {
  input: CorvalObjectiveCreateCommandInput;
};


export type CorvalMutationCreateOrganizationArgs = {
  input: CorvalOrganizationCreateCommandInput;
};


export type CorvalMutationCreateProfessionalFeeArgs = {
  input: CorvalProfessionalFeeCreateCommandInput;
};


export type CorvalMutationCreateProjectArgs = {
  input: CorvalProjectCreateCommandInput;
};


export type CorvalMutationCreateProjectAnnualObjectiveArgs = {
  input: CorvalProjectAnnualObjectiveCreateCommandInput;
};


export type CorvalMutationCreateProjectFromTemplateArgs = {
  input: CorvalProjectCreateFromTemplateCommandInput;
};


export type CorvalMutationCreateProjectTemplateArgs = {
  input: CorvalProjectTemplateCreateCommandInput;
};


export type CorvalMutationCreateProjectVersionArgs = {
  input: CorvalProjectVersionCreateCommandInput;
};


export type CorvalMutationCreateSubCategoryArgs = {
  input: CorvalSubCategoryCreateCommandInput;
};


export type CorvalMutationCreateSubObjectiveArgs = {
  input: CorvalSubObjectiveCreateCommandInput;
};


export type CorvalMutationDeleteActivityArgs = {
  input: CorvalActivityDeleteCommandInput;
};


export type CorvalMutationDeleteAssumptionGroupArgs = {
  input: CorvalAssumptionGroupDeleteCommandInput;
};


export type CorvalMutationDeleteCategoryArgs = {
  input: CorvalCategoryDeleteCommandInput;
};


export type CorvalMutationDeleteDataValueSetArgs = {
  input: CorvalDataValueSetDeleteCommandInput;
};


export type CorvalMutationDeleteHireTypeArgs = {
  input: CorvalHireTypeDeleteCommandInput;
};


export type CorvalMutationDeleteIntakeQuestionArgs = {
  input: CorvalIntakeQuestionDeleteCommandInput;
};


export type CorvalMutationDeleteObjectiveArgs = {
  input: CorvalObjectiveDeleteCommandInput;
};


export type CorvalMutationDeleteProfessionalFeeArgs = {
  input: CorvalProfessionalFeeDeleteCommandInput;
};


export type CorvalMutationDeleteProjectAnnualObjectiveArgs = {
  input: CorvalProjectAnnualObjectiveDeleteCommandInput;
};


export type CorvalMutationDeleteProjectVersionArgs = {
  input: CorvalProjectVersionDeleteCommandInput;
};


export type CorvalMutationDeleteSubCategoryArgs = {
  input: CorvalSubCategoryDeleteCommandInput;
};


export type CorvalMutationDeleteSubObjectiveArgs = {
  input: CorvalSubObjectiveDeleteCommandInput;
};


export type CorvalMutationReassignProjectWorkflowTaskArgs = {
  input: CorvalProjectWorkflowTaskReassignCommandInput;
};


export type CorvalMutationSaveAssumptionArgs = {
  input: CorvalAssumptionSaveCommandInput;
};


export type CorvalMutationSaveStaticProjectBudgetItemsArgs = {
  input: CorvalStaticProjectBudgetItemSaveCommandInput;
};


export type CorvalMutationUpdateAccountArgs = {
  input: CorvalAccountUpdateCommandInput;
};


export type CorvalMutationUpdateActivityArgs = {
  input: CorvalActivityUpdateCommandInput;
};


export type CorvalMutationUpdateAssumptionGroupArgs = {
  input: CorvalAssumptionGroupUpdateCommandInput;
};


export type CorvalMutationUpdateAssumptionGroupOrdinalsArgs = {
  input: CorvalAssumptionGroupUpdateOrdinalsCommandInput;
};


export type CorvalMutationUpdateBusinessFunctionArgs = {
  input: CorvalBusinessFunctionUpdateCommandInput;
};


export type CorvalMutationUpdateCategoryArgs = {
  input: CorvalCategoryUpdateCommandInput;
};


export type CorvalMutationUpdateCategoryOrdinalsArgs = {
  input: CorvalCategoryUpdateOrdinalsCommandInput;
};


export type CorvalMutationUpdateDataValueSetArgs = {
  input: CorvalDataValueSetUpdateCommandInput;
};


export type CorvalMutationUpdateHireTypeArgs = {
  input: CorvalHireTypeUpdateCommandInput;
};


export type CorvalMutationUpdateIntakeQuestionArgs = {
  input: CorvalIntakeQuestionUpdateCommandInput;
};


export type CorvalMutationUpdateIntakeQuestionOrdinalsArgs = {
  input: CorvalIntakeQuestionUpdateOrdinalsCommandInput;
};


export type CorvalMutationUpdateMilestoneArgs = {
  input: CorvalMilestoneUpdateCommandInput;
};


export type CorvalMutationUpdateObjectiveArgs = {
  input: CorvalObjectiveUpdateCommandInput;
};


export type CorvalMutationUpdateObjectiveOrdinalsArgs = {
  input: CorvalObjectiveUpdateOrdinalsCommandInput;
};


export type CorvalMutationUpdateProfessionalFeeArgs = {
  input: CorvalProfessionalFeeUpdateCommandInput;
};


export type CorvalMutationUpdateProjectArgs = {
  input: CorvalProjectUpdateCommandInput;
};


export type CorvalMutationUpdateProjectAnnualObjectiveArgs = {
  input: CorvalProjectAnnualObjectiveUpdateCommandInput;
};


export type CorvalMutationUpdateProjectTemplateArgs = {
  input: CorvalProjectTemplateUpdateCommandInput;
};


export type CorvalMutationUpdateProjectVersionArgs = {
  input: CorvalProjectVersionUpdateCommandInput;
};


export type CorvalMutationUpdateProjectVersionDataArgs = {
  input: CorvalProjectVersionUpdateDataCommandInput;
};


export type CorvalMutationUpdateProjectVersionHireTypeArgs = {
  input: CorvalProjectVersionHireTypeUpdateCommandInput;
};


export type CorvalMutationUpdateProjectWorkflowTaskActionStatusArgs = {
  input: CorvalProjectWorkflowTaskUpdateActionStatusCommandInput;
};


export type CorvalMutationUpdateStrategicAssumptionTemplateArgs = {
  input: CorvalStrategicAssumptionTemplateUpdateCommandInput;
};


export type CorvalMutationUpdateSubCategoryArgs = {
  input: CorvalSubCategoryUpdateCommandInput;
};


export type CorvalMutationUpdateSubCategoryOrdinalsArgs = {
  input: CorvalSubCategoryUpdateOrdinalsCommandInput;
};


export type CorvalMutationUpdateSubObjectiveArgs = {
  input: CorvalSubObjectiveUpdateCommandInput;
};


export type CorvalMutationUpdateSubObjectiveOrdinalsArgs = {
  input: CorvalSubObjectiveUpdateOrdinalsCommandInput;
};

export type CorvalNullableOfConstraintTypeOperationFilterInput = {
  eq?: Maybe<CorvalConstraintType>;
  in?: Maybe<Array<Maybe<CorvalConstraintType>>>;
  neq?: Maybe<CorvalConstraintType>;
  nin?: Maybe<Array<Maybe<CorvalConstraintType>>>;
};

export type CorvalObjective = {
  contextOwner: CorvalContextOwner;
  contextOwnerOrganization?: Maybe<CorvalOrganization>;
  contextOwnerOrganizationId?: Maybe<Scalars['Uuid']>;
  contextOwnerProject?: Maybe<CorvalProject>;
  contextOwnerProjectId?: Maybe<Scalars['Uuid']>;
  createdBy?: Maybe<CorvalAccount>;
  createdById?: Maybe<Scalars['Uuid']>;
  createdUtc: Scalars['DateTime'];
  description: Scalars['String'];
  displayName: Scalars['String'];
  id: Scalars['Uuid'];
  name: Scalars['String'];
  ordinal: Scalars['Int'];
  refId?: Maybe<Scalars['String']>;
  refIdCode?: Maybe<Scalars['Int']>;
  subObjectives?: Maybe<Array<Maybe<CorvalSubObjective>>>;
  updatedBy?: Maybe<CorvalAccount>;
  updatedById?: Maybe<Scalars['Uuid']>;
  updatedUtc: Scalars['DateTime'];
};

export type CorvalObjectiveCreateCommandInput = {
  description: Scalars['String'];
  displayName: Scalars['String'];
  id: Scalars['Uuid'];
  name: Scalars['String'];
  ordinal: Scalars['Int'];
  refIdCode?: Maybe<Scalars['Int']>;
};

export type CorvalObjectiveDeleteCommandInput = {
  id: Scalars['Uuid'];
  targetNewParentId?: Maybe<Scalars['Uuid']>;
};

export type CorvalObjectiveFilterInput = {
  and?: Maybe<Array<CorvalObjectiveFilterInput>>;
  contextOwner?: Maybe<CorvalContextOwnerOperationFilterInput>;
  contextOwnerOrganization?: Maybe<CorvalOrganizationFilterInput>;
  contextOwnerOrganizationId?: Maybe<CorvalUuidOperationFilterInput>;
  contextOwnerProject?: Maybe<CorvalProjectFilterInput>;
  contextOwnerProjectId?: Maybe<CorvalUuidOperationFilterInput>;
  createdBy?: Maybe<CorvalAccountFilterInput>;
  createdById?: Maybe<CorvalUuidOperationFilterInput>;
  createdUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  description?: Maybe<CorvalStringOperationFilterInput>;
  displayName?: Maybe<CorvalStringOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  name?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalObjectiveFilterInput>>;
  ordinal?: Maybe<CorvalIntOperationFilterInput>;
  refIdCode?: Maybe<CorvalIntOperationFilterInput>;
  rowVersion?: Maybe<CorvalListByteOperationFilterInput>;
  subObjectives?: Maybe<CorvalListFilterInputTypeOfSubObjectiveFilterInput>;
  updatedBy?: Maybe<CorvalAccountFilterInput>;
  updatedById?: Maybe<CorvalUuidOperationFilterInput>;
  updatedUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
};

export type CorvalObjectiveSortInput = {
  contextOwner?: Maybe<CorvalSortEnumType>;
  contextOwnerOrganization?: Maybe<CorvalOrganizationSortInput>;
  contextOwnerOrganizationId?: Maybe<CorvalSortEnumType>;
  contextOwnerProject?: Maybe<CorvalProjectSortInput>;
  contextOwnerProjectId?: Maybe<CorvalSortEnumType>;
  createdBy?: Maybe<CorvalAccountSortInput>;
  createdById?: Maybe<CorvalSortEnumType>;
  createdUtc?: Maybe<CorvalSortEnumType>;
  description?: Maybe<CorvalSortEnumType>;
  displayName?: Maybe<CorvalSortEnumType>;
  id?: Maybe<CorvalSortEnumType>;
  name?: Maybe<CorvalSortEnumType>;
  ordinal?: Maybe<CorvalSortEnumType>;
  refIdCode?: Maybe<CorvalSortEnumType>;
  updatedBy?: Maybe<CorvalAccountSortInput>;
  updatedById?: Maybe<CorvalSortEnumType>;
  updatedUtc?: Maybe<CorvalSortEnumType>;
};

export type CorvalObjectiveUpdateCommandInput = {
  description: Scalars['String'];
  displayName: Scalars['String'];
  id: Scalars['Uuid'];
  name: Scalars['String'];
  ordinal: Scalars['Int'];
  refIdCode?: Maybe<Scalars['Int']>;
};

export type CorvalObjectiveUpdateOrdinalsCommandInput = {
  ordinals: Array<CorvalObjectiveUpdateOrdinalsItemInput>;
};

export type CorvalObjectiveUpdateOrdinalsItemInput = {
  id: Scalars['Uuid'];
  ordinal: Scalars['Int'];
};

export type CorvalOrganization = {
  assets?: Maybe<Array<Maybe<CorvalAsset>>>;
  createdBy?: Maybe<CorvalAccount>;
  createdById?: Maybe<Scalars['Uuid']>;
  createdUtc: Scalars['DateTime'];
  id: Scalars['Uuid'];
  name: Scalars['String'];
  organizationMembers?: Maybe<Array<Maybe<CorvalOrganizationAccount>>>;
  projects?: Maybe<Array<Maybe<CorvalProject>>>;
  subscriptionType: CorvalSubscriptionType;
  updatedBy?: Maybe<CorvalAccount>;
  updatedById?: Maybe<Scalars['Uuid']>;
  updatedUtc: Scalars['DateTime'];
};

export type CorvalOrganizationAccount = {
  account?: Maybe<CorvalAccount>;
  accountId: Scalars['Uuid'];
  isActive: Scalars['Boolean'];
  organization?: Maybe<CorvalOrganization>;
  organizationId: Scalars['Uuid'];
  organizationRole: CorvalOrganizationRole;
};

export type CorvalOrganizationAccountFilterInput = {
  account?: Maybe<CorvalAccountFilterInput>;
  accountId?: Maybe<CorvalUuidOperationFilterInput>;
  and?: Maybe<Array<CorvalOrganizationAccountFilterInput>>;
  isActive?: Maybe<CorvalBooleanOperationFilterInput>;
  or?: Maybe<Array<CorvalOrganizationAccountFilterInput>>;
  organization?: Maybe<CorvalOrganizationFilterInput>;
  organizationId?: Maybe<CorvalUuidOperationFilterInput>;
  organizationRole?: Maybe<CorvalOrganizationRoleOperationFilterInput>;
};

export type CorvalOrganizationCreateCommandInput = {
  id: Scalars['Uuid'];
  name: Scalars['String'];
  subscriptionType: CorvalSubscriptionType;
};

export type CorvalOrganizationFilterInput = {
  and?: Maybe<Array<CorvalOrganizationFilterInput>>;
  assets?: Maybe<CorvalListFilterInputTypeOfAssetFilterInput>;
  createdBy?: Maybe<CorvalAccountFilterInput>;
  createdById?: Maybe<CorvalUuidOperationFilterInput>;
  createdUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  name?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalOrganizationFilterInput>>;
  organizationMembers?: Maybe<CorvalListFilterInputTypeOfOrganizationAccountFilterInput>;
  rowVersion?: Maybe<CorvalListByteOperationFilterInput>;
  subscriptionType?: Maybe<CorvalSubscriptionTypeOperationFilterInput>;
  updatedBy?: Maybe<CorvalAccountFilterInput>;
  updatedById?: Maybe<CorvalUuidOperationFilterInput>;
  updatedUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
};

export enum CorvalOrganizationRole {
  Admin = 'ADMIN',
  Member = 'MEMBER'
}

export type CorvalOrganizationRoleOperationFilterInput = {
  eq?: Maybe<CorvalOrganizationRole>;
  in?: Maybe<Array<CorvalOrganizationRole>>;
  neq?: Maybe<CorvalOrganizationRole>;
  nin?: Maybe<Array<CorvalOrganizationRole>>;
};

export type CorvalOrganizationSortInput = {
  createdBy?: Maybe<CorvalAccountSortInput>;
  createdById?: Maybe<CorvalSortEnumType>;
  createdUtc?: Maybe<CorvalSortEnumType>;
  id?: Maybe<CorvalSortEnumType>;
  name?: Maybe<CorvalSortEnumType>;
  subscriptionType?: Maybe<CorvalSortEnumType>;
  updatedBy?: Maybe<CorvalAccountSortInput>;
  updatedById?: Maybe<CorvalSortEnumType>;
  updatedUtc?: Maybe<CorvalSortEnumType>;
};

export type CorvalProfessionalFee = {
  amount: Scalars['Decimal'];
  contextOwner: CorvalContextOwner;
  contextOwnerOrganization?: Maybe<CorvalOrganization>;
  contextOwnerOrganizationId?: Maybe<Scalars['Uuid']>;
  contextOwnerProject?: Maybe<CorvalProject>;
  contextOwnerProjectId?: Maybe<Scalars['Uuid']>;
  createdBy?: Maybe<CorvalAccount>;
  createdById?: Maybe<Scalars['Uuid']>;
  createdUtc: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Uuid'];
  name: Scalars['String'];
  refId?: Maybe<Scalars['String']>;
  refIdCode?: Maybe<Scalars['Int']>;
  resourceCode: Scalars['String'];
  updatedBy?: Maybe<CorvalAccount>;
  updatedById?: Maybe<Scalars['Uuid']>;
  updatedUtc: Scalars['DateTime'];
};

export type CorvalProfessionalFeeCreateCommandInput = {
  amount: Scalars['Decimal'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Uuid'];
  name: Scalars['String'];
  refIdCode?: Maybe<Scalars['Int']>;
  resourceCode: Scalars['String'];
};

export type CorvalProfessionalFeeDeleteCommandInput = {
  professionalFeeId: Scalars['Uuid'];
  replacementProfessionalFeeId?: Maybe<Scalars['Uuid']>;
};

export type CorvalProfessionalFeeFilterInput = {
  amount?: Maybe<CorvalDecimalOperationFilterInput>;
  and?: Maybe<Array<CorvalProfessionalFeeFilterInput>>;
  contextOwner?: Maybe<CorvalContextOwnerOperationFilterInput>;
  contextOwnerOrganization?: Maybe<CorvalOrganizationFilterInput>;
  contextOwnerOrganizationId?: Maybe<CorvalUuidOperationFilterInput>;
  contextOwnerProject?: Maybe<CorvalProjectFilterInput>;
  contextOwnerProjectId?: Maybe<CorvalUuidOperationFilterInput>;
  createdBy?: Maybe<CorvalAccountFilterInput>;
  createdById?: Maybe<CorvalUuidOperationFilterInput>;
  createdUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  description?: Maybe<CorvalStringOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  name?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalProfessionalFeeFilterInput>>;
  refIdCode?: Maybe<CorvalIntOperationFilterInput>;
  resourceCode?: Maybe<CorvalStringOperationFilterInput>;
  rowVersion?: Maybe<CorvalListByteOperationFilterInput>;
  updatedBy?: Maybe<CorvalAccountFilterInput>;
  updatedById?: Maybe<CorvalUuidOperationFilterInput>;
  updatedUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
};

export type CorvalProfessionalFeeSortInput = {
  amount?: Maybe<CorvalSortEnumType>;
  contextOwner?: Maybe<CorvalSortEnumType>;
  contextOwnerOrganization?: Maybe<CorvalOrganizationSortInput>;
  contextOwnerOrganizationId?: Maybe<CorvalSortEnumType>;
  contextOwnerProject?: Maybe<CorvalProjectSortInput>;
  contextOwnerProjectId?: Maybe<CorvalSortEnumType>;
  createdBy?: Maybe<CorvalAccountSortInput>;
  createdById?: Maybe<CorvalSortEnumType>;
  createdUtc?: Maybe<CorvalSortEnumType>;
  description?: Maybe<CorvalSortEnumType>;
  id?: Maybe<CorvalSortEnumType>;
  name?: Maybe<CorvalSortEnumType>;
  refIdCode?: Maybe<CorvalSortEnumType>;
  resourceCode?: Maybe<CorvalSortEnumType>;
  updatedBy?: Maybe<CorvalAccountSortInput>;
  updatedById?: Maybe<CorvalSortEnumType>;
  updatedUtc?: Maybe<CorvalSortEnumType>;
};

export type CorvalProfessionalFeeUpdateCommandInput = {
  amount: Scalars['Decimal'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Uuid'];
  name: Scalars['String'];
  refIdCode?: Maybe<Scalars['Int']>;
  resourceCode: Scalars['String'];
};

export type CorvalProject = {
  asset?: Maybe<CorvalAsset>;
  assetId: Scalars['Uuid'];
  assetIndication?: Maybe<Scalars['String']>;
  assetName?: Maybe<Scalars['String']>;
  assumptions?: Maybe<Array<Maybe<CorvalAssumption>>>;
  auditEntries?: Maybe<Array<Maybe<CorvalAuditEntry>>>;
  businessFunctions: Array<CorvalBusinessFunction>;
  createdBy?: Maybe<CorvalAccount>;
  createdById?: Maybe<Scalars['Uuid']>;
  createdUtc: Scalars['DateTime'];
  id: Scalars['Uuid'];
  isActive: Scalars['Boolean'];
  isDiscoveryComplete: Scalars['Boolean'];
  isTemplateSource: Scalars['Boolean'];
  mapLowerBound: Scalars['DateTime'];
  mapUpperBound: Scalars['DateTime'];
  milestones: Array<CorvalMilestone>;
  name: Scalars['String'];
  organization?: Maybe<CorvalOrganization>;
  organizationId: Scalars['Uuid'];
  parentProjectId?: Maybe<Scalars['Uuid']>;
  parsedTermDictionary: CorvalTermDictionary;
  projectAnnualObjectives?: Maybe<Array<Maybe<CorvalProjectAnnualObjective>>>;
  projectMembers?: Maybe<Array<Maybe<CorvalProjectAccount>>>;
  projectVersionHireTypes: Array<CorvalProjectVersionHireType>;
  projectVersions?: Maybe<Array<Maybe<CorvalProjectVersion>>>;
  projectWorkflowTasks: Array<CorvalProjectWorkflowTask>;
  projectWorkFlowTasks?: Maybe<Array<Maybe<CorvalProjectWorkflowTask>>>;
  revenue?: Maybe<Scalars['Decimal']>;
  staticBudget: CorvalProjectVersionBudgetQueryResponse;
  staticBudgetItems: Array<CorvalStaticProjectBudgetItem>;
  staticProjectActivities: Array<CorvalStaticProjectActivity>;
  staticProjectHires: Array<CorvalStaticProjectHire>;
  staticProjectSubObjectives: Array<CorvalStaticProjectSubObjective>;
  termDictionary: Scalars['String'];
  updatedBy?: Maybe<CorvalAccount>;
  updatedById?: Maybe<Scalars['Uuid']>;
  updatedUtc: Scalars['DateTime'];
};


export type CorvalProjectMapLowerBoundArgs = {
  projectVersionId?: Maybe<Scalars['Uuid']>;
};


export type CorvalProjectMapUpperBoundArgs = {
  projectVersionId?: Maybe<Scalars['Uuid']>;
};


export type CorvalProjectProjectVersionHireTypesArgs = {
  projectVersionId: Scalars['Uuid'];
};


export type CorvalProjectProjectVersionsArgs = {
  where?: Maybe<CorvalProjectVersionFilterInput>;
};


export type CorvalProjectStaticBudgetArgs = {
  completionStateIn?: Maybe<Array<CorvalCompletionState>>;
  includeRecurrenceActivities: Scalars['Boolean'];
  projectVersionId: Scalars['Uuid'];
};


export type CorvalProjectStaticBudgetItemsArgs = {
  projectVersionId: Scalars['Uuid'];
};


export type CorvalProjectStaticProjectActivitiesArgs = {
  projectVersionId: Scalars['Uuid'];
};


export type CorvalProjectStaticProjectHiresArgs = {
  projectVersionId: Scalars['Uuid'];
};


export type CorvalProjectStaticProjectSubObjectivesArgs = {
  projectVersionId: Scalars['Uuid'];
};

export type CorvalProjectAccount = {
  account?: Maybe<CorvalAccount>;
  accountId: Scalars['Uuid'];
  project?: Maybe<CorvalProject>;
  projectId: Scalars['Uuid'];
  projectRole: CorvalProjectRole;
};

export type CorvalProjectAccountFilterInput = {
  account?: Maybe<CorvalAccountFilterInput>;
  accountId?: Maybe<CorvalUuidOperationFilterInput>;
  and?: Maybe<Array<CorvalProjectAccountFilterInput>>;
  or?: Maybe<Array<CorvalProjectAccountFilterInput>>;
  project?: Maybe<CorvalProjectFilterInput>;
  projectId?: Maybe<CorvalUuidOperationFilterInput>;
  projectRole?: Maybe<CorvalProjectRoleOperationFilterInput>;
};

export type CorvalProjectAnnualObjective = {
  createdBy?: Maybe<CorvalAccount>;
  createdById?: Maybe<Scalars['Uuid']>;
  createdUtc: Scalars['DateTime'];
  description: Scalars['String'];
  project?: Maybe<CorvalProject>;
  projectId: Scalars['Uuid'];
  updatedBy?: Maybe<CorvalAccount>;
  updatedById?: Maybe<Scalars['Uuid']>;
  updatedUtc: Scalars['DateTime'];
  year: Scalars['Int'];
};

export type CorvalProjectAnnualObjectiveCreateCommandInput = {
  description: Scalars['String'];
  projectId: Scalars['Uuid'];
  year: Scalars['Int'];
};

export type CorvalProjectAnnualObjectiveDeleteCommandInput = {
  projectId: Scalars['Uuid'];
  year: Scalars['Int'];
};

export type CorvalProjectAnnualObjectiveFilterInput = {
  and?: Maybe<Array<CorvalProjectAnnualObjectiveFilterInput>>;
  createdBy?: Maybe<CorvalAccountFilterInput>;
  createdById?: Maybe<CorvalUuidOperationFilterInput>;
  createdUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  description?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalProjectAnnualObjectiveFilterInput>>;
  project?: Maybe<CorvalProjectFilterInput>;
  projectId?: Maybe<CorvalUuidOperationFilterInput>;
  rowVersion?: Maybe<CorvalListByteOperationFilterInput>;
  updatedBy?: Maybe<CorvalAccountFilterInput>;
  updatedById?: Maybe<CorvalUuidOperationFilterInput>;
  updatedUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  year?: Maybe<CorvalIntOperationFilterInput>;
};

export type CorvalProjectAnnualObjectiveUpdateCommandInput = {
  description: Scalars['String'];
  projectId: Scalars['Uuid'];
  year: Scalars['Int'];
};

export type CorvalProjectAssumptionsQueryInput = {
  projectId: Scalars['Uuid'];
  restrictToCategoryId?: Maybe<Scalars['Uuid']>;
  restrictToDiscovery: Scalars['Boolean'];
};

export type CorvalProjectAssumptionsQueryResponse = {
  assumptions: Array<CorvalAssumption>;
  unansweredQuestions: Array<CorvalResult>;
};

export type CorvalProjectCloneCommandInput = {
  cloneId: Scalars['Uuid'];
  cloneName?: Maybe<Scalars['String']>;
  fullClone: Scalars['Boolean'];
  id: Scalars['Uuid'];
};

export type CorvalProjectCreateCommandInput = {
  assetIndication: Scalars['String'];
  assetName: Scalars['String'];
  id: Scalars['Uuid'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  organizationId: Scalars['Uuid'];
  projectMembers: Array<CorvalProjectCreateCommandMemberItemInput>;
  termDictionary: Scalars['String'];
};

export type CorvalProjectCreateCommandMemberItemInput = {
  accountId: Scalars['Uuid'];
  projectRole: CorvalProjectRole;
};

export type CorvalProjectCreateFromTemplateCommandInput = {
  assetName: Scalars['String'];
  indicationName: Scalars['String'];
  organizationId: Scalars['Uuid'];
  projectMembers: Array<CorvalProjectMemberItemInput>;
  projectName: Scalars['String'];
  projectTemplateId: Scalars['Uuid'];
  startDate: Scalars['LocalDate'];
};

export type CorvalProjectFilterInput = {
  and?: Maybe<Array<CorvalProjectFilterInput>>;
  asset?: Maybe<CorvalAssetFilterInput>;
  assetId?: Maybe<CorvalUuidOperationFilterInput>;
  assumptions?: Maybe<CorvalListFilterInputTypeOfAssumptionFilterInput>;
  createdBy?: Maybe<CorvalAccountFilterInput>;
  createdById?: Maybe<CorvalUuidOperationFilterInput>;
  createdUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  isActive?: Maybe<CorvalBooleanOperationFilterInput>;
  name?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalProjectFilterInput>>;
  parentProjectId?: Maybe<CorvalUuidOperationFilterInput>;
  projectAnnualObjectives?: Maybe<CorvalListFilterInputTypeOfProjectAnnualObjectiveFilterInput>;
  projectMembers?: Maybe<CorvalListFilterInputTypeOfProjectAccountFilterInput>;
  projectWorkflowTasks?: Maybe<CorvalListFilterInputTypeOfProjectWorkflowTaskFilterInput>;
  revenue?: Maybe<CorvalDecimalOperationFilterInput>;
  rowVersion?: Maybe<CorvalListByteOperationFilterInput>;
  termDictionary?: Maybe<CorvalStringOperationFilterInput>;
  updatedBy?: Maybe<CorvalAccountFilterInput>;
  updatedById?: Maybe<CorvalUuidOperationFilterInput>;
  updatedUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
};

export type CorvalProjectMemberItemInput = {
  accountId: Scalars['Uuid'];
  projectRole: CorvalProjectRole;
};

export enum CorvalProjectRole {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Viewer = 'VIEWER'
}

export type CorvalProjectRoleOperationFilterInput = {
  eq?: Maybe<CorvalProjectRole>;
  in?: Maybe<Array<CorvalProjectRole>>;
  neq?: Maybe<CorvalProjectRole>;
  nin?: Maybe<Array<CorvalProjectRole>>;
};

export type CorvalProjectSortInput = {
  asset?: Maybe<CorvalAssetSortInput>;
  assetId?: Maybe<CorvalSortEnumType>;
  createdBy?: Maybe<CorvalAccountSortInput>;
  createdById?: Maybe<CorvalSortEnumType>;
  createdUtc?: Maybe<CorvalSortEnumType>;
  id?: Maybe<CorvalSortEnumType>;
  isActive?: Maybe<CorvalSortEnumType>;
  name?: Maybe<CorvalSortEnumType>;
  parentProjectId?: Maybe<CorvalSortEnumType>;
  revenue?: Maybe<CorvalSortEnumType>;
  termDictionary?: Maybe<CorvalSortEnumType>;
  updatedBy?: Maybe<CorvalAccountSortInput>;
  updatedById?: Maybe<CorvalSortEnumType>;
  updatedUtc?: Maybe<CorvalSortEnumType>;
};

export type CorvalProjectTemplate = {
  category: Scalars['String'];
  description: Scalars['String'];
  endDate?: Maybe<Scalars['LocalDate']>;
  icon: Scalars['String'];
  id: Scalars['Uuid'];
  isArchived: Scalars['Boolean'];
  milestones: Array<CorvalProjectVersionMilestone>;
  name: Scalars['String'];
  organizations: Array<CorvalProjectTemplateOrganization>;
  project: CorvalProject;
  projectVersion: CorvalProjectVersion;
  sourceProjectId: Scalars['Uuid'];
  sourceProjectVersionId: Scalars['Uuid'];
  startDate?: Maybe<Scalars['LocalDate']>;
  tags: Array<CorvalProjectTemplateTag>;
};

export type CorvalProjectTemplateCreateCommandInput = {
  category: Scalars['String'];
  cloneSourceProject: Scalars['Boolean'];
  description: Scalars['String'];
  icon: Scalars['String'];
  name: Scalars['String'];
  organizationIds: Array<Scalars['Uuid']>;
  projectId: Scalars['Uuid'];
  projectMembers: Array<CorvalTemplateProjectMemberItemInput>;
  projectVersionId: Scalars['Uuid'];
  tags: Array<Scalars['String']>;
};

export type CorvalProjectTemplateOrganization = {
  organizationId: Scalars['Uuid'];
  projectTemplateId: Scalars['Uuid'];
};

export type CorvalProjectTemplateTag = {
  projectTemplateId: Scalars['Uuid'];
  tag: Scalars['String'];
};

export type CorvalProjectTemplateUpdateCommandInput = {
  category: Scalars['String'];
  description: Scalars['String'];
  icon: Scalars['String'];
  id: Scalars['Uuid'];
  isArchived: Scalars['Boolean'];
  name: Scalars['String'];
  organizationIds: Array<Scalars['Uuid']>;
  projectMembers: Array<CorvalTemplateProjectMemberItemInput>;
  projectVersionId: Scalars['Uuid'];
  tags: Array<Scalars['String']>;
};

export type CorvalProjectUpdateCommandInput = {
  assetId: Scalars['Uuid'];
  assetIndication: Scalars['String'];
  assetName: Scalars['String'];
  id: Scalars['Uuid'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  organizationId: Scalars['Uuid'];
  projectMembers: Array<CorvalProjectUpdateCommandMemberItemInput>;
  revenue?: Maybe<Scalars['Decimal']>;
  termDictionary: Scalars['String'];
};

export type CorvalProjectUpdateCommandMemberItemInput = {
  accountId: Scalars['Uuid'];
  projectRole: CorvalProjectRole;
};

export type CorvalProjectVersion = {
  budgetItems: Array<CorvalStaticProjectBudgetItem>;
  createdBy?: Maybe<CorvalAccount>;
  createdById?: Maybe<Scalars['Uuid']>;
  createdUtc: Scalars['DateTime'];
  description: Scalars['String'];
  endDateUtc?: Maybe<Scalars['DateTime']>;
  ganttDependencies: Array<CorvalGanttDependency>;
  ganttMilestoneTasks: Array<CorvalProjectVersionMilestone>;
  ganttTasks: Array<CorvalStaticProjectActivity>;
  hires: Array<CorvalStaticProjectHire>;
  hireTypes: Array<CorvalProjectVersionHireType>;
  id: Scalars['Uuid'];
  isActiveVersion: Scalars['Boolean'];
  isDefaultVersion: Scalars['Boolean'];
  isImmutableBase: Scalars['Boolean'];
  mapLowerBound: Scalars['LocalDate'];
  mapUpperBound: Scalars['LocalDate'];
  name: Scalars['String'];
  project?: Maybe<CorvalProject>;
  projectId: Scalars['Uuid'];
  projectVersionMilestones?: Maybe<Array<Maybe<CorvalProjectVersionMilestone>>>;
  startDateUtc?: Maybe<Scalars['DateTime']>;
  staticProjectActivities?: Maybe<Array<Maybe<CorvalStaticProjectActivity>>>;
  staticProjectSubObjectives: Array<CorvalStaticProjectSubObjective>;
  updatedBy?: Maybe<CorvalAccount>;
  updatedById?: Maybe<Scalars['Uuid']>;
  updatedUtc: Scalars['DateTime'];
};

export type CorvalProjectVersionAddSubObjectivesCommandInput = {
  activateTiming: Scalars['Boolean'];
  sourceProjectVersionId?: Maybe<Scalars['Uuid']>;
  subObjectiveCategoryItems: Array<CorvalSubObjectiveCategoryItemInput>;
  targetProjectVersionId: Scalars['Uuid'];
};

export type CorvalProjectVersionAddSubObjectivesCommandResponse = {
  ganttDependencies: Array<CorvalGanttDependency>;
  staticProjectActivities: Array<CorvalStaticProjectActivity>;
};

export type CorvalProjectVersionBudgetQueryResponse = {
  feeBasedCostOccurrences: Array<CorvalStaticCostOccurrenceFee>;
  resourceCostOccurrences: Array<CorvalStaticCostOccurrenceResource>;
};

export type CorvalProjectVersionCreateCommandInput = {
  description: Scalars['String'];
  name: Scalars['String'];
  projectId: Scalars['Uuid'];
  sourceProjectVersionId: Scalars['Uuid'];
};

export type CorvalProjectVersionDeleteCommandInput = {
  projectVersionId: Scalars['Uuid'];
};

export type CorvalProjectVersionFilterInput = {
  and?: Maybe<Array<CorvalProjectVersionFilterInput>>;
  budgetItems?: Maybe<CorvalListFilterInputTypeOfStaticProjectBudgetItemFilterInput>;
  createdBy?: Maybe<CorvalAccountFilterInput>;
  createdById?: Maybe<CorvalUuidOperationFilterInput>;
  createdUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  description?: Maybe<CorvalStringOperationFilterInput>;
  endDateUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  hires?: Maybe<CorvalListFilterInputTypeOfStaticProjectHireFilterInput>;
  hireTypes?: Maybe<CorvalListFilterInputTypeOfProjectVersionHireTypeFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  isActiveVersion?: Maybe<CorvalBooleanOperationFilterInput>;
  isDefaultVersion?: Maybe<CorvalBooleanOperationFilterInput>;
  isImmutableBase?: Maybe<CorvalBooleanOperationFilterInput>;
  name?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalProjectVersionFilterInput>>;
  project?: Maybe<CorvalProjectFilterInput>;
  projectId?: Maybe<CorvalUuidOperationFilterInput>;
  projectVersionMilestones?: Maybe<CorvalListFilterInputTypeOfProjectVersionMilestoneFilterInput>;
  rowVersion?: Maybe<CorvalListByteOperationFilterInput>;
  startDateUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  staticProjectActivities?: Maybe<CorvalListFilterInputTypeOfStaticProjectActivityFilterInput>;
  staticProjectSubObjectives?: Maybe<CorvalListFilterInputTypeOfStaticProjectSubObjectiveFilterInput>;
  updatedBy?: Maybe<CorvalAccountFilterInput>;
  updatedById?: Maybe<CorvalUuidOperationFilterInput>;
  updatedUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
};

export type CorvalProjectVersionHireType = {
  actualHeadcount: Scalars['Int'];
  businessFunction?: Maybe<CorvalBusinessFunction>;
  businessFunctionId: Scalars['Uuid'];
  description: Scalars['String'];
  descriptionOverride?: Maybe<Scalars['String']>;
  hires: Array<CorvalStaticProjectHire>;
  hireType: CorvalHireType;
  hireTypeId: Scalars['Uuid'];
  id: Scalars['Uuid'];
  managingHireType?: Maybe<CorvalProjectVersionHireType>;
  managingHireTypeId?: Maybe<Scalars['Uuid']>;
  modifier: Scalars['Int'];
  name: Scalars['String'];
  nameOverride?: Maybe<Scalars['String']>;
  note: Scalars['String'];
  projectVersionId: Scalars['Uuid'];
  recommendedHeadcount: Scalars['Int'];
  recommendedModifier: Scalars['Int'];
  recommendedSalary: Scalars['Int'];
  resourceCode: Scalars['String'];
  salary: Scalars['Int'];
};

export type CorvalProjectVersionHireTypeFilterInput = {
  and?: Maybe<Array<CorvalProjectVersionHireTypeFilterInput>>;
  businessFunctionId?: Maybe<CorvalUuidOperationFilterInput>;
  description?: Maybe<CorvalStringOperationFilterInput>;
  hireTypeId?: Maybe<CorvalUuidOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  managingHireTypeId?: Maybe<CorvalUuidOperationFilterInput>;
  modifier?: Maybe<CorvalIntOperationFilterInput>;
  name?: Maybe<CorvalStringOperationFilterInput>;
  note?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalProjectVersionHireTypeFilterInput>>;
  projectVersionId?: Maybe<CorvalUuidOperationFilterInput>;
  resourceCode?: Maybe<CorvalStringOperationFilterInput>;
  salary?: Maybe<CorvalIntOperationFilterInput>;
};

export type CorvalProjectVersionHireTypeUpdateCommandInput = {
  businessFunctionId: Scalars['Uuid'];
  description: Scalars['String'];
  hires: Array<CorvalHireItemInput>;
  hireTypeId: Scalars['Uuid'];
  modifier: Scalars['Int'];
  name: Scalars['String'];
  projectVersionId: Scalars['Uuid'];
  salary: Scalars['Int'];
};

export type CorvalProjectVersionMilestone = {
  colorValue: Scalars['String'];
  createdBy?: Maybe<CorvalAccount>;
  createdById?: Maybe<Scalars['Uuid']>;
  createdUtc: Scalars['DateTime'];
  description: Scalars['String'];
  iconName: Scalars['String'];
  id: Scalars['Uuid'];
  milestoneDate: Scalars['LocalDate'];
  milestoneId?: Maybe<Scalars['Uuid']>;
  name: Scalars['String'];
  projectVersionId: Scalars['Uuid'];
  updatedBy?: Maybe<CorvalAccount>;
  updatedById?: Maybe<Scalars['Uuid']>;
  updatedUtc: Scalars['DateTime'];
};

export type CorvalProjectVersionMilestoneFilterInput = {
  and?: Maybe<Array<CorvalProjectVersionMilestoneFilterInput>>;
  colorValue?: Maybe<CorvalStringOperationFilterInput>;
  createdBy?: Maybe<CorvalAccountFilterInput>;
  createdById?: Maybe<CorvalUuidOperationFilterInput>;
  createdUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  description?: Maybe<CorvalStringOperationFilterInput>;
  iconName?: Maybe<CorvalStringOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  milestoneDate?: Maybe<CorvalLocalDateFilterInput>;
  milestoneId?: Maybe<CorvalUuidOperationFilterInput>;
  name?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalProjectVersionMilestoneFilterInput>>;
  projectVersionId?: Maybe<CorvalUuidOperationFilterInput>;
  rowVersion?: Maybe<CorvalListByteOperationFilterInput>;
  updatedBy?: Maybe<CorvalAccountFilterInput>;
  updatedById?: Maybe<CorvalUuidOperationFilterInput>;
  updatedUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
};

export type CorvalProjectVersionSortInput = {
  createdBy?: Maybe<CorvalAccountSortInput>;
  createdById?: Maybe<CorvalSortEnumType>;
  createdUtc?: Maybe<CorvalSortEnumType>;
  description?: Maybe<CorvalSortEnumType>;
  endDateUtc?: Maybe<CorvalSortEnumType>;
  id?: Maybe<CorvalSortEnumType>;
  isActiveVersion?: Maybe<CorvalSortEnumType>;
  isDefaultVersion?: Maybe<CorvalSortEnumType>;
  isImmutableBase?: Maybe<CorvalSortEnumType>;
  name?: Maybe<CorvalSortEnumType>;
  project?: Maybe<CorvalProjectSortInput>;
  projectId?: Maybe<CorvalSortEnumType>;
  startDateUtc?: Maybe<CorvalSortEnumType>;
  updatedBy?: Maybe<CorvalAccountSortInput>;
  updatedById?: Maybe<CorvalSortEnumType>;
  updatedUtc?: Maybe<CorvalSortEnumType>;
};

export type CorvalProjectVersionUpdateCommandInput = {
  description: Scalars['String'];
  isActiveVersion: Scalars['Boolean'];
  name: Scalars['String'];
  projectVersionId: Scalars['Uuid'];
};

export type CorvalProjectVersionUpdateDataCommandInput = {
  activityChanges?: Maybe<CorvalChangesetOfAddActivityItemAndUpdateActivityItemInput>;
  categoryChanges?: Maybe<CorvalChangesetOfAddCategoryItemAndUpdateCategoryItemInput>;
  dependencyChanges?: Maybe<CorvalChangesetOfAddDependencyItemAndUpdateDependencyItemInput>;
  eventChanges?: Maybe<CorvalChangesetOfAddEventItemAndUpdateEventItemInput>;
  projectVersionId: Scalars['Uuid'];
  subCategoryChanges?: Maybe<CorvalChangesetOfAddSubCategoryItemAndUpdateSubCategoryItemInput>;
  subObjectiveChanges?: Maybe<CorvalChangesetOfAddSubObjectiveItemAndUpdateSubObjectiveItemInput>;
};

export type CorvalProjectVersionUpdateDataCommandResponse = {
  invalidActivityIds: Array<Scalars['Uuid']>;
  invalidCategoryIds: Array<Scalars['Uuid']>;
  invalidDependencyIds: Array<Scalars['Uuid']>;
  invalidEventIds: Array<Scalars['Uuid']>;
  invalidSubCategoryIds: Array<Scalars['Uuid']>;
  invalidSubObjectiveIds: Array<Scalars['Uuid']>;
  success: Scalars['Boolean'];
};

export type CorvalProjectWorkflowTask = {
  assignedAccount?: Maybe<CorvalAccount>;
  assignedAccountId?: Maybe<Scalars['Uuid']>;
  auditEntries?: Maybe<Array<Maybe<CorvalAuditEntry>>>;
  completedUtc?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<CorvalAccount>;
  createdById?: Maybe<Scalars['Uuid']>;
  createdUtc: Scalars['DateTime'];
  id: Scalars['Uuid'];
  project?: Maybe<CorvalProject>;
  projectId: Scalars['Uuid'];
  updatedBy?: Maybe<CorvalAccount>;
  updatedById?: Maybe<Scalars['Uuid']>;
  updatedUtc: Scalars['DateTime'];
  workflowActionStatus: CorvalWorkflowActionStatus;
  workflowTask?: Maybe<CorvalWorkflowTask>;
  workflowTaskId: Scalars['Uuid'];
};

export type CorvalProjectWorkflowTaskFilterInput = {
  and?: Maybe<Array<CorvalProjectWorkflowTaskFilterInput>>;
  assignedAccountId?: Maybe<CorvalUuidOperationFilterInput>;
  completedUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  createdBy?: Maybe<CorvalAccountFilterInput>;
  createdById?: Maybe<CorvalUuidOperationFilterInput>;
  createdUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  or?: Maybe<Array<CorvalProjectWorkflowTaskFilterInput>>;
  project?: Maybe<CorvalProjectFilterInput>;
  projectId?: Maybe<CorvalUuidOperationFilterInput>;
  rowVersion?: Maybe<CorvalListByteOperationFilterInput>;
  updatedBy?: Maybe<CorvalAccountFilterInput>;
  updatedById?: Maybe<CorvalUuidOperationFilterInput>;
  updatedUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  workflowActionStatus?: Maybe<CorvalWorkflowActionStatusOperationFilterInput>;
  workflowTask?: Maybe<CorvalWorkflowTaskFilterInput>;
  workflowTaskId?: Maybe<CorvalUuidOperationFilterInput>;
};

export type CorvalProjectWorkflowTaskReassignCommandInput = {
  assignedAccountId?: Maybe<Scalars['Uuid']>;
  projectWorkflowTaskId: Scalars['Uuid'];
};

export type CorvalProjectWorkflowTaskUpdateActionStatusCommandInput = {
  projectWorkflowTaskId: Scalars['Uuid'];
  workflowActionStatus: CorvalWorkflowActionStatus;
};

export type CorvalQuery = {
  accounts: Array<CorvalAccount>;
  activities: Array<CorvalActivity>;
  activityCategories: Array<CorvalCategory>;
  activityRelationshipLoops: CorvalActivityDetectParentChildLoopsCommandResult;
  assumptionGroups: Array<CorvalAssumptionGroup>;
  assumptions: Array<CorvalAssumption>;
  auditEntries: Array<CorvalAuditEntry>;
  businessFunctions: Array<CorvalBusinessFunction>;
  categories: Array<CorvalCategory>;
  category?: Maybe<CorvalCategory>;
  dataValueSet?: Maybe<CorvalDataValueSet>;
  dataValueSets: Array<CorvalDataValueSet>;
  hireTypes: Array<CorvalHireType>;
  intakeQuestion?: Maybe<CorvalIntakeQuestion>;
  intakeQuestions: Array<CorvalIntakeQuestion>;
  me: CorvalAccount;
  milestones: Array<CorvalMilestone>;
  missingSubObjectivesForProjectVersion: Array<CorvalSubObjective>;
  objective?: Maybe<CorvalObjective>;
  objectives: Array<CorvalObjective>;
  organizations: Array<CorvalOrganization>;
  professionalFees: Array<CorvalProfessionalFee>;
  projectAnnualObjective?: Maybe<CorvalProjectAnnualObjective>;
  projectAnnualObjectives: Array<CorvalProjectAnnualObjective>;
  projectAssumptions: CorvalProjectAssumptionsQueryResponse;
  projects: Array<CorvalProject>;
  projectTemplate?: Maybe<CorvalProjectTemplate>;
  staticProjectActivities: Array<CorvalStaticProjectActivity>;
  staticProjectSubObjectives: Array<CorvalStaticProjectSubObjective>;
  strategicAssumptionTemplate: CorvalStrategicAssumptionTemplate;
  subCategories: Array<CorvalSubCategory>;
  subObjective?: Maybe<CorvalSubObjective>;
  subObjectives: Array<CorvalSubObjective>;
  subObjectivesForAnswer: CorvalSubObjectivesForAnswersQueryResponse;
  tags: Array<CorvalTag>;
  unansweredIntakeQuestions: CorvalIntakeQuestionUnansweredQueryResponse;
  workflowTasks: Array<CorvalWorkflowTask>;
};


export type CorvalQueryAccountsArgs = {
  order?: Maybe<Array<CorvalAccountSortInput>>;
  where?: Maybe<CorvalAccountFilterInput>;
};


export type CorvalQueryActivitiesArgs = {
  order?: Maybe<Array<CorvalActivitySortInput>>;
  projectId?: Maybe<Scalars['Uuid']>;
  where?: Maybe<CorvalActivityFilterInput>;
};


export type CorvalQueryActivityCategoriesArgs = {
  input: CorvalActivityCategoriesQueryInput;
  order?: Maybe<Array<CorvalCategorySortInput>>;
};


export type CorvalQueryActivityRelationshipLoopsArgs = {
  childActivityIds: Array<Scalars['Uuid']>;
  parentActivityIds: Array<Scalars['Uuid']>;
  tracePaths: Scalars['Boolean'];
};


export type CorvalQueryAssumptionGroupsArgs = {
  order?: Maybe<Array<CorvalAssumptionGroupSortInput>>;
  where?: Maybe<CorvalAssumptionGroupFilterInput>;
};


export type CorvalQueryAssumptionsArgs = {
  order?: Maybe<Array<CorvalAssumptionSortInput>>;
  where?: Maybe<CorvalAssumptionFilterInput>;
};


export type CorvalQueryAuditEntriesArgs = {
  order?: Maybe<Array<CorvalAuditEntrySortInput>>;
  where?: Maybe<CorvalAuditEntryFilterInput>;
};


export type CorvalQueryBusinessFunctionsArgs = {
  order?: Maybe<Array<CorvalBusinessFunctionSortInput>>;
  where?: Maybe<CorvalBusinessFunctionFilterInput>;
};


export type CorvalQueryCategoriesArgs = {
  order?: Maybe<Array<CorvalCategorySortInput>>;
  where?: Maybe<CorvalCategoryFilterInput>;
};


export type CorvalQueryCategoryArgs = {
  id: Scalars['Uuid'];
};


export type CorvalQueryDataValueSetArgs = {
  id: Scalars['Uuid'];
};


export type CorvalQueryDataValueSetsArgs = {
  order?: Maybe<Array<CorvalDataValueSetSortInput>>;
  where?: Maybe<CorvalDataValueSetFilterInput>;
};


export type CorvalQueryHireTypesArgs = {
  order?: Maybe<Array<CorvalHireTypeSortInput>>;
  where?: Maybe<CorvalHireTypeFilterInput>;
};


export type CorvalQueryIntakeQuestionArgs = {
  id: Scalars['Uuid'];
};


export type CorvalQueryIntakeQuestionsArgs = {
  order?: Maybe<Array<CorvalIntakeQuestionSortInput>>;
  where?: Maybe<CorvalIntakeQuestionFilterInput>;
};


export type CorvalQueryMilestonesArgs = {
  order?: Maybe<Array<CorvalMilestoneSortInput>>;
  where?: Maybe<CorvalMilestoneFilterInput>;
};


export type CorvalQueryMissingSubObjectivesForProjectVersionArgs = {
  projectVersionId: Scalars['Uuid'];
};


export type CorvalQueryObjectiveArgs = {
  id: Scalars['Uuid'];
};


export type CorvalQueryObjectivesArgs = {
  order?: Maybe<Array<CorvalObjectiveSortInput>>;
  where?: Maybe<CorvalObjectiveFilterInput>;
};


export type CorvalQueryOrganizationsArgs = {
  order?: Maybe<Array<CorvalOrganizationSortInput>>;
  where?: Maybe<CorvalOrganizationFilterInput>;
};


export type CorvalQueryProfessionalFeesArgs = {
  order?: Maybe<Array<CorvalProfessionalFeeSortInput>>;
  where?: Maybe<CorvalProfessionalFeeFilterInput>;
};


export type CorvalQueryProjectAnnualObjectiveArgs = {
  projectId: Scalars['Uuid'];
  year: Scalars['Int'];
};


export type CorvalQueryProjectAnnualObjectivesArgs = {
  projectId: Scalars['Uuid'];
};


export type CorvalQueryProjectAssumptionsArgs = {
  input: CorvalProjectAssumptionsQueryInput;
};


export type CorvalQueryProjectsArgs = {
  order?: Maybe<Array<CorvalProjectSortInput>>;
  where?: Maybe<CorvalProjectFilterInput>;
};


export type CorvalQueryProjectTemplateArgs = {
  projectTemplateId: Scalars['Uuid'];
};


export type CorvalQueryStaticProjectActivitiesArgs = {
  endTimeUtc?: Maybe<Scalars['DateTime']>;
  order?: Maybe<Array<CorvalStaticProjectActivitySortInput>>;
  projectVersionId: Scalars['Uuid'];
  startTimeUtc?: Maybe<Scalars['DateTime']>;
  where?: Maybe<CorvalStaticProjectActivityFilterInput>;
};


export type CorvalQueryStaticProjectSubObjectivesArgs = {
  order?: Maybe<Array<CorvalStaticProjectSubObjectiveSortInput>>;
  projectVersionId: Scalars['Uuid'];
  where?: Maybe<CorvalStaticProjectSubObjectiveFilterInput>;
};


export type CorvalQuerySubCategoriesArgs = {
  order?: Maybe<Array<CorvalSubCategorySortInput>>;
  where?: Maybe<CorvalSubCategoryFilterInput>;
};


export type CorvalQuerySubObjectiveArgs = {
  id: Scalars['Uuid'];
};


export type CorvalQuerySubObjectivesArgs = {
  input: CorvalSubObjectiveSearchQueryInput;
  order?: Maybe<Array<CorvalSubObjectiveSortInput>>;
  where?: Maybe<CorvalSubObjectiveFilterInput>;
};


export type CorvalQuerySubObjectivesForAnswerArgs = {
  input: CorvalSubObjectivesForAnswersQueryInput;
};


export type CorvalQueryTagsArgs = {
  order?: Maybe<Array<CorvalTagSortInput>>;
  where?: Maybe<CorvalTagFilterInput>;
};


export type CorvalQueryUnansweredIntakeQuestionsArgs = {
  input: CorvalIntakeQuestionUnansweredQueryInput;
};


export type CorvalQueryWorkflowTasksArgs = {
  order?: Maybe<Array<CorvalWorkflowTaskSortInput>>;
  where?: Maybe<CorvalWorkflowTaskFilterInput>;
};

export enum CorvalQuestionContextEnum {
  Additive = 'ADDITIVE',
  Core = 'CORE',
  Project = 'PROJECT'
}

export type CorvalQuestionContextEnumOperationFilterInput = {
  eq?: Maybe<CorvalQuestionContextEnum>;
  in?: Maybe<Array<CorvalQuestionContextEnum>>;
  neq?: Maybe<CorvalQuestionContextEnum>;
  nin?: Maybe<Array<CorvalQuestionContextEnum>>;
};

export enum CorvalQuestionInputTypeEnum {
  Boolean = 'BOOLEAN',
  Choicemultiple = 'CHOICEMULTIPLE',
  Choicesingle = 'CHOICESINGLE',
  Date = 'DATE',
  Daterange = 'DATERANGE',
  Number = 'NUMBER',
  Textmultiline = 'TEXTMULTILINE',
  Textsingleline = 'TEXTSINGLELINE'
}

export type CorvalQuestionInputTypeEnumOperationFilterInput = {
  eq?: Maybe<CorvalQuestionInputTypeEnum>;
  in?: Maybe<Array<CorvalQuestionInputTypeEnum>>;
  neq?: Maybe<CorvalQuestionInputTypeEnum>;
  nin?: Maybe<Array<CorvalQuestionInputTypeEnum>>;
};

export type CorvalQuickLink = {
  activity?: Maybe<CorvalActivity>;
  activityId: Scalars['Uuid'];
  createdBy?: Maybe<CorvalAccount>;
  createdById?: Maybe<Scalars['Uuid']>;
  createdUtc: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['Uuid'];
  ordinal: Scalars['Int'];
  text: Scalars['String'];
  updatedBy?: Maybe<CorvalAccount>;
  updatedById?: Maybe<Scalars['Uuid']>;
  updatedUtc: Scalars['DateTime'];
  url: Scalars['String'];
};

export type CorvalQuickLinkFilterInput = {
  activity?: Maybe<CorvalActivityFilterInput>;
  activityId?: Maybe<CorvalUuidOperationFilterInput>;
  and?: Maybe<Array<CorvalQuickLinkFilterInput>>;
  createdBy?: Maybe<CorvalAccountFilterInput>;
  createdById?: Maybe<CorvalUuidOperationFilterInput>;
  createdUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  description?: Maybe<CorvalStringOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  or?: Maybe<Array<CorvalQuickLinkFilterInput>>;
  ordinal?: Maybe<CorvalIntOperationFilterInput>;
  rowVersion?: Maybe<CorvalListByteOperationFilterInput>;
  text?: Maybe<CorvalStringOperationFilterInput>;
  updatedBy?: Maybe<CorvalAccountFilterInput>;
  updatedById?: Maybe<CorvalUuidOperationFilterInput>;
  updatedUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  url?: Maybe<CorvalStringOperationFilterInput>;
};

export type CorvalRequiredHireTypeItemInput = {
  headcount: Scalars['Int'];
  hireTypeId: Scalars['Uuid'];
};

export type CorvalResult = {
  description: Scalars['String'];
  intakeQuestion?: Maybe<CorvalIntakeQuestion>;
  triggeringCondition?: Maybe<CorvalIntakeQuestionCondition>;
};

export type CorvalScheduledBudgetItem = {
  amount: Scalars['Int'];
  costType: Scalars['String'];
  createdBy?: Maybe<CorvalAccount>;
  createdById?: Maybe<Scalars['Uuid']>;
  createdUtc: Scalars['DateTime'];
  durationDays: Scalars['Int'];
  id: Scalars['Uuid'];
  name: Scalars['String'];
  note: Scalars['String'];
  objectId: Scalars['Uuid'];
  objectType: Scalars['String'];
  offsetDays: Scalars['Int'];
  projectVersionId: Scalars['Uuid'];
  quarter: Scalars['Int'];
  rowVersion?: Maybe<Array<Scalars['Byte']>>;
  staticProjectActivityId: Scalars['Uuid'];
  updatedBy?: Maybe<CorvalAccount>;
  updatedById?: Maybe<Scalars['Uuid']>;
  updatedUtc: Scalars['DateTime'];
  year: Scalars['Int'];
};

export type CorvalScheduledBudgetItemFilterInput = {
  amount?: Maybe<CorvalIntOperationFilterInput>;
  and?: Maybe<Array<CorvalScheduledBudgetItemFilterInput>>;
  costType?: Maybe<CorvalStringOperationFilterInput>;
  createdBy?: Maybe<CorvalAccountFilterInput>;
  createdById?: Maybe<CorvalUuidOperationFilterInput>;
  createdUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  durationDays?: Maybe<CorvalIntOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  name?: Maybe<CorvalStringOperationFilterInput>;
  note?: Maybe<CorvalStringOperationFilterInput>;
  objectId?: Maybe<CorvalUuidOperationFilterInput>;
  objectType?: Maybe<CorvalStringOperationFilterInput>;
  offsetDays?: Maybe<CorvalIntOperationFilterInput>;
  or?: Maybe<Array<CorvalScheduledBudgetItemFilterInput>>;
  projectVersionId?: Maybe<CorvalUuidOperationFilterInput>;
  rowVersion?: Maybe<CorvalListByteOperationFilterInput>;
  staticProjectActivityId?: Maybe<CorvalUuidOperationFilterInput>;
  updatedBy?: Maybe<CorvalAccountFilterInput>;
  updatedById?: Maybe<CorvalUuidOperationFilterInput>;
  updatedUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
};

export type CorvalScheduledBudgetItemInput = {
  amount: Scalars['Int'];
  id: Scalars['Uuid'];
  name: Scalars['String'];
  note: Scalars['String'];
  quarter: Scalars['Int'];
  year: Scalars['Int'];
};

export enum CorvalSortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type CorvalStaticCostOccurrenceFee = {
  category: CorvalCategory;
  costAmount: Scalars['Decimal'];
  costAmountRange: CorvalMinMaxOfDecimal;
  costAmountType: CorvalCostOccurrenceFeeType;
  costOccurrence: Scalars['LocalDate'];
  instanceType: CorvalCostOccurenceType;
  isCustomValue: Scalars['Boolean'];
  isOngoingOccurrence: Scalars['Boolean'];
  itemData?: Maybe<CorvalStaticCostOccurrenceFeeItemDataType>;
};

export type CorvalStaticCostOccurrenceFeeItemDataType = CorvalStaticProjectActivity | CorvalStaticProjectBudgetItem;

export type CorvalStaticCostOccurrenceResource = {
  hireTypeBusinessFunction: CorvalBusinessFunction;
  hireTypeBusinessFunctionId: Scalars['Uuid'];
  hireTypeId: Scalars['Uuid'];
  isInitialHireOccurrence: Scalars['Boolean'];
  quarterlyCompensation: Scalars['Decimal'];
  resourceCostOccurrence: Scalars['LocalDate'];
  staticProjectHire: CorvalStaticProjectHire;
};

export type CorvalStaticProjectActivity = {
  activity?: Maybe<CorvalActivity>;
  activityDescription: Scalars['String'];
  activityId?: Maybe<Scalars['Uuid']>;
  activityName: Scalars['String'];
  assigneeAccountId?: Maybe<Scalars['Uuid']>;
  auditEntries?: Maybe<Array<Maybe<CorvalAuditEntry>>>;
  businessFunction?: Maybe<CorvalBusinessFunction>;
  businessFunctionId: Scalars['Uuid'];
  categoryDescription: Scalars['String'];
  categoryId: Scalars['Uuid'];
  categoryName: Scalars['String'];
  categoryOrdinal: Scalars['Int'];
  childProjectActivities?: Maybe<Array<Maybe<CorvalStaticProjectActivity>>>;
  childRelationships: Array<CorvalStaticProjectActivityRelationship>;
  completionState: CorvalCompletionState;
  constraintDate?: Maybe<Scalars['LocalDate']>;
  constraintType?: Maybe<CorvalConstraintType>;
  corvalType: CorvalGanttCorvalType;
  createdBy?: Maybe<CorvalAccount>;
  createdById?: Maybe<Scalars['Uuid']>;
  createdUtc: Scalars['DateTime'];
  criticality: CorvalCriticality;
  deadlineDate?: Maybe<Scalars['LocalDate']>;
  description: Scalars['String'];
  displayName?: Maybe<Scalars['String']>;
  duration: Scalars['Int'];
  endDate: Scalars['LocalDate'];
  id: Scalars['Uuid'];
  isAtRisk: Scalars['Boolean'];
  manuallyScheduled: Scalars['Boolean'];
  milestoneRelationships?: Maybe<Array<Maybe<CorvalStaticProjectActivityMilestoneRelationship>>>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  ongoingCostNote?: Maybe<Scalars['String']>;
  ongoingCostPerQuarter: Scalars['Int'];
  ongoingCostQuarters: Scalars['Int'];
  operationalCost: Scalars['Int'];
  operationalCostNote?: Maybe<Scalars['String']>;
  operationalCostReplacesProfessionalFees: Scalars['Boolean'];
  parentProjectActivities?: Maybe<Array<Maybe<CorvalStaticProjectActivity>>>;
  parentRelationships: Array<CorvalStaticProjectActivityRelationship>;
  perceivedAsContinuous: Scalars['Boolean'];
  percentDone: Scalars['Int'];
  professionalFees: Array<CorvalStaticProjectProfessionalFee>;
  project?: Maybe<CorvalProject>;
  projectId: Scalars['Uuid'];
  projectVersion?: Maybe<CorvalProjectVersion>;
  projectVersionId: Scalars['Uuid'];
  requiredHires: Array<CorvalStaticProjectActivityHireType>;
  requiredHireTypes: Array<CorvalStaticProjectActivityHireType>;
  requiredProfessionalFees: Array<CorvalStaticProjectActivityProfessionalFee>;
  scheduledBudgetItems: Array<CorvalScheduledBudgetItem>;
  startDate: Scalars['LocalDate'];
  subCategoryDescription: Scalars['String'];
  subCategoryId: Scalars['Uuid'];
  subCategoryName: Scalars['String'];
  subCategoryOrdinal: Scalars['Int'];
  subObjective?: Maybe<CorvalSubObjective>;
  subObjectiveDescription: Scalars['String'];
  subObjectiveId?: Maybe<Scalars['Uuid']>;
  subObjectiveName: Scalars['String'];
  subObjectiveOrdinal: Scalars['Int'];
  updatedBy?: Maybe<CorvalAccount>;
  updatedById?: Maybe<Scalars['Uuid']>;
  updatedUtc: Scalars['DateTime'];
  watchers: Array<CorvalStaticProjectActivityAccount>;
};

export type CorvalStaticProjectActivityAccount = {
  account: CorvalAccount;
  accountId: Scalars['Uuid'];
  createdBy?: Maybe<CorvalAccount>;
  createdById?: Maybe<Scalars['Uuid']>;
  createdUtc: Scalars['DateTime'];
  id: Scalars['Uuid'];
  staticProjectActivity: CorvalStaticProjectActivity;
  staticProjectActivityId: Scalars['Uuid'];
  updatedBy?: Maybe<CorvalAccount>;
  updatedById?: Maybe<Scalars['Uuid']>;
  updatedUtc: Scalars['DateTime'];
};

export type CorvalStaticProjectActivityAccountFilterInput = {
  account?: Maybe<CorvalAccountFilterInput>;
  accountId?: Maybe<CorvalUuidOperationFilterInput>;
  and?: Maybe<Array<CorvalStaticProjectActivityAccountFilterInput>>;
  createdBy?: Maybe<CorvalAccountFilterInput>;
  createdById?: Maybe<CorvalUuidOperationFilterInput>;
  createdUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  or?: Maybe<Array<CorvalStaticProjectActivityAccountFilterInput>>;
  rowVersion?: Maybe<CorvalListByteOperationFilterInput>;
  staticProjectActivity?: Maybe<CorvalStaticProjectActivityFilterInput>;
  staticProjectActivityId?: Maybe<CorvalUuidOperationFilterInput>;
  updatedBy?: Maybe<CorvalAccountFilterInput>;
  updatedById?: Maybe<CorvalUuidOperationFilterInput>;
  updatedUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
};

export type CorvalStaticProjectActivityFilterInput = {
  activityDescription?: Maybe<CorvalStringOperationFilterInput>;
  activityId?: Maybe<CorvalUuidOperationFilterInput>;
  activityName?: Maybe<CorvalStringOperationFilterInput>;
  and?: Maybe<Array<CorvalStaticProjectActivityFilterInput>>;
  assigneeAccountId?: Maybe<CorvalUuidOperationFilterInput>;
  businessFunctionId?: Maybe<CorvalUuidOperationFilterInput>;
  categoryDescription?: Maybe<CorvalStringOperationFilterInput>;
  categoryId?: Maybe<CorvalUuidOperationFilterInput>;
  categoryName?: Maybe<CorvalStringOperationFilterInput>;
  categoryOrdinal?: Maybe<CorvalIntOperationFilterInput>;
  childRelationships?: Maybe<CorvalListFilterInputTypeOfStaticProjectActivityRelationshipFilterInput>;
  completionState?: Maybe<CorvalCompletionStateOperationFilterInput>;
  constraintDate?: Maybe<CorvalLocalDateFilterInput>;
  constraintType?: Maybe<CorvalNullableOfConstraintTypeOperationFilterInput>;
  createdBy?: Maybe<CorvalAccountFilterInput>;
  createdById?: Maybe<CorvalUuidOperationFilterInput>;
  createdUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  criticality?: Maybe<CorvalCriticalityOperationFilterInput>;
  deadlineDate?: Maybe<CorvalLocalDateFilterInput>;
  description?: Maybe<CorvalStringOperationFilterInput>;
  endDate?: Maybe<CorvalLocalDateFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  isAtRisk?: Maybe<CorvalBooleanOperationFilterInput>;
  manuallyScheduled?: Maybe<CorvalBooleanOperationFilterInput>;
  milestoneRelationships?: Maybe<CorvalListFilterInputTypeOfStaticProjectActivityMilestoneRelationshipFilterInput>;
  name?: Maybe<CorvalStringOperationFilterInput>;
  notes?: Maybe<CorvalStringOperationFilterInput>;
  ongoingCostNote?: Maybe<CorvalStringOperationFilterInput>;
  ongoingCostPerQuarter?: Maybe<CorvalIntOperationFilterInput>;
  ongoingCostQuarters?: Maybe<CorvalIntOperationFilterInput>;
  operationalCost?: Maybe<CorvalIntOperationFilterInput>;
  operationalCostNote?: Maybe<CorvalStringOperationFilterInput>;
  operationalCostReplacesProfessionalFees?: Maybe<CorvalBooleanOperationFilterInput>;
  or?: Maybe<Array<CorvalStaticProjectActivityFilterInput>>;
  parentRelationships?: Maybe<CorvalListFilterInputTypeOfStaticProjectActivityRelationshipFilterInput>;
  perceivedAsContinuous?: Maybe<CorvalBooleanOperationFilterInput>;
  percentDone?: Maybe<CorvalIntOperationFilterInput>;
  professionalFees?: Maybe<CorvalListFilterInputTypeOfStaticProjectProfessionalFeeFilterInput>;
  projectVersion?: Maybe<CorvalProjectVersionFilterInput>;
  projectVersionId?: Maybe<CorvalUuidOperationFilterInput>;
  requiredHireTypes?: Maybe<CorvalListFilterInputTypeOfStaticProjectActivityHireTypeFilterInput>;
  requiredProfessionalFees?: Maybe<CorvalListFilterInputTypeOfStaticProjectActivityProfessionalFeeFilterInput>;
  rowVersion?: Maybe<CorvalListByteOperationFilterInput>;
  scheduledBudgetItems?: Maybe<CorvalListFilterInputTypeOfScheduledBudgetItemFilterInput>;
  startDate?: Maybe<CorvalLocalDateFilterInput>;
  subCategoryDescription?: Maybe<CorvalStringOperationFilterInput>;
  subCategoryId?: Maybe<CorvalUuidOperationFilterInput>;
  subCategoryName?: Maybe<CorvalStringOperationFilterInput>;
  subCategoryOrdinal?: Maybe<CorvalIntOperationFilterInput>;
  subObjectiveDescription?: Maybe<CorvalStringOperationFilterInput>;
  subObjectiveId?: Maybe<CorvalUuidOperationFilterInput>;
  subObjectiveName?: Maybe<CorvalStringOperationFilterInput>;
  subObjectiveOrdinal?: Maybe<CorvalIntOperationFilterInput>;
  updatedBy?: Maybe<CorvalAccountFilterInput>;
  updatedById?: Maybe<CorvalUuidOperationFilterInput>;
  updatedUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  watchers?: Maybe<CorvalListFilterInputTypeOfStaticProjectActivityAccountFilterInput>;
};

export type CorvalStaticProjectActivityHireType = {
  headcount: Scalars['Int'];
  hireType: CorvalProjectVersionHireType;
  hireTypeId: Scalars['Uuid'];
  isHiringPoint: Scalars['Boolean'];
  isSatisfied: Scalars['Boolean'];
  satisfyingHires: Array<CorvalStaticProjectHire>;
  staticProjectActivityId: Scalars['Uuid'];
};


export type CorvalStaticProjectActivityHireTypeIsSatisfiedArgs = {
  staticProjectActivityId: Scalars['Uuid'];
};


export type CorvalStaticProjectActivityHireTypeSatisfyingHiresArgs = {
  staticProjectActivityId: Scalars['Uuid'];
};

export type CorvalStaticProjectActivityHireTypeFilterInput = {
  and?: Maybe<Array<CorvalStaticProjectActivityHireTypeFilterInput>>;
  headcount?: Maybe<CorvalIntOperationFilterInput>;
  hireTypeId?: Maybe<CorvalUuidOperationFilterInput>;
  isHiringPoint?: Maybe<CorvalBooleanOperationFilterInput>;
  or?: Maybe<Array<CorvalStaticProjectActivityHireTypeFilterInput>>;
  staticProjectActivityId?: Maybe<CorvalUuidOperationFilterInput>;
};

export type CorvalStaticProjectActivityMilestoneRelationship = {
  active: Scalars['Boolean'];
  id: Scalars['Uuid'];
  lag: Scalars['Int'];
  lagUnit: Scalars['String'];
  projectVersionMilestone: CorvalProjectVersionMilestone;
  projectVersionMilestoneId: Scalars['Uuid'];
  staticProjectActivity?: Maybe<CorvalStaticProjectActivity>;
  staticProjectActivityId: Scalars['Uuid'];
  type: CorvalGanttDependencyType;
};

export type CorvalStaticProjectActivityMilestoneRelationshipFilterInput = {
  active?: Maybe<CorvalBooleanOperationFilterInput>;
  and?: Maybe<Array<CorvalStaticProjectActivityMilestoneRelationshipFilterInput>>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  lag?: Maybe<CorvalIntOperationFilterInput>;
  lagUnit?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalStaticProjectActivityMilestoneRelationshipFilterInput>>;
  projectVersionMilestone?: Maybe<CorvalProjectVersionMilestoneFilterInput>;
  projectVersionMilestoneId?: Maybe<CorvalUuidOperationFilterInput>;
  staticProjectActivity?: Maybe<CorvalStaticProjectActivityFilterInput>;
  staticProjectActivityId?: Maybe<CorvalUuidOperationFilterInput>;
  type?: Maybe<CorvalGanttDependencyTypeOperationFilterInput>;
};

export type CorvalStaticProjectActivityProfessionalFee = {
  professionalFee?: Maybe<CorvalProfessionalFee>;
  professionalFeeId: Scalars['Uuid'];
  staticProjectActivityId: Scalars['Uuid'];
};

export type CorvalStaticProjectActivityProfessionalFeeFilterInput = {
  and?: Maybe<Array<CorvalStaticProjectActivityProfessionalFeeFilterInput>>;
  or?: Maybe<Array<CorvalStaticProjectActivityProfessionalFeeFilterInput>>;
  professionalFee?: Maybe<CorvalProfessionalFeeFilterInput>;
  professionalFeeId?: Maybe<CorvalUuidOperationFilterInput>;
  staticProjectActivityId?: Maybe<CorvalUuidOperationFilterInput>;
};

export type CorvalStaticProjectActivityRelationship = {
  active: Scalars['Boolean'];
  childStaticProjectActivityId: Scalars['Uuid'];
  id: Scalars['Uuid'];
  lag: Scalars['Int'];
  lagUnit: Scalars['String'];
  parentStaticProjectActivityId: Scalars['Uuid'];
  type: CorvalGanttDependencyType;
};

export type CorvalStaticProjectActivityRelationshipFilterInput = {
  active?: Maybe<CorvalBooleanOperationFilterInput>;
  and?: Maybe<Array<CorvalStaticProjectActivityRelationshipFilterInput>>;
  childStaticProjectActivityId?: Maybe<CorvalUuidOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  lag?: Maybe<CorvalIntOperationFilterInput>;
  lagUnit?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalStaticProjectActivityRelationshipFilterInput>>;
  parentStaticProjectActivityId?: Maybe<CorvalUuidOperationFilterInput>;
  type?: Maybe<CorvalGanttDependencyTypeOperationFilterInput>;
};

export type CorvalStaticProjectActivitySortInput = {
  activityDescription?: Maybe<CorvalSortEnumType>;
  activityId?: Maybe<CorvalSortEnumType>;
  activityName?: Maybe<CorvalSortEnumType>;
  assigneeAccountId?: Maybe<CorvalSortEnumType>;
  businessFunctionId?: Maybe<CorvalSortEnumType>;
  categoryDescription?: Maybe<CorvalSortEnumType>;
  categoryId?: Maybe<CorvalSortEnumType>;
  categoryName?: Maybe<CorvalSortEnumType>;
  categoryOrdinal?: Maybe<CorvalSortEnumType>;
  completionState?: Maybe<CorvalSortEnumType>;
  constraintDate?: Maybe<CorvalSortEnumType>;
  constraintType?: Maybe<CorvalSortEnumType>;
  createdBy?: Maybe<CorvalAccountSortInput>;
  createdById?: Maybe<CorvalSortEnumType>;
  createdUtc?: Maybe<CorvalSortEnumType>;
  criticality?: Maybe<CorvalSortEnumType>;
  deadlineDate?: Maybe<CorvalSortEnumType>;
  description?: Maybe<CorvalSortEnumType>;
  endDate?: Maybe<CorvalSortEnumType>;
  id?: Maybe<CorvalSortEnumType>;
  isAtRisk?: Maybe<CorvalSortEnumType>;
  manuallyScheduled?: Maybe<CorvalSortEnumType>;
  name?: Maybe<CorvalSortEnumType>;
  notes?: Maybe<CorvalSortEnumType>;
  ongoingCostNote?: Maybe<CorvalSortEnumType>;
  ongoingCostPerQuarter?: Maybe<CorvalSortEnumType>;
  ongoingCostQuarters?: Maybe<CorvalSortEnumType>;
  operationalCost?: Maybe<CorvalSortEnumType>;
  operationalCostNote?: Maybe<CorvalSortEnumType>;
  operationalCostReplacesProfessionalFees?: Maybe<CorvalSortEnumType>;
  perceivedAsContinuous?: Maybe<CorvalSortEnumType>;
  percentDone?: Maybe<CorvalSortEnumType>;
  projectVersion?: Maybe<CorvalProjectVersionSortInput>;
  projectVersionId?: Maybe<CorvalSortEnumType>;
  startDate?: Maybe<CorvalSortEnumType>;
  subCategoryDescription?: Maybe<CorvalSortEnumType>;
  subCategoryId?: Maybe<CorvalSortEnumType>;
  subCategoryName?: Maybe<CorvalSortEnumType>;
  subCategoryOrdinal?: Maybe<CorvalSortEnumType>;
  subObjectiveDescription?: Maybe<CorvalSortEnumType>;
  subObjectiveId?: Maybe<CorvalSortEnumType>;
  subObjectiveName?: Maybe<CorvalSortEnumType>;
  subObjectiveOrdinal?: Maybe<CorvalSortEnumType>;
  updatedBy?: Maybe<CorvalAccountSortInput>;
  updatedById?: Maybe<CorvalSortEnumType>;
  updatedUtc?: Maybe<CorvalSortEnumType>;
};

export type CorvalStaticProjectBudgetItem = {
  businessFunction?: Maybe<CorvalBusinessFunction>;
  businessFunctionId: Scalars['Uuid'];
  categoryId: Scalars['Uuid'];
  categoryName: Scalars['String'];
  id: Scalars['Uuid'];
  name: Scalars['String'];
  projectVersionId: Scalars['Uuid'];
  subCategoryName: Scalars['String'];
  values: Array<CorvalStaticProjectBudgetItemValue>;
};

export type CorvalStaticProjectBudgetItemFilterInput = {
  and?: Maybe<Array<CorvalStaticProjectBudgetItemFilterInput>>;
  businessFunctionId?: Maybe<CorvalUuidOperationFilterInput>;
  categoryId?: Maybe<CorvalUuidOperationFilterInput>;
  categoryName?: Maybe<CorvalStringOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  name?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalStaticProjectBudgetItemFilterInput>>;
  projectVersionId?: Maybe<CorvalUuidOperationFilterInput>;
  subCategoryName?: Maybe<CorvalStringOperationFilterInput>;
  values?: Maybe<CorvalListFilterInputTypeOfStaticProjectBudgetItemValueFilterInput>;
};

export type CorvalStaticProjectBudgetItemSaveCommandInput = {
  budgetItems: Array<CorvalStaticProjectBudgetItemSaveItemInput>;
  projectVersionId: Scalars['Uuid'];
};

export type CorvalStaticProjectBudgetItemSaveItemInput = {
  businessFunctionId: Scalars['Uuid'];
  categoryId: Scalars['Uuid'];
  id: Scalars['Uuid'];
  name: Scalars['String'];
  subCategoryName: Scalars['String'];
  values: Array<CorvalStaticProjectBudgetItemSaveItemValueInput>;
};

export type CorvalStaticProjectBudgetItemSaveItemValueInput = {
  id: Scalars['Uuid'];
  startDate: Scalars['LocalDate'];
  value: Scalars['Int'];
};

export type CorvalStaticProjectBudgetItemValue = {
  date: Scalars['LocalDate'];
  id: Scalars['Uuid'];
  startDate: Scalars['LocalDate'];
  staticProjectBudgetItem: CorvalStaticProjectBudgetItem;
  staticProjectBudgetItemId: Scalars['Uuid'];
  value: Scalars['Int'];
};

export type CorvalStaticProjectBudgetItemValueFilterInput = {
  and?: Maybe<Array<CorvalStaticProjectBudgetItemValueFilterInput>>;
  date?: Maybe<CorvalLocalDateFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  or?: Maybe<Array<CorvalStaticProjectBudgetItemValueFilterInput>>;
  staticProjectBudgetItem?: Maybe<CorvalStaticProjectBudgetItemFilterInput>;
  staticProjectBudgetItemId?: Maybe<CorvalUuidOperationFilterInput>;
  value?: Maybe<CorvalIntOperationFilterInput>;
};

export type CorvalStaticProjectHire = {
  headcount: Scalars['Int'];
  hireDate: Scalars['LocalDate'];
  hireType: CorvalProjectVersionHireType;
  hireTypeId: Scalars['Uuid'];
  id: Scalars['Uuid'];
  isActive: Scalars['Boolean'];
  modifier: Scalars['Int'];
  note: Scalars['String'];
  projectVersionId: Scalars['Uuid'];
  projectVersionMilestone?: Maybe<CorvalProjectVersionMilestone>;
  projectVersionMilestoneId?: Maybe<Scalars['Uuid']>;
  projectVersionMilestoneOffsetMonths: Scalars['Int'];
  recommendedHireDates: Array<CorvalStaticProjectHireRecommendedHireDatesQueryResultItem>;
  salary: Scalars['Int'];
  staticProjectActivity?: Maybe<CorvalStaticProjectActivity>;
  staticProjectActivityId?: Maybe<Scalars['Uuid']>;
};

export type CorvalStaticProjectHireFilterInput = {
  and?: Maybe<Array<CorvalStaticProjectHireFilterInput>>;
  headcount?: Maybe<CorvalIntOperationFilterInput>;
  hireDate?: Maybe<CorvalLocalDateFilterInput>;
  hireTypeId?: Maybe<CorvalUuidOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  isActive?: Maybe<CorvalBooleanOperationFilterInput>;
  note?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalStaticProjectHireFilterInput>>;
  projectVersionId?: Maybe<CorvalUuidOperationFilterInput>;
  projectVersionMilestoneId?: Maybe<CorvalUuidOperationFilterInput>;
  projectVersionMilestoneOffsetMonths?: Maybe<CorvalIntOperationFilterInput>;
  staticProjectActivityId?: Maybe<CorvalUuidOperationFilterInput>;
};

export type CorvalStaticProjectHireRecommendedHireDatesQueryResultItem = {
  headcount: Scalars['Int'];
  hireDate: Scalars['LocalDate'];
  isHiringPoint: Scalars['Boolean'];
  staticProjectActivity: CorvalStaticProjectActivity;
  staticProjectActivityId: Scalars['Uuid'];
};

export type CorvalStaticProjectProfessionalFee = {
  amount: Scalars['Int'];
  date: Scalars['LocalDate'];
  description: Scalars['String'];
  id: Scalars['Uuid'];
  name: Scalars['String'];
  professionalFee: CorvalProfessionalFee;
  professionalFeeId: Scalars['Uuid'];
  projectVersionId: Scalars['Uuid'];
  resourceCode: Scalars['String'];
  staticProjectActivity?: Maybe<CorvalStaticProjectActivity>;
  staticProjectActivityId: Scalars['Uuid'];
};

export type CorvalStaticProjectProfessionalFeeFilterInput = {
  amount?: Maybe<CorvalIntOperationFilterInput>;
  and?: Maybe<Array<CorvalStaticProjectProfessionalFeeFilterInput>>;
  date?: Maybe<CorvalLocalDateFilterInput>;
  description?: Maybe<CorvalStringOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  name?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalStaticProjectProfessionalFeeFilterInput>>;
  professionalFeeId?: Maybe<CorvalUuidOperationFilterInput>;
  projectVersionId?: Maybe<CorvalUuidOperationFilterInput>;
  resourceCode?: Maybe<CorvalStringOperationFilterInput>;
  staticProjectActivity?: Maybe<CorvalStaticProjectActivityFilterInput>;
  staticProjectActivityId?: Maybe<CorvalUuidOperationFilterInput>;
};

export type CorvalStaticProjectSubObjective = {
  auditEntries: Array<CorvalAuditEntry>;
  createdBy?: Maybe<CorvalAccount>;
  createdById?: Maybe<Scalars['Uuid']>;
  createdUtc: Scalars['DateTime'];
  description: Scalars['String'];
  endTimeCalculatedUtc: Scalars['DateTime'];
  endTimeUtc: Scalars['DateTime'];
  id: Scalars['Uuid'];
  includeInMap: Scalars['Boolean'];
  name: Scalars['String'];
  notes: Scalars['String'];
  percentCompleted: Scalars['Decimal'];
  project: CorvalProject;
  projectId: Scalars['Uuid'];
  projectVersionId: Scalars['Uuid'];
  startTimeCalculatedUtc: Scalars['DateTime'];
  startTimeUtc: Scalars['DateTime'];
  staticProjectActivities: Array<CorvalStaticProjectActivity>;
  subObjective: CorvalSubObjective;
  subObjectiveId: Scalars['Uuid'];
  updatedBy?: Maybe<CorvalAccount>;
  updatedById?: Maybe<Scalars['Uuid']>;
  updatedUtc: Scalars['DateTime'];
};

export type CorvalStaticProjectSubObjectiveFilterInput = {
  and?: Maybe<Array<CorvalStaticProjectSubObjectiveFilterInput>>;
  createdBy?: Maybe<CorvalAccountFilterInput>;
  createdById?: Maybe<CorvalUuidOperationFilterInput>;
  createdUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  description?: Maybe<CorvalStringOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  name?: Maybe<CorvalStringOperationFilterInput>;
  notes?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalStaticProjectSubObjectiveFilterInput>>;
  projectVersionId?: Maybe<CorvalUuidOperationFilterInput>;
  rowVersion?: Maybe<CorvalListByteOperationFilterInput>;
  subObjectiveId?: Maybe<CorvalUuidOperationFilterInput>;
  updatedBy?: Maybe<CorvalAccountFilterInput>;
  updatedById?: Maybe<CorvalUuidOperationFilterInput>;
  updatedUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
};

export type CorvalStaticProjectSubObjectiveSortInput = {
  createdBy?: Maybe<CorvalAccountSortInput>;
  createdById?: Maybe<CorvalSortEnumType>;
  createdUtc?: Maybe<CorvalSortEnumType>;
  description?: Maybe<CorvalSortEnumType>;
  id?: Maybe<CorvalSortEnumType>;
  name?: Maybe<CorvalSortEnumType>;
  notes?: Maybe<CorvalSortEnumType>;
  projectVersionId?: Maybe<CorvalSortEnumType>;
  subObjectiveId?: Maybe<CorvalSortEnumType>;
  updatedBy?: Maybe<CorvalAccountSortInput>;
  updatedById?: Maybe<CorvalSortEnumType>;
  updatedUtc?: Maybe<CorvalSortEnumType>;
};

export type CorvalStrategicAssumptionTemplate = {
  createdBy?: Maybe<CorvalAccount>;
  createdById?: Maybe<Scalars['Uuid']>;
  createdUtc: Scalars['DateTime'];
  id: Scalars['Uuid'];
  templateString: Scalars['String'];
  updatedBy?: Maybe<CorvalAccount>;
  updatedById?: Maybe<Scalars['Uuid']>;
  updatedUtc: Scalars['DateTime'];
};

export type CorvalStrategicAssumptionTemplateUpdateCommandInput = {
  templateString: Scalars['String'];
};

export type CorvalStringOperationFilterInput = {
  and?: Maybe<Array<CorvalStringOperationFilterInput>>;
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  eq?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Maybe<Scalars['String']>>>;
  ncontains?: Maybe<Scalars['String']>;
  nendsWith?: Maybe<Scalars['String']>;
  neq?: Maybe<Scalars['String']>;
  nin?: Maybe<Array<Maybe<Scalars['String']>>>;
  nstartsWith?: Maybe<Scalars['String']>;
  or?: Maybe<Array<CorvalStringOperationFilterInput>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type CorvalSubCategory = {
  category?: Maybe<CorvalCategory>;
  categoryId: Scalars['Uuid'];
  contextOwner: CorvalContextOwner;
  contextOwnerOrganization?: Maybe<CorvalOrganization>;
  contextOwnerOrganizationId?: Maybe<Scalars['Uuid']>;
  contextOwnerProject?: Maybe<CorvalProject>;
  contextOwnerProjectId?: Maybe<Scalars['Uuid']>;
  createdBy?: Maybe<CorvalAccount>;
  createdById?: Maybe<Scalars['Uuid']>;
  createdUtc: Scalars['DateTime'];
  description: Scalars['String'];
  displayName: Scalars['String'];
  id: Scalars['Uuid'];
  name: Scalars['String'];
  ordinal: Scalars['Int'];
  refId?: Maybe<Scalars['String']>;
  refIdCode?: Maybe<Scalars['Int']>;
  updatedBy?: Maybe<CorvalAccount>;
  updatedById?: Maybe<Scalars['Uuid']>;
  updatedUtc: Scalars['DateTime'];
};


export type CorvalSubCategoryDescriptionArgs = {
  projectVersionId?: Maybe<Scalars['Uuid']>;
};


export type CorvalSubCategoryDisplayNameArgs = {
  projectVersionId?: Maybe<Scalars['Uuid']>;
};


export type CorvalSubCategoryNameArgs = {
  projectVersionId?: Maybe<Scalars['Uuid']>;
};


export type CorvalSubCategoryOrdinalArgs = {
  projectVersionId?: Maybe<Scalars['Uuid']>;
};

export type CorvalSubCategoryCreateCommandInput = {
  categoryId: Scalars['Uuid'];
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['Uuid'];
  name: Scalars['String'];
  ordinal: Scalars['Int'];
  refIdCode?: Maybe<Scalars['Int']>;
};

export type CorvalSubCategoryDeleteCommandInput = {
  id: Scalars['Uuid'];
  targetNewParentId: Scalars['Uuid'];
};

export type CorvalSubCategoryFilterInput = {
  and?: Maybe<Array<CorvalSubCategoryFilterInput>>;
  category?: Maybe<CorvalCategoryFilterInput>;
  categoryId?: Maybe<CorvalUuidOperationFilterInput>;
  contextOwner?: Maybe<CorvalContextOwnerOperationFilterInput>;
  contextOwnerOrganization?: Maybe<CorvalOrganizationFilterInput>;
  contextOwnerOrganizationId?: Maybe<CorvalUuidOperationFilterInput>;
  contextOwnerProject?: Maybe<CorvalProjectFilterInput>;
  contextOwnerProjectId?: Maybe<CorvalUuidOperationFilterInput>;
  createdBy?: Maybe<CorvalAccountFilterInput>;
  createdById?: Maybe<CorvalUuidOperationFilterInput>;
  createdUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  description?: Maybe<CorvalStringOperationFilterInput>;
  displayName?: Maybe<CorvalStringOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  name?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalSubCategoryFilterInput>>;
  ordinal?: Maybe<CorvalIntOperationFilterInput>;
  refIdCode?: Maybe<CorvalIntOperationFilterInput>;
  rowVersion?: Maybe<CorvalListByteOperationFilterInput>;
  updatedBy?: Maybe<CorvalAccountFilterInput>;
  updatedById?: Maybe<CorvalUuidOperationFilterInput>;
  updatedUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
};

export type CorvalSubCategorySortInput = {
  category?: Maybe<CorvalCategorySortInput>;
  categoryId?: Maybe<CorvalSortEnumType>;
  contextOwner?: Maybe<CorvalSortEnumType>;
  contextOwnerOrganization?: Maybe<CorvalOrganizationSortInput>;
  contextOwnerOrganizationId?: Maybe<CorvalSortEnumType>;
  contextOwnerProject?: Maybe<CorvalProjectSortInput>;
  contextOwnerProjectId?: Maybe<CorvalSortEnumType>;
  createdBy?: Maybe<CorvalAccountSortInput>;
  createdById?: Maybe<CorvalSortEnumType>;
  createdUtc?: Maybe<CorvalSortEnumType>;
  description?: Maybe<CorvalSortEnumType>;
  displayName?: Maybe<CorvalSortEnumType>;
  id?: Maybe<CorvalSortEnumType>;
  name?: Maybe<CorvalSortEnumType>;
  ordinal?: Maybe<CorvalSortEnumType>;
  refIdCode?: Maybe<CorvalSortEnumType>;
  updatedBy?: Maybe<CorvalAccountSortInput>;
  updatedById?: Maybe<CorvalSortEnumType>;
  updatedUtc?: Maybe<CorvalSortEnumType>;
};

export type CorvalSubCategoryUpdateCommandInput = {
  categoryId: Scalars['Uuid'];
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['Uuid'];
  name: Scalars['String'];
  ordinal: Scalars['Int'];
  refIdCode?: Maybe<Scalars['Int']>;
};

export type CorvalSubCategoryUpdateOrdinalsCommandInput = {
  ordinals: Array<CorvalSubCategoryUpdateOrdinalsItemInput>;
};

export type CorvalSubCategoryUpdateOrdinalsItemInput = {
  id: Scalars['Uuid'];
  ordinal: Scalars['Int'];
};

export type CorvalSubObjective = {
  activities?: Maybe<Array<Maybe<CorvalActivitySubObjective>>>;
  applicableStartYear?: Maybe<Scalars['Int']>;
  applicableStartYearIndex: Scalars['Int'];
  auditEntries?: Maybe<Array<Maybe<CorvalAuditEntry>>>;
  category: CorvalCategory;
  categoryId: Scalars['Uuid'];
  conditions?: Maybe<Array<Maybe<CorvalSubObjectiveCondition>>>;
  contextOwner: CorvalContextOwner;
  contextOwnerOrganization?: Maybe<CorvalOrganization>;
  contextOwnerOrganizationId?: Maybe<Scalars['Uuid']>;
  contextOwnerProject?: Maybe<CorvalProject>;
  contextOwnerProjectId?: Maybe<Scalars['Uuid']>;
  createdBy?: Maybe<CorvalAccount>;
  createdById?: Maybe<Scalars['Uuid']>;
  createdUtc: Scalars['DateTime'];
  description: Scalars['String'];
  displayName: Scalars['String'];
  entityLabel: Scalars['String'];
  id: Scalars['Uuid'];
  isRecommended: Scalars['Boolean'];
  matchesAnswer?: Maybe<CorvalSubObjectiveMatchResult>;
  milestoneId?: Maybe<Scalars['Uuid']>;
  name: Scalars['String'];
  objective?: Maybe<CorvalObjective>;
  objectiveId: Scalars['Uuid'];
  ordinal: Scalars['Int'];
  projectTimingMilestoneOffsetMonths: Scalars['Int'];
  refId?: Maybe<Scalars['String']>;
  refIdCode?: Maybe<Scalars['Int']>;
  rowVersion?: Maybe<Array<Scalars['Byte']>>;
  subCategory: CorvalSubCategory;
  subCategoryId: Scalars['Uuid'];
  targetIntakeQuestion?: Maybe<CorvalIntakeQuestion>;
  targetIntakeQuestionId: Scalars['Uuid'];
  updatedBy?: Maybe<CorvalAccount>;
  updatedById?: Maybe<Scalars['Uuid']>;
  updatedUtc: Scalars['DateTime'];
};


export type CorvalSubObjectiveCategoryArgs = {
  projectVersionId?: Maybe<Scalars['Uuid']>;
};


export type CorvalSubObjectiveCategoryIdArgs = {
  projectVersionId?: Maybe<Scalars['Uuid']>;
};


export type CorvalSubObjectiveDescriptionArgs = {
  projectVersionId?: Maybe<Scalars['Uuid']>;
};


export type CorvalSubObjectiveDisplayNameArgs = {
  projectVersionId?: Maybe<Scalars['Uuid']>;
};


export type CorvalSubObjectiveIsRecommendedArgs = {
  projectId: Scalars['Uuid'];
};


export type CorvalSubObjectiveMatchesAnswerArgs = {
  answerValue: Scalars['String'];
  intakeQuestionId: Scalars['Uuid'];
};


export type CorvalSubObjectiveNameArgs = {
  projectVersionId?: Maybe<Scalars['Uuid']>;
};


export type CorvalSubObjectiveOrdinalArgs = {
  projectVersionId?: Maybe<Scalars['Uuid']>;
};


export type CorvalSubObjectiveSubCategoryArgs = {
  projectVersionId?: Maybe<Scalars['Uuid']>;
};


export type CorvalSubObjectiveSubCategoryIdArgs = {
  projectVersionId?: Maybe<Scalars['Uuid']>;
};

export type CorvalSubObjectiveCategoryItemInput = {
  categoryId: Scalars['Uuid'];
  subCategoryId: Scalars['Uuid'];
  subObjectiveId: Scalars['Uuid'];
};

export type CorvalSubObjectiveCondition = {
  conditionType: CorvalConditionTypeEnum;
  id: Scalars['Uuid'];
  parentCollectionName: Scalars['String'];
  parentId: Scalars['Uuid'];
  subObjective?: Maybe<CorvalSubObjective>;
  subObjectiveId: Scalars['Uuid'];
  value: Scalars['String'];
};

export type CorvalSubObjectiveConditionCreateItemInput = {
  conditionType: CorvalConditionTypeEnum;
  id: Scalars['Uuid'];
  value: Scalars['String'];
};

export type CorvalSubObjectiveConditionFilterInput = {
  and?: Maybe<Array<CorvalSubObjectiveConditionFilterInput>>;
  conditionType?: Maybe<CorvalConditionTypeEnumOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  or?: Maybe<Array<CorvalSubObjectiveConditionFilterInput>>;
  subObjective?: Maybe<CorvalSubObjectiveFilterInput>;
  subObjectiveId?: Maybe<CorvalUuidOperationFilterInput>;
  value?: Maybe<CorvalStringOperationFilterInput>;
};

export type CorvalSubObjectiveConditionUpdateItemInput = {
  conditionType: CorvalConditionTypeEnum;
  id: Scalars['Uuid'];
  value: Scalars['String'];
};

export type CorvalSubObjectiveCreateCommandInput = {
  applicableStartYear?: Maybe<Scalars['Int']>;
  conditions: Array<CorvalSubObjectiveConditionCreateItemInput>;
  description: Scalars['String'];
  displayName: Scalars['String'];
  id: Scalars['Uuid'];
  milestoneId?: Maybe<Scalars['Uuid']>;
  name: Scalars['String'];
  objectiveId: Scalars['Uuid'];
  ordinal: Scalars['Int'];
  projectTimingMilestoneOffsetMonths: Scalars['Int'];
  refIdCode?: Maybe<Scalars['Int']>;
  subCategoryId: Scalars['Uuid'];
  targetIntakeQuestionId: Scalars['Uuid'];
};

export type CorvalSubObjectiveDeleteCommandInput = {
  id: Scalars['Uuid'];
};

export type CorvalSubObjectiveFilterInput = {
  activities?: Maybe<CorvalListFilterInputTypeOfActivitySubObjectiveFilterInput>;
  and?: Maybe<Array<CorvalSubObjectiveFilterInput>>;
  applicableStartYear?: Maybe<CorvalIntOperationFilterInput>;
  conditions?: Maybe<CorvalListFilterInputTypeOfSubObjectiveConditionFilterInput>;
  contextOwner?: Maybe<CorvalContextOwnerOperationFilterInput>;
  contextOwnerOrganization?: Maybe<CorvalOrganizationFilterInput>;
  contextOwnerOrganizationId?: Maybe<CorvalUuidOperationFilterInput>;
  contextOwnerProject?: Maybe<CorvalProjectFilterInput>;
  contextOwnerProjectId?: Maybe<CorvalUuidOperationFilterInput>;
  createdBy?: Maybe<CorvalAccountFilterInput>;
  createdById?: Maybe<CorvalUuidOperationFilterInput>;
  createdUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  description?: Maybe<CorvalStringOperationFilterInput>;
  displayName?: Maybe<CorvalStringOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  milestoneId?: Maybe<CorvalUuidOperationFilterInput>;
  name?: Maybe<CorvalStringOperationFilterInput>;
  objective?: Maybe<CorvalObjectiveFilterInput>;
  objectiveId?: Maybe<CorvalUuidOperationFilterInput>;
  or?: Maybe<Array<CorvalSubObjectiveFilterInput>>;
  ordinal?: Maybe<CorvalIntOperationFilterInput>;
  projectTimingMilestoneOffsetMonths?: Maybe<CorvalIntOperationFilterInput>;
  refIdCode?: Maybe<CorvalIntOperationFilterInput>;
  rowVersion?: Maybe<CorvalListByteOperationFilterInput>;
  subCategory?: Maybe<CorvalSubCategoryFilterInput>;
  subCategoryId?: Maybe<CorvalUuidOperationFilterInput>;
  targetIntakeQuestion?: Maybe<CorvalIntakeQuestionFilterInput>;
  targetIntakeQuestionId?: Maybe<CorvalUuidOperationFilterInput>;
  updatedBy?: Maybe<CorvalAccountFilterInput>;
  updatedById?: Maybe<CorvalUuidOperationFilterInput>;
  updatedUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
};

export type CorvalSubObjectiveMatchResult = {
  description: Scalars['String'];
  subObjective: CorvalSubObjective;
  triggeringCondition?: Maybe<CorvalSubObjectiveCondition>;
};

export type CorvalSubObjectiveSearchQueryInput = {
  categoryId?: Maybe<Scalars['Uuid']>;
  projectId?: Maybe<Scalars['Uuid']>;
};

export type CorvalSubObjectivesForAnswersQueryInput = {
  answers: Array<CorvalIntakeQuestionAnswerValueInput>;
};

export type CorvalSubObjectivesForAnswersQueryResponse = {
  results: Array<CorvalSubObjectiveMatchResult>;
};

export type CorvalSubObjectiveSortInput = {
  applicableStartYear?: Maybe<CorvalSortEnumType>;
  contextOwner?: Maybe<CorvalSortEnumType>;
  contextOwnerOrganization?: Maybe<CorvalOrganizationSortInput>;
  contextOwnerOrganizationId?: Maybe<CorvalSortEnumType>;
  contextOwnerProject?: Maybe<CorvalProjectSortInput>;
  contextOwnerProjectId?: Maybe<CorvalSortEnumType>;
  createdBy?: Maybe<CorvalAccountSortInput>;
  createdById?: Maybe<CorvalSortEnumType>;
  createdUtc?: Maybe<CorvalSortEnumType>;
  description?: Maybe<CorvalSortEnumType>;
  displayName?: Maybe<CorvalSortEnumType>;
  id?: Maybe<CorvalSortEnumType>;
  milestoneId?: Maybe<CorvalSortEnumType>;
  name?: Maybe<CorvalSortEnumType>;
  objective?: Maybe<CorvalObjectiveSortInput>;
  objectiveId?: Maybe<CorvalSortEnumType>;
  ordinal?: Maybe<CorvalSortEnumType>;
  projectTimingMilestoneOffsetMonths?: Maybe<CorvalSortEnumType>;
  refIdCode?: Maybe<CorvalSortEnumType>;
  subCategory?: Maybe<CorvalSubCategorySortInput>;
  subCategoryId?: Maybe<CorvalSortEnumType>;
  targetIntakeQuestion?: Maybe<CorvalIntakeQuestionSortInput>;
  targetIntakeQuestionId?: Maybe<CorvalSortEnumType>;
  updatedBy?: Maybe<CorvalAccountSortInput>;
  updatedById?: Maybe<CorvalSortEnumType>;
  updatedUtc?: Maybe<CorvalSortEnumType>;
};

export type CorvalSubObjectiveUpdateCommandInput = {
  applicableStartYear?: Maybe<Scalars['Int']>;
  conditions: Array<CorvalSubObjectiveConditionUpdateItemInput>;
  description: Scalars['String'];
  displayName: Scalars['String'];
  id: Scalars['Uuid'];
  milestoneId?: Maybe<Scalars['Uuid']>;
  name: Scalars['String'];
  objectiveId: Scalars['Uuid'];
  ordinal: Scalars['Int'];
  projectTimingMilestoneOffsetMonths: Scalars['Int'];
  refIdCode?: Maybe<Scalars['Int']>;
  subCategoryId: Scalars['Uuid'];
  targetIntakeQuestionId: Scalars['Uuid'];
};

export type CorvalSubObjectiveUpdateOrdinalsCommandInput = {
  ordinals: Array<CorvalSubObjectiveUpdateOrdinalsItemInput>;
};

export type CorvalSubObjectiveUpdateOrdinalsItemInput = {
  id: Scalars['Uuid'];
  ordinal: Scalars['Int'];
};

export enum CorvalSubscriptionType {
  Freeunlimited = 'FREEUNLIMITED'
}

export type CorvalSubscriptionTypeOperationFilterInput = {
  eq?: Maybe<CorvalSubscriptionType>;
  in?: Maybe<Array<CorvalSubscriptionType>>;
  neq?: Maybe<CorvalSubscriptionType>;
  nin?: Maybe<Array<CorvalSubscriptionType>>;
};

export enum CorvalSystemRole {
  Accountsadmin = 'ACCOUNTSADMIN',
  Corvaladmin = 'CORVALADMIN',
  Decisionengineadmin = 'DECISIONENGINEADMIN',
  Member = 'MEMBER'
}

export type CorvalSystemRoleOperationFilterInput = {
  eq?: Maybe<CorvalSystemRole>;
  in?: Maybe<Array<CorvalSystemRole>>;
  neq?: Maybe<CorvalSystemRole>;
  nin?: Maybe<Array<CorvalSystemRole>>;
};

export type CorvalTag = {
  name: Scalars['String'];
};

export type CorvalTagFilterInput = {
  and?: Maybe<Array<CorvalTagFilterInput>>;
  name?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalTagFilterInput>>;
};

export type CorvalTagSortInput = {
  name?: Maybe<CorvalSortEnumType>;
};

export type CorvalTemplateProjectMemberItemInput = {
  accountId: Scalars['Uuid'];
  projectRole: CorvalProjectRole;
};

export type CorvalTermDictionary = {
  projectMilestones?: Maybe<CorvalTermDictionaryProjectMilestones>;
  timelineDetails?: Maybe<CorvalTermDictionaryTimelineDetails>;
};

export type CorvalTermDictionaryItem = {
  description?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

export type CorvalTermDictionaryProjectMilestones = {
  commercializationStart?: Maybe<CorvalTermDictionaryItem>;
  investigationalNewDrugApplicationFiling?: Maybe<CorvalTermDictionaryItem>;
  launchDate?: Maybe<CorvalTermDictionaryItem>;
  ndaApproval?: Maybe<CorvalTermDictionaryItem>;
  ndaSubmission?: Maybe<CorvalTermDictionaryItem>;
  phase2TrialData?: Maybe<CorvalTermDictionaryItem>;
  phase2TrialStart?: Maybe<CorvalTermDictionaryItem>;
  phase3TrialData?: Maybe<CorvalTermDictionaryItem>;
  phase3TrialStart?: Maybe<CorvalTermDictionaryItem>;
};

export type CorvalTermDictionaryTimelineDetails = {
  ndaProcessTimeframe?: Maybe<CorvalTermDictionaryItem>;
  phase2TrialsProcessTimeframe?: Maybe<CorvalTermDictionaryItem>;
  phase3TrialsProcessTimeframe?: Maybe<CorvalTermDictionaryItem>;
};

export type CorvalTimeSpanCondition = {
  activity?: Maybe<CorvalActivity>;
  activityId: Scalars['Uuid'];
  answerValue: Scalars['String'];
  conditionType: CorvalConditionTypeEnum;
  id: Scalars['Uuid'];
  targetIntakeQuestion?: Maybe<CorvalIntakeQuestion>;
  targetIntakeQuestionId: Scalars['Uuid'];
  timeSpanUnit: CorvalTimeSpanUnit;
  timeSpanValue: Scalars['Int'];
};

export type CorvalTimeSpanConditionFilterInput = {
  activity?: Maybe<CorvalActivityFilterInput>;
  activityId?: Maybe<CorvalUuidOperationFilterInput>;
  and?: Maybe<Array<CorvalTimeSpanConditionFilterInput>>;
  answerValue?: Maybe<CorvalStringOperationFilterInput>;
  conditionType?: Maybe<CorvalConditionTypeEnumOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  or?: Maybe<Array<CorvalTimeSpanConditionFilterInput>>;
  targetIntakeQuestion?: Maybe<CorvalIntakeQuestionFilterInput>;
  targetIntakeQuestionId?: Maybe<CorvalUuidOperationFilterInput>;
  timeSpanUnit?: Maybe<CorvalTimeSpanUnitOperationFilterInput>;
  timeSpanValue?: Maybe<CorvalIntOperationFilterInput>;
};

export enum CorvalTimeSpanUnit {
  Days = 'DAYS',
  Months = 'MONTHS',
  Weeks = 'WEEKS'
}

export type CorvalTimeSpanUnitOperationFilterInput = {
  eq?: Maybe<CorvalTimeSpanUnit>;
  in?: Maybe<Array<CorvalTimeSpanUnit>>;
  neq?: Maybe<CorvalTimeSpanUnit>;
  nin?: Maybe<Array<CorvalTimeSpanUnit>>;
};

export type CorvalUpdateActivityItemInput = {
  businessFunctionId?: Maybe<Scalars['Uuid']>;
  categoryDescription?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['Uuid']>;
  categoryName?: Maybe<Scalars['String']>;
  categoryOrdinal?: Maybe<Scalars['Int']>;
  constraintDate?: Maybe<Scalars['LocalDate']>;
  constraintType?: Maybe<CorvalConstraintType>;
  criticality?: Maybe<CorvalCriticality>;
  deadlineDate?: Maybe<Scalars['LocalDate']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Float']>;
  endDate?: Maybe<Scalars['LocalDate']>;
  id: Scalars['Uuid'];
  isAtRisk?: Maybe<Scalars['Boolean']>;
  manuallyScheduled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  ongoingCostNote?: Maybe<Scalars['String']>;
  ongoingCostPerQuarter?: Maybe<Scalars['Int']>;
  ongoingCostQuarters?: Maybe<Scalars['Int']>;
  operationalCost?: Maybe<Scalars['Int']>;
  operationalCostNote?: Maybe<Scalars['String']>;
  operationalCostReplacesProfessionalFees?: Maybe<Scalars['Boolean']>;
  percentDone?: Maybe<Scalars['Int']>;
  requiredHireTypes?: Maybe<Array<CorvalRequiredHireTypeItemInput>>;
  scheduledBudgetItems?: Maybe<Array<CorvalScheduledBudgetItemInput>>;
  startDate?: Maybe<Scalars['LocalDate']>;
  subCategoryDescription?: Maybe<Scalars['String']>;
  subCategoryId?: Maybe<Scalars['Uuid']>;
  subCategoryName?: Maybe<Scalars['String']>;
  subCategoryOrdinal?: Maybe<Scalars['Int']>;
  subObjectiveDescription?: Maybe<Scalars['String']>;
  subObjectiveId?: Maybe<Scalars['Uuid']>;
  subObjectiveName?: Maybe<Scalars['String']>;
  subObjectiveOrdinal?: Maybe<Scalars['Int']>;
  watcherAccountIds?: Maybe<Array<Scalars['Uuid']>>;
};

export type CorvalUpdateCategoryItemInput = {
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['Uuid'];
  name?: Maybe<Scalars['String']>;
  ordinal?: Maybe<Scalars['Int']>;
};

export type CorvalUpdateDependencyItemInput = {
  active?: Maybe<Scalars['Boolean']>;
  from?: Maybe<Scalars['Uuid']>;
  fromSide?: Maybe<Scalars['String']>;
  id: Scalars['Uuid'];
  lag?: Maybe<Scalars['Int']>;
  lagUnit?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['Uuid']>;
  toSide?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['Int']>;
};

export type CorvalUpdateEventItemInput = {
  colorValue?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  iconName?: Maybe<Scalars['String']>;
  id: Scalars['Uuid'];
  milestoneId?: Maybe<Scalars['Uuid']>;
  name?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['LocalDate']>;
};

export type CorvalUpdateSubCategoryItemInput = {
  categoryId?: Maybe<Scalars['Uuid']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['Uuid'];
  name?: Maybe<Scalars['String']>;
  ordinal?: Maybe<Scalars['Int']>;
};

export type CorvalUpdateSubObjectiveItemInput = {
  businessFunctionId?: Maybe<Scalars['Uuid']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Uuid'];
  name?: Maybe<Scalars['String']>;
  subCategoryId?: Maybe<Scalars['Uuid']>;
};


export type CorvalUuidOperationFilterInput = {
  eq?: Maybe<Scalars['Uuid']>;
  gt?: Maybe<Scalars['Uuid']>;
  gte?: Maybe<Scalars['Uuid']>;
  in?: Maybe<Array<Maybe<Scalars['Uuid']>>>;
  lt?: Maybe<Scalars['Uuid']>;
  lte?: Maybe<Scalars['Uuid']>;
  neq?: Maybe<Scalars['Uuid']>;
  ngt?: Maybe<Scalars['Uuid']>;
  ngte?: Maybe<Scalars['Uuid']>;
  nin?: Maybe<Array<Maybe<Scalars['Uuid']>>>;
  nlt?: Maybe<Scalars['Uuid']>;
  nlte?: Maybe<Scalars['Uuid']>;
};

export enum CorvalValueTypeEnum {
  Number = 'NUMBER',
  Text = 'TEXT'
}

export type CorvalValueTypeEnumOperationFilterInput = {
  eq?: Maybe<CorvalValueTypeEnum>;
  in?: Maybe<Array<CorvalValueTypeEnum>>;
  neq?: Maybe<CorvalValueTypeEnum>;
  nin?: Maybe<Array<CorvalValueTypeEnum>>;
};

export enum CorvalWorkflowActionStatus {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE'
}

export type CorvalWorkflowActionStatusOperationFilterInput = {
  eq?: Maybe<CorvalWorkflowActionStatus>;
  in?: Maybe<Array<CorvalWorkflowActionStatus>>;
  neq?: Maybe<CorvalWorkflowActionStatus>;
  nin?: Maybe<Array<CorvalWorkflowActionStatus>>;
};

export enum CorvalWorkflowActionType {
  None = 'NONE',
  Reviewactivitymap = 'REVIEWACTIVITYMAP',
  Reviewbudgetsummary = 'REVIEWBUDGETSUMMARY',
  Reviewinitialinquiry = 'REVIEWINITIALINQUIRY',
  Reviewobjectives = 'REVIEWOBJECTIVES',
  Reviewresourcesummary = 'REVIEWRESOURCESUMMARY',
  Reviewroadmap = 'REVIEWROADMAP',
  Reviewstrategicinputs = 'REVIEWSTRATEGICINPUTS',
  Reviewtimeline = 'REVIEWTIMELINE'
}

export type CorvalWorkflowActionTypeOperationFilterInput = {
  eq?: Maybe<CorvalWorkflowActionType>;
  in?: Maybe<Array<CorvalWorkflowActionType>>;
  neq?: Maybe<CorvalWorkflowActionType>;
  nin?: Maybe<Array<CorvalWorkflowActionType>>;
};

export enum CorvalWorkflowContextType {
  Incrementalplanning = 'INCREMENTALPLANNING',
  Onboarding = 'ONBOARDING',
  Projectmodifications = 'PROJECTMODIFICATIONS'
}

export type CorvalWorkflowContextTypeOperationFilterInput = {
  eq?: Maybe<CorvalWorkflowContextType>;
  in?: Maybe<Array<CorvalWorkflowContextType>>;
  neq?: Maybe<CorvalWorkflowContextType>;
  nin?: Maybe<Array<CorvalWorkflowContextType>>;
};

export type CorvalWorkflowTask = {
  createdBy?: Maybe<CorvalAccount>;
  createdById?: Maybe<Scalars['Uuid']>;
  createdUtc: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['Uuid'];
  name: Scalars['String'];
  ordinal: Scalars['Int'];
  subCategory?: Maybe<CorvalSubCategory>;
  updatedBy?: Maybe<CorvalAccount>;
  updatedById?: Maybe<Scalars['Uuid']>;
  updatedUtc: Scalars['DateTime'];
  workflowActionType: CorvalWorkflowActionType;
  workflowContextType: CorvalWorkflowContextType;
};

export type CorvalWorkflowTaskFilterInput = {
  and?: Maybe<Array<CorvalWorkflowTaskFilterInput>>;
  createdBy?: Maybe<CorvalAccountFilterInput>;
  createdById?: Maybe<CorvalUuidOperationFilterInput>;
  createdUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  description?: Maybe<CorvalStringOperationFilterInput>;
  id?: Maybe<CorvalUuidOperationFilterInput>;
  name?: Maybe<CorvalStringOperationFilterInput>;
  or?: Maybe<Array<CorvalWorkflowTaskFilterInput>>;
  ordinal?: Maybe<CorvalIntOperationFilterInput>;
  rowVersion?: Maybe<CorvalListByteOperationFilterInput>;
  updatedBy?: Maybe<CorvalAccountFilterInput>;
  updatedById?: Maybe<CorvalUuidOperationFilterInput>;
  updatedUtc?: Maybe<CorvalDateTimeOperationFilterInput>;
  workflowActionType?: Maybe<CorvalWorkflowActionTypeOperationFilterInput>;
  workflowContextType?: Maybe<CorvalWorkflowContextTypeOperationFilterInput>;
};

export type CorvalWorkflowTaskSortInput = {
  createdBy?: Maybe<CorvalAccountSortInput>;
  createdById?: Maybe<CorvalSortEnumType>;
  createdUtc?: Maybe<CorvalSortEnumType>;
  description?: Maybe<CorvalSortEnumType>;
  id?: Maybe<CorvalSortEnumType>;
  name?: Maybe<CorvalSortEnumType>;
  ordinal?: Maybe<CorvalSortEnumType>;
  updatedBy?: Maybe<CorvalAccountSortInput>;
  updatedById?: Maybe<CorvalSortEnumType>;
  updatedUtc?: Maybe<CorvalSortEnumType>;
  workflowActionType?: Maybe<CorvalSortEnumType>;
  workflowContextType?: Maybe<CorvalSortEnumType>;
};


      export interface IntrospectionResultData {
        __schema: {
          types: {
            kind: string;
            name: string;
            possibleTypes: {
              name: string;
            }[];
          }[];
        };
      }
      const result: IntrospectionResultData = {
  "__schema": {
    "types": [
      {
        "kind": "UNION",
        "name": "StaticCostOccurrenceFeeItemDataType",
        "possibleTypes": [
          {
            "name": "StaticProjectActivity"
          },
          {
            "name": "StaticProjectBudgetItem"
          }
        ]
      }
    ]
  }
};
      export default result;
    